import DragIndicatorIcon from '@mui/icons-material/DragIndicator'
import VideocamIcon from '@mui/icons-material/Videocam'
import VideocamOffIcon from '@mui/icons-material/VideocamOff'
import MicIcon from '@mui/icons-material/Mic'
import MicOffIcon from '@mui/icons-material/MicOff'
import VolumeUpIcon from '@mui/icons-material/VolumeUp'
import SignalWifiOffIcon from '@mui/icons-material/SignalWifiOff'
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner'
import LoginIcon from '@mui/icons-material/Login'
import LayersClearIcon from '@mui/icons-material/LayersClear'
import ReplayIcon from '@mui/icons-material/Replay'
import RefreshIcon from '@mui/icons-material/Refresh'
import AddRoundedIcon from '@mui/icons-material/AddRounded'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import SearchIcon from '@mui/icons-material/Search'
import PreviewIcon from '@mui/icons-material/Preview'
import HistoryIcon from '@mui/icons-material/History'
import SettingsIcon from '@mui/icons-material/Settings'
import MedicationIcon from '@mui/icons-material/Medication'
import CloseIcon from '@mui/icons-material/Close'
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline'
import ScreenRotationIcon from '@mui/icons-material/ScreenRotation'
import OpenInFullIcon from '@mui/icons-material/OpenInFull'
import ArticleIcon from '@mui/icons-material/Article'
import PrintIcon from '@mui/icons-material/Print'
import DownloadIcon from '@mui/icons-material/Download'
import SendIcon from '@mui/icons-material/Send'
import MenuRoundedIcon from '@mui/icons-material/MenuRounded'
import CollectionsIcon from '@mui/icons-material/Collections'
import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded'
import VideocamRoundedIcon from '@mui/icons-material/VideocamRounded'
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded'
import { Box, IconButton, Select, MenuItem, FormControl, Typography, Paper, Tooltip, Avatar, Drawer, SwipeableDrawer, Button, ListItemIcon, ListItemText, CircularProgress, Menu, Popover, Dialog, DialogTitle, DialogContent, DialogActions, Divider } from '@mui/material'
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong'
import AssignmentIcon from '@mui/icons-material/Assignment'
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart'
import PsychologyIcon from '@mui/icons-material/Psychology'
import AssessmentIcon from '@mui/icons-material/Assessment'
import { getAndSetCameras, getAndSetMicrophones, getAndSetSpeakers } from 'src/consumer/components/LiveSessionPage/LiveSessionPageComponents'
import { getSelectedCameraInLocalStorage, getSelectedMicrophoneInLocalStorage, getSelectedSpeakerInLocalStorage } from 'src/consumer/services/localstorageServices'
import AgoraRTC from 'agora-rtc-sdk-ng'
import React, { useCallback, useContext, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import { flushSync } from 'react-dom'
import { Spinner } from 'react-bootstrap'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import dayjs from 'dayjs'
import dayjsUtc from 'dayjs/plugin/utc'
import { getTimezoneOffset } from 'src/consumer/helpers/utilFunctions'
import { getAgeFromDobWithTime } from 'src/consumer/helpers/profilePageHelper'
import { fetchAndProcessBookedSlots } from 'src/clinic/components/ClinicManageBookingsPage/utils'
import {
  AGORA_RTC_LAYOUTS,
  RTC_PROVIDERS,
  buildChamberShellSnapshot,
  createBookedEventLocalParticipantIdentity,
  createMentorChamberLocalParticipantIdentity,
  decorateSessionWithRouting,
  FLOW_TYPES,
  preloadAgoraRtcUIKitModule,
  readLocalParticipantIdentity,
  readSessionInterfaceId,
  resolveSessionRoutingContext,
  useRtcSessionShell,
} from 'src/live'
import { CheckoutButtonComponent } from 'src/clinic/components/CheckIn/checkInComponents'
import {
  setEmrChamberAutoConnectPause,
  setEmrVideoCallActivity,
} from 'src/clinic/components/CheckIn/checkInZoneRoutes'
import {
  logAutoConnectPaused,
  logAutoConnectResumed,
} from 'src/clinic/components/CheckIn/services'
import DayViewCalendarComponent from 'src/clinic/components/ClinicManageBookingsPage/DayViewCalendarComponent'
import BookedSlotsDrawer from 'src/clinic/components/ClinicManageBookingsPage/components/BookedSlotsDrawer'
import PatientSearchDrawer from 'src/mentor/components/MentorClinicBookingsPage/component/PatientSearchDrawer'
import SplitScreenHeader from './components/SplitScreenHeader'
import NotificationPanel, { showNotification } from './components/NotificationPanel'
import {
  clearPortalVoiceLauncherContext,
  publishPortalVoiceLauncherContext,
} from 'src/mentor/components/voice/portalVoiceLauncherContext'
import DebugPanel from './components/DebugPanel'
import './VideoCallButtons.css' // Enhanced video call controls v2.1
import { getCPDataWithParams, putCPDataWithoutParams } from 'src/clinic/services'
import BaseUITabsComponent from 'src/common/tabs/BaseUITabs'
import {
  HotlineChamberInteractionPart,
  HotlineSectionSeparator,
} from 'src/consumer/components/HotlineChamberPage/HotlineChamberStyles'
import {
  LSPastPrescriptionsComponent,
} from 'src/consumer/components/LiveSessionPage/LiveSessionPageComponents'
import {
  allAvailableEventTypes,
  BOOKING_SESSION_STATUS,
  CHAMBER_SCREEN_ACTIONS,
  CHAMBER_SCREEN_STATES,
  STATUS_SESSION_CANCELLED,
  BOOKING_STATUSES,
  BOOKING_PAYMENT_STATUSES,
} from 'src/consumer/constants'
import {
  askCheckedInChamberScreenToPollNextAction,
  checkChamberScreenStatus,
  getDataWithoutParams,
  markBookedEventLog,
  sendShowImageCommandToChamberScreen,
  getAgoraToken,
  sendReloadChamberRoomScreenSignal,
} from 'src/consumer/services/featureServices'
import { getDataWithParams } from 'src/consumer/services/profileService'
import { useCheckedInOnlyChamberRoomId, useCheckedInOrPeekedInChamberRoomId } from 'src/customHooks/customHooks'
import AssessmentReportMakingPage from 'src/mentor/components/AssessmentReport/AssessmentReportMakingPage'
import PractitionerAssessmentDrawer from 'src/mentor/components/PractitionerAssessment/PractitionerAssessmentDrawer'
import {
  MENTOR_CLINIC_BOOKING_TABS,
} from 'src/mentor/components/MentorClinicBookingsPage/util'
import ChamberScreenSignallingActions from 'src/mentor/components/MentorClinicSomeChamberAutoJoiningPage/components/ChamberScreenSignallingActions'
import { ChamberScreenSignallingSnackBarContext } from 'src/mentor/components/MentorClinicSomeChamberAutoJoiningPage/components/ChamberScreenSignallingSnackBarProvider'
import LeaveButton from 'src/mentor/components/MentorClinicSomeChamberAutoJoiningPage/components/LeaveButton'
import ChamberRoomStatusIndicator from 'src/mentor/components/MentorClinicSomeChamberAutoJoiningPage/components/ChamberRoomStatusIndicator'
import ScreeningSectionsProvider from 'src/mentor/components/PrescriptionMakingPage/context/ScreeningSectionsProvider'
import { MentorProfileContext } from 'src/mentor/context/MentorProfileContext'
import { DocSideContext } from 'src/context/DocSideContextProvider'
import {
  isCommonResponseSuccessful,
  markBookedSessionAsCompletedFunction,
  sleep,
} from 'src/mentor/helpers/utilityFunctions'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import { buildMentorRtmUsername } from './utils/rtmUsernameBuilder'
import PrescriptionMakingPage from '../PrescriptionMakingPage'
import PrescriptionDataProvider from '../PrescriptionMakingPage/context/PrescriptionDataProvider'
import ScreeningReportMakingPage from '../ScreeningReportMakingPage'
import TherapyReportMakingPage from '../TherapyReportMakingPage'
import { getTherapyReportShortLabelFromEntity } from '../TherapyReportMakingPage/therapyReportLabels'
import VitalsListingPage from '../VitalsListingPage'
import LSPastVisitReportsComponent from 'src/consumer/components/LiveSessionPage/components/LSPastVisitReportsComponent/LSPastVisitReportsComponent'
import { getPastPatientReports } from 'src/reducers/emr/services/pastPatientReports'
import store from 'src/store'
import { FLOW_STATUSES_FOR_LEAVING_SESSION } from 'src/consumer/components/LiveSessionPage/utils/sessionNavigationUtils'
import RXDrawerComponent from 'src/consumer/components/LiveSessionPage/components/RXDrawerComponent/RXDrawerComponent'
import ReportPreviewComponent from 'src/consumer/components/LiveSessionPage/components/ReportPreviewComponent/ReportPreviewComponent'
import MentorChamberAgoraVideoSurface from 'src/live/shell/components/MentorChamberAgoraVideoSurface'

dayjs.extend(dayjsUtc)

const MENTOR_SPLIT_HEADER_OFFSET_PX = 44

// Picture-in-picture video tile dimensions (mobile, while the EMR sheet is open). Portrait by
// default; switches to a 16:9 landscape tile when the incoming video is landscape.
const PIP_WIDTH = 118
const PIP_HEIGHT = 158
const PIP_WIDTH_LANDSCAPE = 192
const PIP_HEIGHT_LANDSCAPE = 108
const PIP_EDGE_MARGIN = 8

// Shared styles for the bottom-right mobile control dock (label chip + round button).
const CHAMBER_DOCK_LABEL_SX = {
  fontSize: '11px',
  fontWeight: 600,
  color: '#fff',
  px: 1,
  py: 0.25,
  borderRadius: '999px',
  background: 'rgba(15, 15, 18, 0.62)',
  backdropFilter: 'blur(8px)',
  WebkitBackdropFilter: 'blur(8px)',
  whiteSpace: 'nowrap',
  boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
}
const CHAMBER_DOCK_FAB_SX = {
  width: 46,
  height: 46,
  color: '#fff',
  background: 'rgba(15, 15, 18, 0.62)',
  backdropFilter: 'blur(12px) saturate(180%)',
  WebkitBackdropFilter: 'blur(12px) saturate(180%)',
  border: '1px solid rgba(255,255,255,0.22)',
  boxShadow: '0 6px 18px rgba(0,0,0,0.35)',
  '&:hover': { background: 'rgba(15,15,18,0.78)' },
}

// Icon + short initial for the section tab strip (mirrors the /l/* live-session tabs). On mobile we
// show the icon + initial; on desktop the icon + full label.
const CHAMBER_TAB_META = {
  prescription: { icon: MedicationIcon, initial: 'Rx' },
  patient_history: { icon: HistoryIcon, initial: 'H' },
  vitals: { icon: MonitorHeartIcon, initial: 'V' },
  assessments: { icon: AssignmentIcon, initial: 'Assess' },
  therapy_report: { icon: PsychologyIcon, initial: 'T' },
  assessment_report: { icon: AssessmentIcon, initial: 'A' },
  screening_report: { icon: ArticleIcon, initial: 'S' },
}

// Single-letter gender for the "34/M" age-gender tag on appointment cards.
const GENDER_SHORT_LABELS = { male: 'M', female: 'F', nonBinary: 'NB' }

// Short, human labels for the mobile appointment cards.
const APPOINTMENT_TYPE_LABELS = {
  [allAvailableEventTypes.consultation]: 'Consultation',
  [allAvailableEventTypes.therapySession]: 'Therapy',
  [allAvailableEventTypes.screening]: 'Screening',
  [allAvailableEventTypes.assessment]: 'Assessment',
  [allAvailableEventTypes.nutritionConsultation]: 'Nutrition',
}

// "in 3 days" / "2 days ago" / Today / Tomorrow / Yesterday for the appointments date tab.
function relativeDayLabel(ddmmyyyy) {
  const day = dayjs(ddmmyyyy, 'DD-MM-YYYY').startOf('day')
  if (!day.isValid()) return ''
  const diff = day.diff(dayjs().startOf('day'), 'day')
  if (diff === 0) return 'Today'
  if (diff === 1) return 'Tomorrow'
  if (diff === -1) return 'Yesterday'
  return diff > 0 ? `in ${diff} days` : `${Math.abs(diff)} days ago`
}

const CALENDAR_EVENT_SCOPES = Object.freeze({
  own: 'own',
  consultations: 'consultations',
  both: 'both',
})
const AUTO_CONNECT_PAUSE_OPTIONS = Object.freeze([
  { value: 1 * 60 * 1000, label: '1 min' },
  { value: 3 * 60 * 1000, label: '3 min' },
  { value: 5 * 60 * 1000, label: '5 min' },
  { value: 10 * 60 * 1000, label: '10 min' },
  { value: 15 * 60 * 1000, label: '15 min' },
  { value: 30 * 60 * 1000, label: '30 min' },
])
const AUTO_CONNECT_INACTIVITY_PAUSE_MS = 3 * 60 * 1000
const AUDIO_PREVIEW_BAR_COUNT = 12
const AUDIO_PREVIEW_IDLE_LEVELS = Object.freeze(
  Array.from({ length: AUDIO_PREVIEW_BAR_COUNT }, (_, index) =>
    index % 3 === 1 ? 20 : 10,
  ),
)
const REPORT_EVENT_TYPE_ALIASES = Object.freeze({
  [allAvailableEventTypes.consultation]: ['consultation', 'prescription'],
  [allAvailableEventTypes.therapySession]: ['therapy-session', 'therapy', 'therapy-report'],
  // Nutrition consultations resolve to the therapy-report report type server-side (they
  // co-occupy that report's editing-event-types list). Alias both labels so report-type lookups
  // succeed regardless of which key the caller used.
  [allAvailableEventTypes.nutritionConsultation]: [
    'nutrition-consultation',
    'therapy-report',
    'diet-plan',
  ],
  [allAvailableEventTypes.screening]: ['screening', 'screening-report'],
  [allAvailableEventTypes.assessment]: ['assessment', 'assessment-report'],
})

function formatAutoConnectRemaining(remainingMs) {
  const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000))
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  if (minutes <= 0) {
    return `${seconds}s`
  }

  return `${minutes}:${String(seconds).padStart(2, '0')}`
}

function buildAudioPreviewBars(dataArray, barCount = AUDIO_PREVIEW_BAR_COUNT) {
  if (!dataArray || dataArray.length === 0 || barCount <= 0) {
    return [...AUDIO_PREVIEW_IDLE_LEVELS]
  }

  const bucketSize = Math.max(1, Math.floor(dataArray.length / barCount))

  return Array.from({ length: barCount }, (_, index) => {
    const start = index * bucketSize
    const end = Math.min(dataArray.length, start + bucketSize)
    const slice = dataArray.slice(start, end)
    const average =
      slice.length > 0 ? slice.reduce((sum, value) => sum + value, 0) / slice.length : 0

    return Math.max(8, Math.min(100, Math.round((average / 255) * 100)))
  })
}

function normalizeEventTypeCandidate(value) {
  return typeof value === 'string' ? value.trim().toLowerCase() : ''
}

function resolveBookedEventPatientId(bookedEvent) {
  return (
    bookedEvent?.patientId ||
    bookedEvent?.patientInfo?.id ||
    bookedEvent?.patientInfoData?.id ||
    bookedEvent?.patientInfo?.patientId ||
    bookedEvent?.patientInfoData?.patientId ||
    null
  )
}

function resolveBookedEventReportType(bookedEvent, auxiliaryDataFromApi = null) {
  const rawCandidates = [
    bookedEvent?.eventType,
    bookedEvent?.type,
    bookedEvent?.eventTypeSlug,
    bookedEvent?.eventTypeData?.type,
    bookedEvent?.eventTypeData?.eventType,
    bookedEvent?.eventTypeData?.slug,
    auxiliaryDataFromApi?.eventType,
    auxiliaryDataFromApi?.eventTypeSlug,
    auxiliaryDataFromApi?.consultationDetails?.eventType,
    auxiliaryDataFromApi?.consultationDetails?.type,
  ]
    .map(normalizeEventTypeCandidate)
    .filter(Boolean)

  for (const [canonicalEventType, aliases] of Object.entries(REPORT_EVENT_TYPE_ALIASES)) {
    if (rawCandidates.some((candidate) => aliases.includes(candidate))) {
      return canonicalEventType
    }
  }

  return bookedEvent?.eventType
}

function readCheckedInRoomContext() {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    const raw = localStorage.getItem('checkedInDetails')
    if (!raw) {
      return null
    }

    const parsed = JSON.parse(raw)
    if (!parsed?.chamberRoomId || !parsed?.clinicLocationId || !parsed?.clinicBrandId) {
      return null
    }

    return parsed
  } catch (error) {
    console.error('[MentorClinicSomeChamberAutoJoiningPage] Failed to read checked-in room context', error)
    return null
  }
}

// 3-dot menu component for Screening Report actions

export default function MentorClinicSomeChamberAutoJoiningPage() {
  const { clinicId, clinicBrandId, sessionSlug } = useParams()
  const { mentorClinicAssociationData } = useContext(MentorProfileContext)

  // wakelock - Only request when page is visible
  useEffect(() => {
    let wakeLock = null

    const requestWakeLock = async () => {
      // Check if page is visible before requesting wake lock
      if (document.hidden || !document.visibilityState || document.visibilityState === 'hidden') {
        return
      }

      // Check if WakeLock API is available
      if (!('wakeLock' in navigator)) {
        return
      }

      try {
        wakeLock = await navigator.wakeLock.request('screen')

        // Optionally handle the wake lock release
        wakeLock.addEventListener('release', () => {
          // Wake lock released
        })
      } catch (err) {
        // Silently handle errors (e.g., page not visible, user denied, etc.)
        if (err.name !== 'NotAllowedError') {
        console.error(`${err.name}: ${err.message}`)
        }
      }
    }

    // Request wake lock when page becomes visible
    const handleVisibilityChange = () => {
      if (!document.hidden && document.visibilityState === 'visible') {
    requestWakeLock()
      } else if (wakeLock) {
        // Release wake lock when page becomes hidden
        wakeLock.release().catch(() => {})
        wakeLock = null
      }
    }

    // Initial request if page is visible
    if (!document.hidden) {
      requestWakeLock()
    }

    // Listen for visibility changes
    document.addEventListener('visibilitychange', handleVisibilityChange)

    // Clean up on component unmount
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      if (wakeLock) {
        wakeLock.release().then(() => {
          // Wake lock released
        }).catch(() => {})
      }
    }
  }, [])

  const showPredecidedUIComponent =
    clinicId && mentorClinicAssociationData?.find((item) => item?.id === clinicId)

  useEffect(() => {
    const debugPayload = {
      debugVersion: 'mentor-chamber-shared-renderer-default-v1',
      componentPath: showPredecidedUIComponent ? 'predecided-clinic-chamber' : 'undecided-clinic-selector',
      clinicBrandId: clinicBrandId || null,
      clinicId: clinicId || null,
      sessionSlug: sessionSlug || null,
    }

    if (typeof window !== 'undefined') {
      window.__AUMHUM_MENTOR_CHAMBER_RTC_DEBUG__ = debugPayload
    }

    console.info('[MentorClinicSomeChamberAutoJoiningPage] Route debug', debugPayload)
  }, [clinicBrandId, clinicId, sessionSlug, showPredecidedUIComponent])

  return (
    <div
      className={
        'vh-100 vw-100 justify-content-center align-items-center' +
        (showPredecidedUIComponent ? ' d-flex' : '')
      }
    >
      {showPredecidedUIComponent ? (
        <PredecidedClinicIdUIComponent 
          clinicLocationId={clinicId}
          clinicBrandId={clinicBrandId}
          sessionSlug={sessionSlug}
        />
      ) : (
        <UndecidedClinicIdUIComponent />
      )}
    </div>
  )
}

const PredecidedClinicIdUIComponent = ({ clinicLocationId, clinicBrandId, sessionSlug }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const { showSnackBar } = useContext(ChamberScreenSignallingSnackBarContext)
  const [serverGivenNextAction, setServerGivenNextAction] = useState()
  const { mentorClinicAssociationData, mentorProfileData, portalViewSettings } = useContext(MentorProfileContext)
  const hidePatientContactDetails = Boolean(portalViewSettings?.hidePatientContactDetails)
  const { setFlowId, setButtonTopOffset, setShowDocSide } = useContext(DocSideContext)
  const chosenClinicData = mentorClinicAssociationData?.find(
    (item) => item?.id === clinicLocationId,
  )

  // const [anchorElForMenu, setAnchorElForMenu] = useState(null)
  // const menuOpen = Boolean(anchorElForMenu)
  // const handleClickMenuOpener = (event) => {
  //   setAnchorElForMenu(event.currentTarget)
  // }
  // const handleCloseMenu = () => {
  //   setAnchorElForMenu(null)
  // }

  // serverGivenNextAction?.channel?.chamberRoomId

  const [chamberScreenStateNow, setChamberScreenStateNow] = useState(CHAMBER_SCREEN_STATES.IDLING)
  const [joinedChamberName, setJoinedChamberName] = useState('')
  const [joinedChannelName, setJoinedChannelName] = useState('')
  const [agoraRtcProps, setAgoraRtcProps] = useState({})
  const [agoraRtmProps, setAgoraRtmProps] = useState({})
  
  // Store original chamber room channel to reconnect after booked event session
  const [originalChamberRoomChannel, setOriginalChamberRoomChannel] = useState(null)
  const [isInBookedEventSession, setIsInBookedEventSession] = useState(false)

  // interaction menu related:
  const [triggerSave, setTriggerSave] = useState()
  const [newWantedMenuItemId, setNewWantedMenuItemId] = useState()
  const [patientMenuOptions, setPatientMenuOptions] = useState([])
  const [selectedOptionPatientMenu, setSelectedOptionPatientMenu] = useState()
  const [patientBookedSlotDetailsLoading, setPatientBookedSlotDetailsLoading] = useState(false)
  const [patientSelected, setPatientSelected] = useState(false)
  // Live mirror of patientSelected so the debounced/setTimeout signalling handlers can read the
  // current value from their (stale) closures — used to stop the chamber's periodic "continue-idling"
  // next-action from tearing down an active patient consult.
  const patientSelectedRef = useRef(patientSelected)
  useEffect(() => {
    patientSelectedRef.current = patientSelected
  }, [patientSelected])
  const [selectedPatientBookedEventId, setSelectedPatientBookedEventId] = useState()
  const [selectedPatientBookedEventData, setSelectedPatientBookedEventData] = useState()
  const [auxiliaryData, setAuxiliaryData] = useState()
  const [rxDrawerOpen, setRxDrawerOpen] = useState(false)
  const [reportPreviewDrawerOpen, setReportPreviewDrawerOpen] = useState(false)
  // Mobile-only: presents the patient report/prescription workspace as a full-screen sheet
  // (on desktop it lives in the split panel; on mobile that panel is display:none otherwise).
  // When open, the video collapses to a small draggable picture-in-picture tile (see pipPos).
  const [mobileReportSheetOpen, setMobileReportSheetOpen] = useState(false)
  // Picture-in-picture position for the video tile while the report sheet is open. null = the
  // default spot (top-centre); once dragged it holds an absolute {left, top} in px.
  const [pipPos, setPipPos] = useState(null)
  // The floating PIP follows the incoming video's orientation (landscape tile for a landscape feed).
  const [pipLandscape, setPipLandscape] = useState(false)
  const pipDragRef = useRef(null)
  // Bottom-right mobile control dock (Video/Rx toggle · History · Print). Minimizable to a
  // single hamburger so it never blocks the patient/report.
  const [chamberDockMinimized, setChamberDockMinimized] = useState(false)
  // True while the on-screen keyboard is open (detected via visualViewport shrink). The dock hides
  // then so it never covers the field being typed.
  const [keyboardOpen, setKeyboardOpen] = useState(false)
  // Chamber-level patient-history drawer (uniform across report types) + its overflow ⋮ menu.
  const [chamberHistoryDrawerOpen, setChamberHistoryDrawerOpen] = useState(false)
  const chamberHistoryGalleryRef = useRef(null)
  const [sheetMoreMenuAnchor, setSheetMoreMenuAnchor] = useState(null)
  // Anchor for the chamber dock's Print button menu (Print / Download PDF / Send PDF to patient).
  const [printMenuAnchor, setPrintMenuAnchor] = useState(null)
  const [assessmentDrawerOpen, setAssessmentDrawerOpen] = useState(false)

  useEffect(() => {
    setAssessmentDrawerOpen(false)
  }, [selectedPatientBookedEventId])
  
  // Ref to prevent multiple LEAVE API calls
  const isClosingBookedEventRef = useRef(false)
  
  // Ref to track if we've already determined this is an offline meeting
  const isOfflineMeetingRef = useRef(false)
  
  // Ref to track the last report mode that was active (for cleanup)
  const lastActiveReportModeRef = useRef(null)
  
  // Ref to prevent multiple calls to getEventBySlug
  const isFetchingEventBySlugRef = useRef(false)
  
  // Ref to prevent URL updates when leaving session
  // CRITICAL: This ref MUST be set to true BEFORE clearing selectedOptionPatientMenu
  // to prevent the menu setup useEffect from re-selecting the menu after leaving
  // See: finallyCloseBookedEvent() and the menu setup useEffect at line ~1821
  const isLeavingSessionRef = useRef(false)
  
  // Ref to track the last slug we intentionally removed from URL
  const lastRemovedSlugRef = useRef(null)
  const [hideLayoutComponents, setHideLayoutComponents] = useState({
    sidebar: false,
    endSession: false,
    patientDetails: false,
  })

  const chamberRoomId = useCheckedInOnlyChamberRoomId()

  // Chamber screen status tracking
  const [chamberScreenStatus, setChamberScreenStatus] = useState('unknown') // 'online', 'offline', or 'unknown'

  const [showDocOnSidebar, setShowDocOnSidebar] = useState()

  // Pre-join "ready room": default the camera/mic ON so permission is requested and the
  // self-view lights up the moment the lobby mounts, and remember the doctor's last choice
  // (persisted on every toggle below) so the eventual auto-join lands in the same state.
  const [isCameraOpen, setIsCameraOpen] = useState(
    () => localStorage.getItem('chamberJoinWithCamera') !== 'false',
  )
  const [isAudioOpen, setIsAudioOpen] = useState(
    () => localStorage.getItem('chamberJoinWithMic') !== 'false',
  )
  
  // Device preview states
  const [availableCameras, setAvailableCameras] = useState([])
  const [availableMicrophones, setAvailableMicrophones] = useState([])
  const [availableSpeakers, setAvailableSpeakers] = useState([])
  const [selectedCamera, setSelectedCamera] = useState('')
  const [selectedMicrophone, setSelectedMicrophone] = useState('')
  const [selectedSpeaker, setSelectedSpeaker] = useState('')
  const [previewStream, setPreviewStream] = useState(null)
  // Device pickers live behind a settings gear on the preview (like Zoom/Meet) instead of
  // taking up three always-visible rows of the lobby.
  const [deviceMenuAnchor, setDeviceMenuAnchor] = useState(null)
  const previewVideoRef = useRef(null)
  const [audioPreviewBars, setAudioPreviewBars] = useState(() => [
    ...AUDIO_PREVIEW_IDLE_LEVELS,
  ])
  const audioPreviewStreamRef = useRef(null)
  const audioPreviewContextRef = useRef(null)
  const audioPreviewAnalyserRef = useRef(null)
  const audioPreviewAnimationFrameRef = useRef(null)
  const [autoConnectPauseDurationMs, setAutoConnectPauseDurationMs] = useState(
    AUTO_CONNECT_PAUSE_OPTIONS[2].value,
  )
  const [autoConnectPausedUntil, setAutoConnectPausedUntil] = useState(null)
  const [autoConnectRemainingMs, setAutoConnectRemainingMs] = useState(0)
  const [autoConnectPauseDialogOpen, setAutoConnectPauseDialogOpen] = useState(false)
  const getAndHandleNextActionRef = useRef(null)
  const autoConnectPausedUntilRef = useRef(null)
  const autoConnectInactivityTimerRef = useRef(null)
  const autoConnectResumeInFlightRef = useRef(false)
  const activeAutoConnectPauseDurationRef = useRef(null)
  const activeAutoConnectLogContextRef = useRef({
    bookedEventId: null,
    checkedInRoomContext: null,
  })
  const isCameraOpenRef = useRef(isCameraOpen)
  const isAudioOpenRef = useRef(isAudioOpen)

  useEffect(() => {
    isCameraOpenRef.current = isCameraOpen
  }, [isCameraOpen])

  useEffect(() => {
    isAudioOpenRef.current = isAudioOpen
  }, [isAudioOpen])

  useEffect(() => {
    autoConnectPausedUntilRef.current = autoConnectPausedUntil
  }, [autoConnectPausedUntil])

  useEffect(() => {
    return () => {
      setEmrChamberAutoConnectPause(false, {
        source: 'mentor-chamber-room',
        resumeSource: 'unmount',
      })
    }
  }, [])

  const buildAutoConnectIoState = useCallback(
    (autoConnectState = {}) => ({
      camera: isCameraOpenRef.current,
      mic: isAudioOpenRef.current,
      autoConnectPaused: autoConnectState?.autoConnectPaused,
      autoConnectPauseDurationMs: autoConnectState?.autoConnectPauseDurationMs,
      autoConnectResumeAtEpochMs: autoConnectState?.autoConnectResumeAtEpochMs,
    }),
    [],
  )

  const logAutoConnectPauseState = useCallback(
    async ({
      paused,
      pauseDurationMs = null,
      resumeAtEpochMs = null,
      bookedEventId = null,
      checkedInRoomContext = null,
    }) => {
      const ioState = buildAutoConnectIoState({
        autoConnectPaused: paused,
        autoConnectPauseDurationMs: pauseDurationMs,
        autoConnectResumeAtEpochMs: resumeAtEpochMs,
      })
      const resolvedBookedEventId = bookedEventId || selectedPatientBookedEventId
      const resolvedCheckedInRoomContext = checkedInRoomContext || readCheckedInRoomContext()

      const pendingLogs = []

      if (resolvedBookedEventId) {
        pendingLogs.push(
          markBookedEventLog(
            resolvedBookedEventId,
            paused ? 'AUTO_CONNECT_PAUSED' : 'AUTO_CONNECT_RESUMED',
            'mentor',
            ioState,
          ),
        )
      }

      if (resolvedCheckedInRoomContext) {
        pendingLogs.push(
          paused
            ? logAutoConnectPaused(resolvedCheckedInRoomContext, {
                autoConnectPauseDurationMs: pauseDurationMs,
                autoConnectResumeAtEpochMs: resumeAtEpochMs,
              })
            : logAutoConnectResumed(resolvedCheckedInRoomContext, {
                autoConnectPauseDurationMs: pauseDurationMs,
                autoConnectResumeAtEpochMs: resumeAtEpochMs,
              }),
        )
      }

      if (pendingLogs.length === 0) {
        return
      }

      try {
        await Promise.allSettled(pendingLogs)
      } catch (error) {
        console.warn(
          '[MentorClinicSomeChamberAutoJoiningPage] Failed to log auto-connect pause state',
          error,
        )
      }
    },
    [buildAutoConnectIoState, selectedPatientBookedEventId],
  )

  // Tab state for calendar views
  const [selectedTab, setSelectedTab] = useState(MENTOR_CLINIC_BOOKING_TABS.calendar.id)
  const [calendarEventScope, setCalendarEventScope] = useState(CALENDAR_EVENT_SCOPES.own)
  const [screenerCalendarAccess, setScreenerCalendarAccess] = useState(null)
  
  // Calendar date state
  const [selectedDate, setSelectedDate] = useState(dayjs().format('DD-MM-YYYY'))
  const isToday = dayjs().format('DD-MM-YYYY') === selectedDate

  // Action button states
  const [patientSearchOpen, setPatientSearchOpen] = useState(false)
  const [bookedSlotsDrawerOpen, setBookedSlotsDrawerOpen] = useState(false)
  const [calendarDrawerOpen, setCalendarDrawerOpen] = useState(false) // Calendar drawer for mobile
  const [isRefreshingBookings, setIsRefreshingBookings] = useState(false)
  const [isLeavingSession, setIsLeavingSession] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const [isVideoLandscape, setIsVideoLandscape] = useState(false) // Video view mode: false = portrait (full height), true = landscape (full width)
  const [chamberLocalParticipantIdentity, setChamberLocalParticipantIdentity] = useState(null)
  const [bookedSlotsInDay, setBookedSlotsInDay] = useState([])
  const [screeningBookingCandidate, setScreeningBookingCandidate] = useState(null)
  const [isBookingScreeningFromConsultation, setIsBookingScreeningFromConsultation] = useState(false)
  const effectiveCalendarClinicBrandId = chosenClinicData?.clinicBrandId || clinicBrandId
  const effectiveCalendarClinicLocationId = chosenClinicData?.id || clinicLocationId
  const canViewConsultationCalendar = Boolean(
    screenerCalendarAccess?.canViewConsultationCalendar,
  )
  const effectiveCalendarEventScope = canViewConsultationCalendar
    ? calendarEventScope
    : CALENDAR_EVENT_SCOPES.own
  const calendarBookingListingApiSignature = useMemo(() => {
    const params = new URLSearchParams({
      'get-patient-details': 'true',
    })
    if (effectiveCalendarEventScope !== CALENDAR_EVENT_SCOPES.own) {
      params.set('calendar-scope', effectiveCalendarEventScope)
    }
    if (effectiveCalendarClinicBrandId) {
      params.set('clinicBrandId', effectiveCalendarClinicBrandId)
    }
    if (effectiveCalendarClinicLocationId) {
      params.set('clinicLocationId', effectiveCalendarClinicLocationId)
    }
    return `/api/secure/teacher/booked-slots/all-with-patient-info?${params.toString()}`
  }, [
    effectiveCalendarClinicBrandId,
    effectiveCalendarClinicLocationId,
    effectiveCalendarEventScope,
  ])

  useEffect(() => {
    let isMounted = true

    async function loadEffectiveScreenerAccess() {
      if (
        !effectiveCalendarClinicBrandId ||
        !effectiveCalendarClinicLocationId ||
        !getAllRolesInBoolean().isScreener
      ) {
        if (isMounted) {
          setScreenerCalendarAccess(null)
          setCalendarEventScope(CALENDAR_EVENT_SCOPES.own)
        }
        return
      }

      try {
        const response = await getCPDataWithParams(
          '/api/secure/teacher/screener-access/effective',
          {
            clinicBrandId: effectiveCalendarClinicBrandId,
            clinicLocationId: effectiveCalendarClinicLocationId,
          },
        )
        if (!isMounted) return
        const access = response?.data?.data?.effectiveScreenerAccess || null
        setScreenerCalendarAccess(access)
        if (!access?.canViewConsultationCalendar) {
          setCalendarEventScope(CALENDAR_EVENT_SCOPES.own)
        }
      } catch (error) {
        console.error('Error loading effective screener calendar access:', error)
        if (isMounted) {
          setScreenerCalendarAccess(null)
          setCalendarEventScope(CALENDAR_EVENT_SCOPES.own)
        }
      }
    }

    loadEffectiveScreenerAccess()

    return () => {
      isMounted = false
    }
  }, [effectiveCalendarClinicBrandId, effectiveCalendarClinicLocationId])
  const stopAudioPreview = useCallback(() => {
    if (audioPreviewAnimationFrameRef.current) {
      cancelAnimationFrame(audioPreviewAnimationFrameRef.current)
      audioPreviewAnimationFrameRef.current = null
    }

    if (audioPreviewStreamRef.current) {
      audioPreviewStreamRef.current.getTracks().forEach((track) => {
        if (track.readyState !== 'ended') {
          track.stop()
        }
      })
      audioPreviewStreamRef.current = null
    }

    if (audioPreviewContextRef.current) {
      audioPreviewContextRef.current.close().catch(() => {})
      audioPreviewContextRef.current = null
    }

    audioPreviewAnalyserRef.current = null
    setAudioPreviewBars([...AUDIO_PREVIEW_IDLE_LEVELS])
  }, [])

  const enrichBookedEventWithPatientData = useCallback((bookedEvent, auxiliaryDataFromApi = null) => {
    if (!bookedEvent || typeof bookedEvent !== 'object') return bookedEvent

    const selectedPatientInfo =
      selectedPatientBookedEventData?.patientInfoData?.id === bookedEvent?.patientId
        ? selectedPatientBookedEventData?.patientInfoData
        : selectedPatientBookedEventData?.patientInfo?.id === bookedEvent?.patientId
          ? selectedPatientBookedEventData?.patientInfo
          : null

    const slotMatch = bookedSlotsInDay?.find(
      (slot) => slot?.id === bookedEvent?.id || slot?.slug === bookedEvent?.slug,
    )
    const patientMatchById = bookedSlotsInDay?.find((slot) => slot?.patientId === bookedEvent?.patientId)

    const auxiliaryPatientInfo = Array.isArray(auxiliaryDataFromApi?.patientInfo)
      ? auxiliaryDataFromApi.patientInfo.find((patient) => patient?.id === bookedEvent?.patientId)
      : auxiliaryDataFromApi?.patientInfo?.id === bookedEvent?.patientId
        ? auxiliaryDataFromApi.patientInfo
        : null

    const resolvedPatientInfo =
      selectedPatientInfo ??
      slotMatch?.patientInfoData ??
      slotMatch?.patientInfo ??
      patientMatchById?.patientInfoData ??
      patientMatchById?.patientInfo ??
      auxiliaryPatientInfo ??
      null

    if (!resolvedPatientInfo) return bookedEvent

    return {
      ...bookedEvent,
      patientId:
        bookedEvent?.patientId ??
        resolvedPatientInfo?.id ??
        resolvedPatientInfo?.patientId ??
        null,
      patientInfo: {
        ...(bookedEvent?.patientInfo ?? {}),
        ...resolvedPatientInfo,
      },
      patientInfoData: {
        ...(bookedEvent?.patientInfoData ?? {}),
        ...resolvedPatientInfo,
      },
      patientDateOfBirth:
        bookedEvent?.patientDateOfBirth ?? resolvedPatientInfo?.dateOfBirth ?? null,
      patientGender: bookedEvent?.patientGender ?? resolvedPatientInfo?.gender ?? null,
      patientNumber: bookedEvent?.patientNumber ?? resolvedPatientInfo?.patientNumber ?? null,
      patientName: bookedEvent?.patientName ?? resolvedPatientInfo?.name ?? bookedEvent?.userName ?? null,
    }
  }, [bookedSlotsInDay, selectedPatientBookedEventData])

  const fetchPatientInfoById = useCallback(async (patientId) => {
    if (!patientId) return null
    try {
      const response = await getDataWithParams('/api/secure/patient/get', { patientId })
      if (response?.status === 200 && response?.data?.data) {
        return response.data.data
      }
    } catch (error) {
      console.error('Error fetching patient info for booked event', error)
    }
    return null
  }, [])
  
  // Slot duration state
  const [eachSlotDurationInMins, setEachSlotDurationInMins] = useState(30)
  
  // Calendar navigation functions
  const onPrevClick = useCallback(() => {
    const newDate = dayjs(selectedDate, 'DD-MM-YYYY').subtract(1, 'day').format('DD-MM-YYYY')
    setSelectedDate(newDate)
    // Defer event dispatch to avoid updating components during render
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('calendar-date-change', { detail: { date: newDate } }))
    }, 0)
  }, [selectedDate])
  
  const onNextClick = useCallback(() => {
    const newDate = dayjs(selectedDate, 'DD-MM-YYYY').add(1, 'day').format('DD-MM-YYYY')
    setSelectedDate(newDate)
    // Defer event dispatch to avoid updating components during render
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('calendar-date-change', { detail: { date: newDate } }))
    }, 0)
  }, [selectedDate])
  
  const handleGoToToday = useCallback(() => {
    setSelectedDate(dayjs().format('DD-MM-YYYY'))
  }, [])

  // Action button handlers
  const handleOpenPatientSearch = useCallback(() => {
    setPatientSearchOpen(true)
  }, [])

  const handleOpenBookedSlotsDrawer = useCallback(() => {
    setBookedSlotsDrawerOpen(true)
  }, [])

  const handleRefreshBookings = useCallback(() => {
    // Trigger refresh using the calendar ref
    setIsRefreshingBookings(true)
    if (calendarRef.current?.refresh) {
      calendarRef.current.refresh()
    }
    // Reset the refreshing state after a short delay
    setTimeout(() => {
      setIsRefreshingBookings(false)
    }, 1000)
  }, [])
  
  const clinicSchedules = chosenClinicData?.schedules

  const therapyReportRef = useRef()
  const prescriptionRef = useRef()
  const screeningReportRef = useRef() // NEW: Ref for screening report
  const assessmentReportRef = useRef()
  const calendarRef = useRef() // Ref for calendar component

  if (!chosenClinicData) {
    navigate('/mentor-home')
  }

  useEffect(() => {
    preloadAgoraRtcUIKitModule().catch(() => {})
  }, [])

  useEffect(() => {
    const debugPayload = {
      componentPath: 'predecided-clinic-chamber',
      clinicBrandId,
      clinicLocationId,
      chamberRoomId: serverGivenNextAction?.channel?.chamberRoomId || chamberRoomId || null,
      joinedChannelName: joinedChannelName || null,
      chamberScreenState: chamberScreenStateNow,
      debugVersion: 'mentor-chamber-shared-renderer-v1',
      rtcSurface: 'shared-renderer-agora-surface',
    }

    if (typeof window !== 'undefined') {
      window.__AUMHUM_MENTOR_CHAMBER_RTC_DEBUG__ = debugPayload
    }

    console.info('[MentorClinicSomeChamberAutoJoiningPage] RTC surface', debugPayload)
  }, [
    chamberRoomId,
    chamberScreenStateNow,
    clinicBrandId,
    clinicLocationId,
    joinedChannelName,
    serverGivenNextAction?.channel?.chamberRoomId,
  ])

  const getAndHandleNextAction = async (options = {}) => {
    // Don't poll for server actions if we're in a booked event session
    if (isInBookedEventSession) {
      return
    }

    // Read the pause state from the ref, not the closed-over `autoConnectPausedUntil` state:
    // this function is captured by the 60s poll's setInterval, so the state value would be stale
    // (the interval wouldn't see a pause that happened after it was set up) and auto-connect
    // would keep joining despite being paused. The ref is always current.
    if (
      options?.force !== true &&
      autoConnectPausedUntilRef.current &&
      autoConnectPausedUntilRef.current > Date.now()
    ) {
      return
    }
    
    const response = await getCPDataWithParams(
      `/api/secure/teacher/mentor-screen/get-next-action`,
      {
        clinicLocationId: clinicLocationId,
        screenState: chamberScreenStateNow,
        joinedChannelName: agoraRtcProps?.channel,
        chamberRoomId: chamberRoomId,
      },
    )
    if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
      handleIncomingNextActionFromServer(response?.data?.data)
      setServerGivenNextAction(response?.data?.data)
    } else {
      showNotification.error('Error getting next action')
    }
  }

  useEffect(() => {
    getAndHandleNextActionRef.current = getAndHandleNextAction
  }, [getAndHandleNextAction])

  const handleResumeAutoConnect = useCallback(
    async ({ source = 'manual', pauseDurationMs = null } = {}) => {
      if (autoConnectResumeInFlightRef.current) {
        return
      }

      const pausedUntil = autoConnectPausedUntilRef.current
      if (!pausedUntil) {
        return
      }
      const effectivePauseDurationMs =
        pauseDurationMs || activeAutoConnectPauseDurationRef.current || null
      const logContext = activeAutoConnectLogContextRef.current || {
        bookedEventId: null,
        checkedInRoomContext: null,
      }

      autoConnectResumeInFlightRef.current = true
      autoConnectPausedUntilRef.current = null
      activeAutoConnectPauseDurationRef.current = null
      activeAutoConnectLogContextRef.current = {
        bookedEventId: null,
        checkedInRoomContext: null,
      }
      setEmrChamberAutoConnectPause(false, {
        source: 'mentor-chamber-room',
        resumeSource: source,
      })
      setAutoConnectPausedUntil(null)
      setAutoConnectRemainingMs(0)
      setAutoConnectPauseDialogOpen(false)

      try {
        await logAutoConnectPauseState({
          paused: false,
          pauseDurationMs: effectivePauseDurationMs,
          resumeAtEpochMs: pausedUntil,
          bookedEventId: logContext?.bookedEventId,
          checkedInRoomContext: logContext?.checkedInRoomContext,
        })
      } finally {
        autoConnectResumeInFlightRef.current = false
      }

      showNotification.success(
        source === 'timer' ? 'Auto-connect resumed automatically' : 'Auto-connect resumed',
      )
      setTimeout(() => {
        if (chamberRoomId && chamberScreenStateNow === CHAMBER_SCREEN_STATES.IDLING) {
          getAndHandleNextActionRef.current?.({ force: true })
        }
      }, 0)
    },
    [chamberRoomId, chamberScreenStateNow, logAutoConnectPauseState],
  )

  const handlePauseAutoConnect = useCallback(async ({ source = 'manual', pauseDurationMs = null } = {}) => {
    const resolvedSource = typeof source === 'string' ? source : 'manual'

    if (
      autoConnectPausedUntilRef.current &&
      autoConnectPausedUntilRef.current > Date.now()
    ) {
      if (resolvedSource === 'inactivity') {
        setAutoConnectPauseDialogOpen(true)
      }
      return
    }

    const requestedPauseDuration =
      pauseDurationMs || autoConnectPauseDurationMs || AUTO_CONNECT_PAUSE_OPTIONS[2].value
    const nextPauseDuration =
      Number(requestedPauseDuration) || AUTO_CONNECT_PAUSE_OPTIONS[2].value
    const resumeAtEpochMs = Date.now() + nextPauseDuration
    const checkedInRoomContext = readCheckedInRoomContext()
    activeAutoConnectPauseDurationRef.current = nextPauseDuration
    activeAutoConnectLogContextRef.current = {
      bookedEventId: selectedPatientBookedEventId || null,
      checkedInRoomContext,
    }
    autoConnectPausedUntilRef.current = resumeAtEpochMs
    setEmrChamberAutoConnectPause(true, {
      source: 'mentor-chamber-room',
      pauseSource: resolvedSource,
      pauseDurationMs: nextPauseDuration,
      resumeAtEpochMs,
      chamberRoomId,
      bookedEventId: selectedPatientBookedEventId || null,
    })
    setAutoConnectPausedUntil(resumeAtEpochMs)
    setAutoConnectRemainingMs(nextPauseDuration)
    await logAutoConnectPauseState({
      paused: true,
      pauseDurationMs: nextPauseDuration,
      resumeAtEpochMs,
      bookedEventId: selectedPatientBookedEventId,
      checkedInRoomContext,
    })

    if (resolvedSource === 'inactivity') {
      setAutoConnectPauseDialogOpen(true)
      showNotification.info(
        `Auto-connect paused while you were away. Auto-resume in ${formatAutoConnectRemaining(nextPauseDuration)}.`,
      )
    } else {
      setAutoConnectPauseDialogOpen(false)
      showNotification.info(`Auto-connect paused for ${formatAutoConnectRemaining(nextPauseDuration)}`)
    }
  }, [autoConnectPauseDurationMs, chamberRoomId, logAutoConnectPauseState, selectedPatientBookedEventId])

  async function handleIncomingNextActionFromServer(nextActionData) {
    // Don't override if we're in a booked event session
    if (isInBookedEventSession) {
      return
    }
    
    const data = nextActionData?.chamberScreenAction
    switch (data?.action) {
      case CHAMBER_SCREEN_ACTIONS.ACTION_JOIN:
        try {
          // Don't pull the doctor into the room until the in-clinic reception screen is actually
          // up — otherwise they'd land in an empty call. We ALWAYS re-confirm with a fresh status
          // check here (never the cached `chamberScreenStatus`, which is stale inside this
          // poll-captured closure) and bail out if it's detected offline, staying on the ready-room.
          // The next poll retries; the offline banner already explains the wait. (The backend also
          // gates this once deployed; until then this is the safety net.)
          if (chamberRoomId) {
            const liveScreenStatus = await checkChamberScreenStatus(chamberRoomId)
            setChamberScreenStatus(liveScreenStatus)
            if (liveScreenStatus === 'offline') {
              return
            }
          }

          showNotification.info('Server commanded to join a session...')

          // Small settle buffer before joining. Permission + device enumeration already
          // happen eagerly in the lobby, so this no longer needs to mask a cold getUserMedia
          // prompt — trimmed from 5s to 1s to make auto-joins feel near-instant.
          await sleep(1000)

          await joinAgoraChannelAndStartVideo(data)

          // Call askCheckedInChamberScreenToPollNextAction only after joinAgoraChannelAndStartVideo completes
          const chamberRoomIdForSignal = nextActionData?.channel?.chamberRoomId
          
          if (chamberRoomIdForSignal) {
            await askCheckedInChamberScreenToPollNextAction(chamberRoomIdForSignal)
          }
        } catch (error) {
          showNotification.error('Error joining session. Please try again.')
          // Don't rethrow - allow the function to continue processing other actions
        }
        break
      case CHAMBER_SCREEN_ACTIONS.ACTION_CONTINUE_SESSION:
        // toast.info('Server commanded to continue session...')
        setTimeout(() => continueSession(data), 5000)
        break
      case CHAMBER_SCREEN_ACTIONS.ACTION_LEAVE:
        showNotification.info('Server commanded to leave the current session...')
        setTimeout(() => {
          leaveThisSession()
        }, 5000)
        break
      case CHAMBER_SCREEN_ACTIONS.ACTION_CONTINUE_IDLING:
        // toast.info('Server commanded to continue idling...')
        setTimeout(() => continueIdling(data), 5000)
        break
      default:
        // Unknown action received
        break
    }
  }

  async function informChamberRoomChannelJoin(channelName) {
    const responseOne = await getCPDataWithParams(
      `/api/secure/teacher/mentor-screen/chamber-room-channel/log/join`,
      {
        channelName: channelName,
      },
    )
    // Channel join logged to server
  }

  async function informChamberRoomChannelLeave(channelName) {
    const responseOne = await getCPDataWithParams(
      `/api/secure/teacher/mentor-screen/chamber-room-channel/log/leave`,
      {
        channelName: channelName,
      },
    )
    // Channel leave logged to server
  }

  // Load available devices only when a patient is selected
  // Skip device loading for offline meetings to avoid browser permission prompts
  // Don't load devices just because mentor is checked in - wait until patient is selected
  useEffect(() => {
    // CRITICAL: Check ref FIRST - this is the source of truth set synchronously in getAndSetPatientBookedEventDetails
    // If ref says offline, return immediately without any checks that might trigger device enumeration
    if (isOfflineMeetingRef.current) {
      setAvailableCameras([])
      setAvailableMicrophones([])
      setAvailableSpeakers([])
      return // Don't proceed with device loading - CRITICAL to prevent permission requests
    }
    
    // If no patient is selected and camera/mic are not enabled, don't load devices
    // But if camera/mic are enabled, allow device loading for preview
    if (!selectedPatientBookedEventData && !isCameraOpen && !isAudioOpen) {
      // Don't clear devices if they're already loaded and camera/mic are enabled
      // This allows device dropdowns to remain populated when user enables camera/mic
      if (availableCameras.length === 0 && availableMicrophones.length === 0) {
        return
      }
    }
    
    // Check meetingSrc as additional safeguard (ref should already be set, but double-check)
    const meetingSrc = selectedPatientBookedEventData?.meetingSrc
    const isOffline = meetingSrc === 'offline'
    
    // Update ref to track offline status immediately (synchronously)
    // This ensures ref is always in sync with current data
    isOfflineMeetingRef.current = isOffline
    
    // For offline meetings, explicitly set empty device lists and return early
    // Do this BEFORE any async operations that might request permissions
    if (isOffline) {
      setAvailableCameras([])
      setAvailableMicrophones([])
      setAvailableSpeakers([])
      return // Don't proceed with device loading - CRITICAL to prevent permission requests
    }
    
    // Load devices when:
    // 1. We're in IDLING state (checked in)
    // 2. Either a patient is selected OR camera/mic are enabled (for preview)
    // 3. The meeting is NOT offline (ref is false AND meetingSrc is not 'offline')
    const shouldLoadDevices = 
      chamberScreenStateNow === CHAMBER_SCREEN_STATES.IDLING &&
      !isOfflineMeetingRef.current &&
      (selectedPatientBookedEventData || isCameraOpen || isAudioOpen) &&
      (!selectedPatientBookedEventData || meetingSrc !== 'offline')
    
    if (shouldLoadDevices) {
      const loadDevices = async () => {
        // Final check before calling functions that might request permissions
        // This is a safety check in case state changed during async operation
        // Check ref FIRST, then data
        if (isOfflineMeetingRef.current) {
          return
        }

        if (!selectedPatientBookedEventData || selectedPatientBookedEventData.meetingSrc === 'offline') {
          return
        }
        
        try {
          // Check permissions first - some browsers require permissions before device enumeration
          let hasCameraPermission = false
          let hasMicrophonePermission = false
          
          try {
            if (navigator.permissions) {
              const [cameraPerm, micPerm] = await Promise.all([
                navigator.permissions.query({ name: 'camera' }).catch(() => ({ state: 'prompt' })),
                navigator.permissions.query({ name: 'microphone' }).catch(() => ({ state: 'prompt' })),
              ])
              hasCameraPermission = cameraPerm.state === 'granted'
              hasMicrophonePermission = micPerm.state === 'granted'
            }
          } catch (permError) {
            // Permissions API not available, try to request permissions via getUserMedia
          }
          
          // Request permissions if not granted (this enables device enumeration)
          if (!hasCameraPermission || !hasMicrophonePermission) {
            try {
              const stream = await navigator.mediaDevices.getUserMedia({
                video: true,
                audio: true,
              })
              // Stop the stream immediately - we just needed permissions
              stream.getTracks().forEach(track => track.stop())
              hasCameraPermission = true
              hasMicrophonePermission = true
            } catch (mediaError) {
              // Continue anyway - some browsers allow device enumeration without permissions
            }
          }
          
          // Load devices - these may return empty arrays if permissions aren't granted
          // but we'll try anyway as some browsers allow enumeration without permissions
          const [cameras, microphones, speakers] = await Promise.all([
            AgoraRTC.getCameras().catch(err => {
              // Suppress permission errors - they're expected if permissions weren't granted
              if (err?.code === 'PERMISSION_DENIED' || err?.name === 'NotAllowedError' || err?.message?.includes('Permission denied')) {
                return []
              }
              // Log other unexpected errors
              console.warn('Error getting cameras:', err)
              return []
            }),
            AgoraRTC.getMicrophones().catch(err => {
              // Suppress permission errors
              if (err?.code === 'PERMISSION_DENIED' || err?.name === 'NotAllowedError' || err?.message?.includes('Permission denied')) {
                return []
              }
              // Log other unexpected errors
              console.warn('Error getting microphones:', err)
              return []
            }),
            AgoraRTC.getPlaybackDevices().catch(err => {
              // Check if it's a permission error (some browsers may require permissions for speakers)
              const isPermissionError = err?.code === 'PERMISSION_DENIED' || 
                                      err?.name === 'NotAllowedError' || 
                                      err?.message?.includes('Permission denied') ||
                                      err?.message?.includes('PERMISSION_DENIED')
              if (isPermissionError) {
                // Don't log permission errors for speakers
                return []
              }
              // Log other unexpected errors (but not permission errors)
              console.warn('Error getting speakers:', err)
              return []
            }),
          ])
          
          // Update state with devices
          if (cameras.length > 0) {
            setAvailableCameras(cameras)
            const defaultCam = cameras[0].deviceId
            const localStorageCam = getSelectedCameraInLocalStorage()
            const isLocalCamAvailable = cameras.find((item) => item.deviceId === localStorageCam)
            if (localStorageCam && isLocalCamAvailable) {
              setSelectedCamera(localStorageCam)
            } else {
              setSelectedCamera(defaultCam)
              localStorage.setItem('selectedCamera', defaultCam)
            }
          } else {
            console.warn('No cameras found - permissions may not be granted or no camera available')
            setAvailableCameras([])
            setSelectedCamera('')
          }
          
          if (microphones.length > 0) {
            setAvailableMicrophones(microphones)
            const defaultMic = microphones[0].deviceId
            const localStorageMic = getSelectedMicrophoneInLocalStorage()
            const isLocalMicAvailable = microphones.find((item) => item.deviceId === localStorageMic)
            if (localStorageMic && isLocalMicAvailable) {
              setSelectedMicrophone(localStorageMic)
            } else {
              setSelectedMicrophone(defaultMic)
              localStorage.setItem('selectedMicrophone', defaultMic)
            }
          } else {
            console.warn('No microphones found - permissions may not be granted or no microphone available')
            setAvailableMicrophones([])
            setSelectedMicrophone('')
          }
          
          if (speakers.length > 0) {
            setAvailableSpeakers(speakers)
            const defaultSpeaker = speakers[0].deviceId
            const localStorageSpeaker = getSelectedSpeakerInLocalStorage()
            const isLocalSpeakerAvailable = speakers.find((item) => item.deviceId === localStorageSpeaker)
            if (localStorageSpeaker && isLocalSpeakerAvailable) {
              setSelectedSpeaker(localStorageSpeaker)
            } else {
              setSelectedSpeaker(defaultSpeaker)
              localStorage.setItem('selectedSpeaker', defaultSpeaker)
            }
          } else {
            console.warn('No speakers found')
            setAvailableSpeakers([])
            setSelectedSpeaker('')
          }
        } catch (error) {
          console.error('Error loading devices:', error)
        }
      }
      loadDevices()
    }
  }, [chamberScreenStateNow, selectedPatientBookedEventData, isCameraOpen, isAudioOpen])

  // Refresh devices when session starts (when call auto-joins)
  // This ensures device lists are populated even if initial load failed
  useEffect(() => {
    if (chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING && joinedChannelName) {
      // Session has started, refresh devices to ensure UI is up to date
      const refreshDevices = async () => {
        try {
          // Check if devices are already loaded
          if (availableCameras.length === 0 || availableMicrophones.length === 0) {
            // Request permissions if needed (this enables device enumeration)
            let permissionsExplicitlyDenied = false
            try {
              const stream = await navigator.mediaDevices.getUserMedia({
                video: true,
                audio: true,
              })
              // Stop the stream immediately - we just needed permissions
              stream.getTracks().forEach(track => track.stop())
            } catch (mediaError) {
              // Permission denied is expected if user hasn't granted access
              if (mediaError.name === 'NotAllowedError' || mediaError.name === 'PermissionDeniedError') {
                permissionsExplicitlyDenied = true
              }
            }
            
            // Don't try to enumerate devices if permissions were explicitly denied
            if (permissionsExplicitlyDenied) {
              return
            }
            
            // Load devices (permissions might already be granted or we'll handle errors gracefully)
            const [cameras, microphones, speakers] = await Promise.all([
              AgoraRTC.getCameras().catch(err => {
                // Suppress permission errors - they're expected if permissions weren't granted
                const isPermissionError = err?.code === 'PERMISSION_DENIED' || 
                                        err?.name === 'NotAllowedError' || 
                                        err?.message?.includes('Permission denied') ||
                                        err?.message?.includes('PERMISSION_DENIED')
                if (isPermissionError) {
                  // Silently handle permission errors
                  return []
                }
                // Log other unexpected errors
                // Error getting cameras
                return []
              }),
              AgoraRTC.getMicrophones().catch(err => {
                // Suppress permission errors
                const isPermissionError = err?.code === 'PERMISSION_DENIED' || 
                                        err?.name === 'NotAllowedError' || 
                                        err?.message?.includes('Permission denied') ||
                                        err?.message?.includes('PERMISSION_DENIED')
                if (isPermissionError) {
                  return []
                }
                // Log other unexpected errors
                // Error getting microphones
                return []
              }),
              AgoraRTC.getPlaybackDevices().catch(err => {
                // Check if it's a permission error (some browsers may require permissions for speakers)
                const isPermissionError = err?.code === 'PERMISSION_DENIED' || 
                                        err?.name === 'NotAllowedError' || 
                                        err?.message?.includes('Permission denied') ||
                                        err?.message?.includes('PERMISSION_DENIED')
                if (isPermissionError) {
                  // Don't log permission errors for speakers
                  return []
                }
                // Log other unexpected errors (but not permission errors)
                // Error getting speakers
                return []
              }),
            ])
            
            // Update state with devices
            if (cameras.length > 0) {
              setAvailableCameras(cameras)
              if (!selectedCamera || !cameras.find(cam => cam.deviceId === selectedCamera)) {
                const defaultCam = cameras[0].deviceId
                setSelectedCamera(defaultCam)
                localStorage.setItem('selectedCamera', defaultCam)
              }
            }
            
            if (microphones.length > 0) {
              setAvailableMicrophones(microphones)
              if (!selectedMicrophone || !microphones.find(mic => mic.deviceId === selectedMicrophone)) {
                const defaultMic = microphones[0].deviceId
                setSelectedMicrophone(defaultMic)
                localStorage.setItem('selectedMicrophone', defaultMic)
              }
            }
            
            if (speakers.length > 0) {
              setAvailableSpeakers(speakers)
              if (!selectedSpeaker || !speakers.find(sp => sp.deviceId === selectedSpeaker)) {
                const defaultSpeaker = speakers[0].deviceId
                setSelectedSpeaker(defaultSpeaker)
                localStorage.setItem('selectedSpeaker', defaultSpeaker)
              }
            }
          }
        } catch (error) {
          console.error('[Device Refresh] Error refreshing devices:', error)
        }
      }
      
      // Small delay to ensure permissions are granted after call starts
      const timeoutId = setTimeout(refreshDevices, 500)
      return () => clearTimeout(timeoutId)
    }
  }, [chamberScreenStateNow, joinedChannelName, availableCameras.length, availableMicrophones.length, selectedCamera, selectedMicrophone, selectedSpeaker])

  // Handle camera preview stream
  // Skip camera preview for offline meetings to avoid permission requests
  useEffect(() => {
    let currentStream = null
    
    // Don't start preview for offline meetings - check both ref and meetingSrc
    // But allow preview if no patient is selected (waiting screen)
    const isOfflineMeeting = 
      selectedPatientBookedEventData &&
      (isOfflineMeetingRef.current || selectedPatientBookedEventData?.meetingSrc === 'offline')
    
    if (
      chamberScreenStateNow === CHAMBER_SCREEN_STATES.IDLING &&
      isCameraOpen &&
      selectedCamera &&
      previewVideoRef.current &&
      !isOfflineMeeting
    ) {
      const startPreview = async () => {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({
            video: { deviceId: { exact: selectedCamera } },
            audio: false,
          })
          if (previewVideoRef.current) {
            previewVideoRef.current.srcObject = stream
            setPreviewStream(stream)
            currentStream = stream
          }
        } catch (error) {
          console.error('Error starting camera preview:', error)
        }
      }
      startPreview()
    } else {
      // Stop preview when camera is turned off
      setPreviewStream((prevStream) => {
        if (prevStream) {
          prevStream.getTracks().forEach(track => track.stop())
          if (previewVideoRef.current) {
            previewVideoRef.current.srcObject = null
          }
        }
        return null
      })
    }

    return () => {
      if (currentStream) {
        currentStream.getTracks().forEach(track => track.stop())
      }
      setPreviewStream((prevStream) => {
        if (prevStream) {
          prevStream.getTracks().forEach(track => track.stop())
        }
        return null
      })
    }
  }, [chamberScreenStateNow, isCameraOpen, selectedCamera, selectedPatientBookedEventData?.meetingSrc])

  useEffect(() => {
    let cancelled = false

    const isOfflineMeeting =
      selectedPatientBookedEventData &&
      (isOfflineMeetingRef.current || selectedPatientBookedEventData?.meetingSrc === 'offline')

    const startAudioPreview = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: selectedMicrophone
            ? {
                deviceId: { exact: selectedMicrophone },
              }
            : true,
          video: false,
        })

        if (cancelled) {
          stream.getTracks().forEach((track) => track.stop())
          return
        }

        const AudioContextClass = window.AudioContext || window.webkitAudioContext

        stopAudioPreview()

        if (!AudioContextClass) {
          audioPreviewStreamRef.current = stream
          setAudioPreviewBars([...AUDIO_PREVIEW_IDLE_LEVELS])
          return
        }

        const audioContext = new AudioContextClass()
        const analyser = audioContext.createAnalyser()
        const microphone = audioContext.createMediaStreamSource(stream)

        analyser.fftSize = 256
        analyser.smoothingTimeConstant = 0.82
        microphone.connect(analyser)

        audioPreviewStreamRef.current = stream
        audioPreviewContextRef.current = audioContext
        audioPreviewAnalyserRef.current = analyser

        const updateAudioPreview = () => {
          if (!audioPreviewAnalyserRef.current) {
            return
          }

          const frequencyData = new Uint8Array(
            audioPreviewAnalyserRef.current.frequencyBinCount,
          )
          audioPreviewAnalyserRef.current.getByteFrequencyData(frequencyData)
          setAudioPreviewBars(buildAudioPreviewBars(frequencyData))
          audioPreviewAnimationFrameRef.current = requestAnimationFrame(updateAudioPreview)
        }

        updateAudioPreview()
      } catch (error) {
        console.error('Error starting microphone preview:', error)
        stopAudioPreview()
      }
    }

    if (
      chamberScreenStateNow === CHAMBER_SCREEN_STATES.IDLING &&
      isAudioOpen &&
      !isOfflineMeeting
    ) {
      startAudioPreview()
    } else {
      stopAudioPreview()
    }

    return () => {
      cancelled = true
      stopAudioPreview()
    }
  }, [
    chamberScreenStateNow,
    isAudioOpen,
    selectedMicrophone,
    selectedPatientBookedEventData?.meetingSrc,
    stopAudioPreview,
  ])

  async function joinAgoraChannelAndStartVideo(data) {
    // Don't join chamber room channel if we're in a booked event session
    // Also check if current channel is a booked event channel (not a chamber room channel)
    const currentChannel = agoraRtcProps?.channel
    const isCurrentChannelBookedEvent = currentChannel && !currentChannel.includes('chamber-room') && !currentChannel.includes('CHAMBER')
    
    if (isInBookedEventSession || isCurrentChannelBookedEvent) {
      return
    }
    
    // Stop preview stream before joining
    setPreviewStream((prevStream) => {
      if (prevStream) {
        prevStream.getTracks().forEach(track => track.stop())
        if (previewVideoRef.current) {
          previewVideoRef.current.srcObject = null
        }
      }
      return null
    })
    stopAudioPreview()
    
    // Validate and refresh device IDs before joining to prevent NotFoundError
    // Also load devices to populate UI dropdowns even if camera/audio aren't enabled yet
    let validCameraDeviceId = undefined
    let validMicrophoneDeviceId = undefined
    
    try {
      // Track permission state to provide better UI feedback
      let cameraPermissionDenied = false
      let microphonePermissionDenied = false
      let speakerError = false
      
      // Always load all devices to populate UI dropdowns, not just when camera/audio are enabled
      // This ensures device lists are available in the UI
      const [currentCameras, currentMicrophones, currentSpeakers] = await Promise.all([
        AgoraRTC.getCameras().catch(err => {
          // Check if it's a permission error
          const isPermissionError = err?.code === 'PERMISSION_DENIED' || 
                                   err?.name === 'NotAllowedError' || 
                                   err?.message?.includes('Permission denied') ||
                                   err?.message?.includes('PERMISSION_DENIED')
          
          if (isPermissionError) {
            cameraPermissionDenied = true
            return []
          }
          // Log other unexpected errors
          // Error getting cameras
          return []
        }),
        AgoraRTC.getMicrophones().catch(err => {
          // Check if it's a permission error
          const isPermissionError = err?.code === 'PERMISSION_DENIED' || 
                                   err?.name === 'NotAllowedError' || 
                                   err?.message?.includes('Permission denied') ||
                                   err?.message?.includes('PERMISSION_DENIED')
          
          if (isPermissionError) {
            microphonePermissionDenied = true
            return []
          }
          // Log other unexpected errors
          // Error getting microphones
          return []
        }),
        AgoraRTC.getPlaybackDevices().catch(err => {
          // Check if it's a permission error (some browsers may require permissions for speakers)
          const isPermissionError = err?.code === 'PERMISSION_DENIED' || 
                                   err?.name === 'NotAllowedError' || 
                                   err?.message?.includes('Permission denied') ||
                                   err?.message?.includes('PERMISSION_DENIED')
          
          if (isPermissionError) {
            // Speakers typically don't require permissions, but some browsers might throw this
            // Don't show a warning for permission errors on speakers
            return []
          }
          // Log other unexpected errors (but not permission errors)
          speakerError = true
          // Error getting speakers
          return []
        }),
      ])
      
      // Update camera devices in state
      if (currentCameras && currentCameras.length > 0) {
        setAvailableCameras(currentCameras)
        const defaultCam = currentCameras[0].deviceId
        const localStorageCam = getSelectedCameraInLocalStorage()
        const isLocalCamAvailable = currentCameras.find((item) => item.deviceId === localStorageCam)
        
        if (localStorageCam && isLocalCamAvailable) {
          setSelectedCamera(localStorageCam)
          if (isCameraOpen) {
            validCameraDeviceId = localStorageCam
          }
        } else {
          setSelectedCamera(defaultCam)
          localStorage.setItem('selectedCamera', defaultCam)
          if (isCameraOpen) {
            validCameraDeviceId = defaultCam
          }
        }
      } else {
        // Only log warning if it's not a permission issue
        if (!cameraPermissionDenied) {
          // No cameras available
        }
        setAvailableCameras([])
      }
      
      // Update microphone devices in state
      if (currentMicrophones && currentMicrophones.length > 0) {
        setAvailableMicrophones(currentMicrophones)
        const defaultMic = currentMicrophones[0].deviceId
        const localStorageMic = getSelectedMicrophoneInLocalStorage()
        const isLocalMicAvailable = currentMicrophones.find((item) => item.deviceId === localStorageMic)
        
        if (localStorageMic && isLocalMicAvailable) {
          setSelectedMicrophone(localStorageMic)
          if (isAudioOpen) {
            validMicrophoneDeviceId = localStorageMic
          }
        } else {
          setSelectedMicrophone(defaultMic)
          localStorage.setItem('selectedMicrophone', defaultMic)
          if (isAudioOpen) {
            validMicrophoneDeviceId = defaultMic
          }
        }
      } else {
        // Only log warning if it's not a permission issue
        if (!microphonePermissionDenied) {
          // No microphones available
        }
        setAvailableMicrophones([])
      }
      
      // Update speaker devices in state
      if (currentSpeakers && currentSpeakers.length > 0) {
        setAvailableSpeakers(currentSpeakers)
        const defaultSpeaker = currentSpeakers[0].deviceId
        const localStorageSpeaker = getSelectedSpeakerInLocalStorage()
        const isLocalSpeakerAvailable = currentSpeakers.find((item) => item.deviceId === localStorageSpeaker)
        
        if (localStorageSpeaker && isLocalSpeakerAvailable) {
          setSelectedSpeaker(localStorageSpeaker)
        } else {
          setSelectedSpeaker(defaultSpeaker)
          localStorage.setItem('selectedSpeaker', defaultSpeaker)
        }
      } else {
        // Only log warning if it's not a permission error
        if (speakerError) {
          // No speakers available
        }
        setAvailableSpeakers([])
      }
      
      // Show user-friendly toast messages if permissions are needed
      if (cameraPermissionDenied || microphonePermissionDenied) {
        const missingPermissions = []
        if (cameraPermissionDenied) missingPermissions.push('camera')
        if (microphonePermissionDenied) missingPermissions.push('microphone')
        
        toast.info(
          `Please allow ${missingPermissions.join(' and ')} access in your browser settings to use video/audio features.`,
          {
            autoClose: 5000,
            toastId: 'media-permissions-needed', // Prevent duplicate toasts
          }
        )
      }
    } catch (error) {
      console.error('[joinAgoraChannelAndStartVideo] Error validating devices:', error)
      // Continue without device IDs if validation fails - Agora will use default devices
    }
    
    await informChamberRoomChannelJoin(data?.joinChannelName)
    setChamberScreenStateNow(CHAMBER_SCREEN_STATES.SESSION_RUNNING)
    setJoinedChamberName(data?.chamberRoomName)
    setJoinedChannelName(data?.joinChannelName)
    const resolvedVideoQuality =
      data?.sessionRoutingDecision?.videoQuality || data?.videoQuality || null
    setAgoraRtcProps({
      appId: import.meta.env.VITE_AGORA_APP_ID,
      channel: data?.joinChannelName,
      uid: parseInt(data?.joinChannelUid),
      token: data?.joinChannelRtcToken,
      layout: AGORA_RTC_LAYOUTS.pin,
      role: 'host',
      enableDualStream: resolvedVideoQuality?.enableDualStream === true,
      enableAudio: isAudioOpen,
      enableVideo: isCameraOpen,
      cameraDeviceId: validCameraDeviceId,
      microphoneDeviceId: validMicrophoneDeviceId,
      videoQuality: resolvedVideoQuality,
    })
    setChamberLocalParticipantIdentity(
      readLocalParticipantIdentity(
        data,
        createMentorChamberLocalParticipantIdentity(data, mentorProfileData),
      ),
    )
    // Build RTM username as JSON string with role, name, and profilePicId
    const rtmUsername = buildMentorRtmUsername(mentorProfileData)
    let parsedUsername = null
    try {
      parsedUsername = JSON.parse(rtmUsername)
    } catch (e) {
      console.error('Error parsing RTM username:', e)
    }
    // RTM props set for chamber room
    setAgoraRtmProps({
      username: rtmUsername,
      displayUsername: true,
      token: data?.joinChannelRtmToken,
    })
  }

  // Join booked event video call channel - navigates to /l/* page
  async function joinBookedEventVideoCall(bookedEventData) {
    try {
      // Check if session is blocked (payment pending - slot held but not confirmed)
      // No one should be able to join blocked sessions
      const isSessionBlocked = 
        bookedEventData?.status === BOOKING_STATUSES.BOOKING_INITIATED &&
        bookedEventData?.paymentStatus === BOOKING_PAYMENT_STATUSES.PENDING
      
      if (isSessionBlocked) {
        toast.warning('This session is awaiting payment confirmation and cannot be joined yet.')
        return
      }
      
      // Check if this is a video call event type
      const isVideoCallEvent = 
        bookedEventData?.eventType === allAvailableEventTypes.consultation ||
        bookedEventData?.eventType === allAvailableEventTypes.therapySession ||
        bookedEventData?.eventType === allAvailableEventTypes.screening ||
        bookedEventData?.eventType === allAvailableEventTypes.assessment

      if (!isVideoCallEvent) {
        // Not a video call, just set the selected event
        setSelectedPatientBookedEventId(bookedEventData?.id)
        setPatientSelected(true)
        return
      }

      // Store current chamber room state for reconnection BEFORE closing the session
      if (joinedChannelName && chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING) {
        setOriginalChamberRoomChannel(joinedChannelName)
        // Store current Agora props in sessionStorage for reconnection
        sessionStorage.setItem('chamberRoomRtcProps', JSON.stringify(agoraRtcProps))
        sessionStorage.setItem('chamberRoomRtmProps', JSON.stringify(agoraRtmProps))
        sessionStorage.setItem('chamberRoomChannelName', joinedChannelName)
        sessionStorage.setItem('chamberRoomChamberName', joinedChamberName)
        sessionStorage.setItem(
          'chamberRoomLocalParticipantIdentity',
          JSON.stringify(chamberLocalParticipantIdentity),
        )
        sessionStorage.setItem('chamberRoomUrl', window.location.pathname)
        
        // Close the current video call session to free camera and mic
        // Stop preview stream if active
        setPreviewStream((prevStream) => {
          if (prevStream) {
            prevStream.getTracks().forEach(track => track.stop())
            if (previewVideoRef.current) {
              previewVideoRef.current.srcObject = null
            }
          }
          return null
        })
        
        // Inform server that we're leaving the chamber room channel
        await informChamberRoomChannelLeave(joinedChannelName)
        
        // Use flushSync to ensure state updates complete before navigation
        // This prevents React warnings about updating components during render
        flushSync(() => {
          setAgoraRtcProps({})
          setAgoraRtmProps({})
          setChamberLocalParticipantIdentity(null)
          setChamberScreenStateNow(CHAMBER_SCREEN_STATES.IDLING)
        })
        
        // Small delay to ensure Agora cleanup completes before navigating
        await new Promise(resolve => setTimeout(resolve, 300))
      }

      // Mark that we're joining this event
      markBookedEventLog(bookedEventData?.id, 'JOIN', 'mentor')
      
      // Navigate to live session page with return state
      const eventSlug = bookedEventData?.slug || bookedEventData?.id
      navigate(`/l/${eventSlug}`, {
        state: {
          from: 'mentor-chamber-room',
          returnUrl: window.location.pathname,
          chamberRoomId: chamberRoomId,
        },
      })
    } catch (error) {
      console.error('Error joining booked event video call:', error)
      showNotification.error('Error joining video call')
    }
  }

  function continueIdling(data) {
    // A patient consult is active — ignore the chamber's periodic "continue-idling" next-action so it
    // doesn't tear the live session (and its floating controls) down to idle. The explicit leave /
    // checkout paths handle going idle when the consult actually ends. (This poll-driven flip, every
    // ~60s, was why the floating dock/controls only showed intermittently.)
    if (patientSelectedRef.current) {
      return
    }
    setJoinedChamberName()
    setJoinedChannelName()
    setChamberScreenStateNow(CHAMBER_SCREEN_STATES.IDLING)
  }

  function continueSession(data) {
    setChamberScreenStateNow(CHAMBER_SCREEN_STATES.SESSION_RUNNING)
  }

  /**
   * CRITICAL FIX: Header Persistence After Leaving Session
   * 
   * This function has a specific order of operations that MUST be maintained to prevent
   * the session header from persisting on the calendar page after leaving.
   * 
   * CRITICAL ORDER OF OPERATIONS (DO NOT CHANGE):
   * 1. Set isLeavingSessionRef.current = true FIRST (line ~1102)
   *    - This prevents the menu setup useEffect from re-selecting the menu
   * 2. Refresh event data if markAsCompleted (line ~1140)
   *    - Must happen AFTER guard is set, BEFORE clearing state
   *    - The guard prevents menu re-selection even though data is refreshed
   * 3. Clear selectedOptionPatientMenu and selectedPatientBookedEventData (line ~1147)
   *    - This triggers the header management useEffect to reset header
   * 
   * DEPENDENCIES:
   * - Menu setup useEffect (line ~1821) MUST check isLeavingSessionRef.current FIRST
   * - Header management useEffect (line ~2007) watches selectedOptionPatientMenu
   * - Child report components MUST NOT set headers (they were removed)
   * 
   * IF THIS BREAKS:
   * - Check that isLeavingSessionRef.current is set BEFORE clearing selectedOptionPatientMenu
   * - Check that menu setup useEffect still has the guard check
   * - Check that header management useEffect is still watching selectedOptionPatientMenu
   * - Check that child components aren't setting headers again
   */
  async function finallyCloseBookedEvent(markAsCompleted = false) {
    // Guard against multiple simultaneous calls
    if (isClosingBookedEventRef.current) {
      return
    }
    
    // CRITICAL: Mark that we're leaving FIRST, before any state changes
    // This MUST happen before clearing selectedOptionPatientMenu to prevent the menu setup
    // useEffect from re-selecting the menu. See menu setup useEffect at line ~1821
    // 
    // IMPORTANT: If this line is moved or removed, the header will persist after leaving
    isLeavingSessionRef.current = true
    
    // Reset header IMMEDIATELY before any state changes to prevent it from being re-set
    // This must happen before setSelectedOptionPatientMenu() to ensure header is cleared
    // Reset for ALL report types: prescription, therapy_report, screening_report, assessment_report
    // Use flushSync to ensure this happens synchronously before other state updates
    flushSync(() => {
      setFlowId(null)
      setButtonTopOffset(0)
    })
    
    // Immediately set to mentor-portal to ensure calendar header shows
    // Use requestAnimationFrame to ensure this runs after the null reset but still quickly
    requestAnimationFrame(() => {
      setFlowId('mentor-portal')
    })
    
    // Only log LEAVE if we have a valid booked event ID
    const bookedEventId = selectedPatientBookedEventData?.id
    if (bookedEventId) {
      isClosingBookedEventRef.current = true
      try {
        await markBookedEventLog(bookedEventId, 'LEAVE', 'mentor')
      } catch (error) {
        console.error('Error logging LEAVE event:', error)
      } finally {
        // Reset the guard after a short delay to allow state updates to complete
        setTimeout(() => {
          isClosingBookedEventRef.current = false
        }, 1000)
      }
    }
    
    // If marking as completed, refresh event data BEFORE clearing state
    // This ensures the calendar shows the updated "completed" status
    // 
    // CRITICAL ORDER: This MUST happen:
    // 1. AFTER isLeavingSessionRef.current = true (already set above)
    // 2. BEFORE clearing selectedOptionPatientMenu (below)
    // 
    // The isLeavingSessionRef guard in the menu setup useEffect will prevent menu re-selection
    // even though we're refreshing the event data here
    if (markAsCompleted && selectedPatientBookedEventId) {
      // Verify guard is set (defensive check)
      if (!isLeavingSessionRef.current) {
        isLeavingSessionRef.current = true
      }
      
      await markBookedSessionAsCompletedFunction(selectedPatientBookedEventData)
      // Refresh event data to show updated "completed" status
      // isLeavingSessionRef is already true, so the menu setup useEffect won't re-select the menu
      await getAndSetPatientBookedEventDetails(false)
    }
    
    // Clear state in a batch to prevent multiple re-renders
    // Use flushSync to ensure these happen synchronously and in order
    flushSync(() => {
      // Clear selectedOptionPatientMenu FIRST - this will trigger the parent's useEffect
      // to automatically reset the header (since parent manages header based on this state)
      setSelectedOptionPatientMenu()
      setAssessmentDrawerOpen(false)
      
      // Clear selectedPatientBookedEventData - this also triggers parent's header reset
      setSelectedPatientBookedEventData(null)
      
      // Then clear other state
      setSelectedPatientBookedEventId()
      setPatientSelected(false)
      setNewWantedMenuItemId()
      // On mobile, surface the appointments drawer (defaulted to Today) the moment we land back on
      // the video page, so the doctor goes straight to picking the next patient.
      if (isMobile) {
        setAppointmentsMode('today')
        setUpcomingDate(null)
        setCalendarDrawerOpen(true)
      }
    })
    
    // Header will be automatically reset by the parent's useEffect that watches selectedOptionPatientMenu
    // No need to manually reset it here - the parent is the single source of truth
    
    // Remove /l/<slug> from URL when leaving session
    // Use flushSync to ensure URL is updated synchronously before any other effects run
    if (clinicBrandId && clinicLocationId) {
      const basePath = `/mentor-home/join-chamber-room/${clinicBrandId}/${clinicLocationId}`
      const currentPath = window.location.pathname // Use window.location to get absolute latest
      // If URL contains /l/, remove it immediately
      if (currentPath.includes('/l/')) {
        // Extract the slug we're removing to prevent re-adding it
        const slugMatch = currentPath.match(/\/l\/([^/]+)/)
        if (slugMatch) {
          lastRemovedSlugRef.current = slugMatch[1]
        }
        // Use navigate with replace to update URL and prevent back navigation
        flushSync(() => {
          navigate(basePath, { replace: true })
        })
        // Force a small delay to ensure URL change is processed before any effects run
        await new Promise(resolve => setTimeout(resolve, 100))
      }
    }
    
    // Keep the leaving flag set for longer to prevent URL updates from re-triggering
    // Reset after a longer delay to ensure all effects have completed
    setTimeout(() => {
      isLeavingSessionRef.current = false
      // Clear the removed slug ref after a longer delay to allow new sessions to be opened
      setTimeout(() => {
        lastRemovedSlugRef.current = null
      }, 2000) // Increased delay to prevent re-opening
    }, 1000) // Increased delay to ensure all effects have completed
    
    // If we were in a booked event video call session, reconnect to chamber room
    if (isInBookedEventSession) {
      setIsInBookedEventSession(false)
      // Leave the booked event channel
      if (joinedChannelName) {
        informChamberRoomChannelLeave(joinedChannelName)
      }
      // Reset video call state
      setJoinedChamberName()
      setJoinedChannelName()
      setChamberScreenStateNow(CHAMBER_SCREEN_STATES.IDLING)
      setAgoraRtcProps({})
      setAgoraRtmProps({})
      // Trigger reconnection to chamber room by calling getAndHandleNextAction
      // The server will send the chamber room join action
      setTimeout(() => {
        if (chamberRoomId) {
          getAndHandleNextAction()
        }
      }, 500)
    }
  }

  // Function to mark as completed without leaving the page
  async function markAsCompletedOnly() {
    if (selectedOptionPatientMenu === 'screening_report') {
      // For screening reports, use the new markAsCompletedOnly function
      await screeningReportRef?.current?.markAsCompletedOnly()
      // Mark the event as completed via API
      if (selectedPatientBookedEventData) {
        await markBookedSessionAsCompletedFunction(selectedPatientBookedEventData)
        // Refresh the event data to show updated status
        await getAndSetPatientBookedEventDetails(false)
      }
      return
    }
    
    // For other report types, fall back to closeBookedEvent
    await closeBookedEvent(true)
  }

  async function closeBookedEvent(markAsCompleted = true) {
    // Default to true - "Save & Leave Session" should always mark as completed
    if (selectedOptionPatientMenu === 'prescription') {
      setNewWantedMenuItemId('end')
      await prescriptionRef?.current?.savePrescriptionData()
    }
    if (selectedOptionPatientMenu === 'therapy_report') {
      try {
        const result = await therapyReportRef?.current?.checkAndOpenModal(markAsCompleted)
        // Therapy checkAndOpenModal only saves and returns continue/stop; it does NOT call leaveRoom.
        // When result is continue, we must call finallyCloseBookedEvent to clear state and return to calendar (same as screening).
        if (result === FLOW_STATUSES_FOR_LEAVING_SESSION.continue) {
          await finallyCloseBookedEvent(markAsCompleted)
        }
        return result
      } catch (error) {
        console.error('Error in checkAndOpenModal:', error)
        throw error
      }
    }
    if (selectedOptionPatientMenu === 'screening_report') {
      // For screening reports, checkAndOpenModal with shouldLeave=true will handle leaving
      const result = await screeningReportRef?.current?.checkAndOpenModal(markAsCompleted, true)
      if (result === FLOW_STATUSES_FOR_LEAVING_SESSION.continue) {
        await finallyCloseBookedEvent(markAsCompleted)
      }
      return result
    }

    await finallyCloseBookedEvent(markAsCompleted)
  }

  // Cleanup function to stop all media tracks (both video and audio)
  const cleanupMediaTracks = useCallback(() => {
    try {
      // Stop all tracks from any active media streams
      // This includes tracks from getUserMedia, Agora local streams, and preview streams
      
      // 1. Clean up video elements
      const videoElements = document.querySelectorAll('video')
      videoElements.forEach((video) => {
        if (video.srcObject) {
          const stream = video.srcObject
          if (stream instanceof MediaStream) {
            stream.getTracks().forEach((track) => {
              if (track.readyState !== 'ended') {
                track.stop()
              }
            })
          }
          video.srcObject = null
        }
      })

      // 2. Clean up audio elements
      const audioElements = document.querySelectorAll('audio')
      audioElements.forEach((audio) => {
        if (audio.srcObject) {
          const stream = audio.srcObject
          if (stream instanceof MediaStream) {
            stream.getTracks().forEach((track) => {
              if (track.readyState !== 'ended') {
                track.stop()
              }
            })
          }
          audio.srcObject = null
        }
      })

      // 3. Clean up preview stream if active
      setPreviewStream((prevStream) => {
        if (prevStream) {
          prevStream.getTracks().forEach((track) => {
            if (track.readyState !== 'ended') {
              track.stop()
            }
          })
          if (previewVideoRef.current) {
            previewVideoRef.current.srcObject = null
          }
        }
        return null
      })
      stopAudioPreview()

      // 4. Explicitly stop all audio and video tracks from any active streams
      const allMediaElements = document.querySelectorAll('video, audio')
      allMediaElements.forEach((element) => {
        if (element.srcObject) {
          const stream = element.srcObject
          if (stream instanceof MediaStream) {
            stream.getAudioTracks().forEach((audioTrack) => {
              if (audioTrack.readyState !== 'ended') {
                audioTrack.stop()
              }
            })
            stream.getVideoTracks().forEach((videoTrack) => {
              if (videoTrack.readyState !== 'ended') {
                videoTrack.stop()
              }
            })
          }
        }
      })

      // 5. Clean up any tracked streams in global scope (if used)
      if (window.localMediaStreams && Array.isArray(window.localMediaStreams)) {
        window.localMediaStreams.forEach((stream) => {
          if (stream instanceof MediaStream) {
            stream.getTracks().forEach((track) => {
              if (track.readyState !== 'ended') {
                track.stop()
              }
            })
          }
        })
        window.localMediaStreams = []
      }
    } catch (error) {
      console.error('Error cleaning up media tracks:', error)
    }
  }, [stopAudioPreview])

  async function leaveThisSession() {
    // Cleanup all media tracks (camera and microphone) before leaving
    cleanupMediaTracks()
    
    informChamberRoomChannelLeave(joinedChannelName)
    setJoinedChamberName()
    setJoinedChannelName()
    setChamberScreenStateNow(CHAMBER_SCREEN_STATES.IDLING)
    setAgoraRtcProps({})
    setAgoraRtmProps({})
    
    // If we were in a booked event session, reconnect to chamber room
    if (isInBookedEventSession) {
      setIsInBookedEventSession(false)
      // Trigger reconnection to chamber room
      setTimeout(() => {
        if (chamberRoomId) {
          getAndHandleNextAction()
        }
      }, 500)
    }
  }

  const handleRefreshStatusForUser = useCallback(() => {
    if (!selectedPatientBookedEventId) return
    markBookedEventLog(selectedPatientBookedEventId, 'REFRESH', 'mentor', {
      camera: isCameraOpenRef.current,
      mic: isAudioOpenRef.current,
    })
  }, [selectedPatientBookedEventId])

  useEffect(() => {
    let interval = null
    if (selectedPatientBookedEventId) {
      // Immediately log status when session starts
      handleRefreshStatusForUser()
      // Set up periodic logging every 3 minutes (180000ms)
      interval = setInterval(() => {
        handleRefreshStatusForUser()
      }, 180000)
    }
    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }
  }, [selectedPatientBookedEventId, handleRefreshStatusForUser])

  // Log camera/mic state changes immediately when they toggle (without resetting the interval)
  // Use refs to track previous values and only log when they actually change
  const prevCameraStateRef = useRef(isCameraOpen)
  const prevAudioStateRef = useRef(isAudioOpen)
  const prevBookedEventIdRef = useRef(selectedPatientBookedEventId)

  useEffect(() => {
    // If session changed (new session started or ended), reset tracking refs
    // This ensures we don't log on session start (interval effect handles that)
    if (prevBookedEventIdRef.current !== selectedPatientBookedEventId) {
      prevBookedEventIdRef.current = selectedPatientBookedEventId
      prevCameraStateRef.current = isCameraOpen
      prevAudioStateRef.current = isAudioOpen
      return
    }

    // Only log if we have an active session and the state actually changed
    if (selectedPatientBookedEventId) {
      const cameraChanged = prevCameraStateRef.current !== isCameraOpen
      const audioChanged = prevAudioStateRef.current !== isAudioOpen

      if (cameraChanged || audioChanged) {
        // Log the state change immediately
        markBookedEventLog(selectedPatientBookedEventId, 'REFRESH', 'mentor', {
          camera: isCameraOpen,
          mic: isAudioOpen,
        })

        // Update refs to track current state
        prevCameraStateRef.current = isCameraOpen
        prevAudioStateRef.current = isAudioOpen
      }
    }
  }, [isCameraOpen, isAudioOpen, selectedPatientBookedEventId])

  // Store channel in ref to avoid recreating interval unnecessarily
  const currentChannelRef = useRef(agoraRtcProps?.channel)
  useEffect(() => {
    currentChannelRef.current = agoraRtcProps?.channel
  }, [agoraRtcProps?.channel])

  useEffect(() => {
    if (!autoConnectPausedUntil) {
      setAutoConnectRemainingMs(0)
      return
    }

    const syncPauseState = () => {
      const remaining = Math.max(0, autoConnectPausedUntil - Date.now())

      if (remaining <= 0) {
        handleResumeAutoConnect({ source: 'timer' })
        return
      }

      setAutoConnectRemainingMs(remaining)
    }

    syncPauseState()
    const intervalId = setInterval(syncPauseState, 1000)

    return () => {
      clearInterval(intervalId)
    }
  }, [
    autoConnectPausedUntil,
    chamberRoomId,
    chamberScreenStateNow,
    handleResumeAutoConnect,
  ])

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined
    }

    const shouldWatchAutoConnectInactivity =
      chamberScreenStateNow === CHAMBER_SCREEN_STATES.IDLING &&
      !isInBookedEventSession &&
      Boolean(chamberRoomId) &&
      !autoConnectPausedUntil

    const clearInactivityTimer = () => {
      if (autoConnectInactivityTimerRef.current) {
        window.clearTimeout(autoConnectInactivityTimerRef.current)
        autoConnectInactivityTimerRef.current = null
      }
    }

    if (!shouldWatchAutoConnectInactivity) {
      clearInactivityTimer()
      return undefined
    }

    const scheduleInactivityPause = () => {
      clearInactivityTimer()
      autoConnectInactivityTimerRef.current = window.setTimeout(() => {
        autoConnectInactivityTimerRef.current = null
        handlePauseAutoConnect({
          source: 'inactivity',
          pauseDurationMs: AUTO_CONNECT_INACTIVITY_PAUSE_MS,
        })
      }, AUTO_CONNECT_INACTIVITY_PAUSE_MS)
    }

    const activityEvents = ['click', 'keydown', 'mousemove', 'scroll', 'touchstart']
    activityEvents.forEach((eventName) => {
      window.addEventListener(eventName, scheduleInactivityPause, { passive: true })
    })
    scheduleInactivityPause()

    return () => {
      clearInactivityTimer()
      activityEvents.forEach((eventName) => {
        window.removeEventListener(eventName, scheduleInactivityPause)
      })
    }
  }, [
    autoConnectPausedUntil,
    chamberRoomId,
    chamberScreenStateNow,
    handlePauseAutoConnect,
    isInBookedEventSession,
  ])

  useEffect(() => {
    if (chamberRoomId) {
      getAndHandleNextAction() // Initial call
    }
  }, [chamberRoomId])

  // Cleanup media tracks on component unmount
  useEffect(() => {
    return () => {
      cleanupMediaTracks()
    }
  }, [cleanupMediaTracks])

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (chamberRoomId) {
        getAndHandleNextAction()
      }
    }, 60000)
    return () => {
      clearInterval(intervalId)
    }
    // Only recreate interval when these core values change, not when agoraRtcProps object reference changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chamberRoomId, chamberScreenStateNow, clinicLocationId])

  // Track the previous chamber-screen status so we can announce up<->down transitions
  // (the patient-side reception/kiosk screen coming back online or switching off).
  const prevChamberScreenStatusRef = useRef('unknown')

  const runChamberScreenStatusCheck = useCallback(async () => {
    if (!chamberRoomId) {
      return
    }
    try {
      const status = await checkChamberScreenStatus(chamberRoomId)
      setChamberScreenStatus(status)
      const prev = prevChamberScreenStatusRef.current
      if (status !== prev) {
        // Only announce real up<->down flips — not the initial unknown->x read, and not
        // transient unknowns from a failed/aborted status poll (those shouldn't toast).
        if (prev === 'online' && status === 'offline') {
          showNotification.warning(
            'Reception screen switched off — patients may not be able to check in until it is back online.',
          )
        } else if (prev === 'offline' && status === 'online') {
          showNotification.success('Reception screen is back online.')
        }
        prevChamberScreenStatusRef.current = status
      }
    } catch (error) {
      console.error('[MENTOR PORTAL] Error checking chamber screen status:', error)
      setChamberScreenStatus('unknown')
      prevChamberScreenStatusRef.current = 'unknown'
    }
  }, [chamberRoomId])

  // Periodically check the patient-side reception/kiosk screen status. The backend marks a
  // screen "down" only after ~3 min without a heartbeat, so a screen *going* offline can take
  // up to ~3 min to surface; a screen *coming back* online surfaces within one poll. We also
  // re-check the instant the tab regains focus, so "is the other side up yet?" is answered
  // immediately when the doctor returns to this screen.
  useEffect(() => {
    if (!chamberRoomId) {
      setChamberScreenStatus('unknown')
      prevChamberScreenStatusRef.current = 'unknown'
      return
    }

    runChamberScreenStatusCheck()

    const statusIntervalId = setInterval(runChamberScreenStatusCheck, 30000)

    const handleFocus = () => runChamberScreenStatusCheck()
    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        runChamberScreenStatusCheck()
      }
    }
    window.addEventListener('focus', handleFocus)
    document.addEventListener('visibilitychange', handleVisibility)

    return () => {
      clearInterval(statusIntervalId)
      window.removeEventListener('focus', handleFocus)
      document.removeEventListener('visibilitychange', handleVisibility)
    }
  }, [chamberRoomId, runChamberScreenStatusCheck])

  // Auto-refresh calendar bookings (similar to calendar page)
  useEffect(() => {
    // Only auto-refresh when viewing calendar tab
    if (selectedTab !== MENTOR_CLINIC_BOOKING_TABS.calendar.id) {
      return
    }
    
    // Initial refresh
    if (calendarRef.current?.refresh) {
      calendarRef.current.refresh()
    }
    
    // Scroll to current time when returning to calendar view
    // Only scroll if viewing today's date
    const isToday = dayjs().format('DD-MM-YYYY') === selectedDate
    if (isToday && calendarRef.current?.scrollToPresentLine) {
      // Small delay to ensure calendar is rendered
      setTimeout(() => {
        calendarRef.current?.scrollToPresentLine()
      }, 500)
    }
    
    // Set up interval to refresh every 75 seconds (same as calendar page)
    const intervalId = setInterval(() => {
      if (calendarRef.current?.refresh) {
        calendarRef.current.refresh()
      }
    }, 75000)
    
    return () => {
      clearInterval(intervalId)
    }
  }, [selectedTab, selectedDate]) // Refresh when tab or date changes

  // interaction part:

  async function getAndSetPatientBookedEventDetails(updateBookedEventDatOnly = false) {
    if (!selectedPatientBookedEventId) {
      return null
    }

    const bookedEventDetailResponse = await getDataWithoutParams(
      `/api/secure/user/booked-slot/details?eventId=${selectedPatientBookedEventId}&send-auxiliary-data=true`,
    )
    if (
      isCommonResponseSuccessful(bookedEventDetailResponse?.data?.code) &&
      Object.keys(bookedEventDetailResponse?.data?.data?.bookedEvent)?.length !== 0
    ) {
      const { bookedEvent, ...auxiliaryDataFromApi } = bookedEventDetailResponse.data.data
      const backendSessionRoutingDecision =
        auxiliaryDataFromApi?.sessionRoutingDecision || bookedEvent?.sessionRoutingDecision || null
      const routingContext = resolveSessionRoutingContext({
        flowType: FLOW_TYPES.mentorChamberAutoJoin,
        sessionData: {
          ...bookedEvent,
          sessionRoutingDecision: backendSessionRoutingDecision,
        },
        sessionRoutingDecision: backendSessionRoutingDecision,
      })
      const routedBookedEvent = decorateSessionWithRouting(bookedEvent, {
        flowType: FLOW_TYPES.mentorChamberAutoJoin,
        sessionRoutingDecision:
          backendSessionRoutingDecision || routingContext.sessionRoutingDecision,
      })
      const routedAuxiliaryData = {
        ...auxiliaryDataFromApi,
        sessionInterfaceId: readSessionInterfaceId(
          auxiliaryDataFromApi,
          FLOW_TYPES.mentorChamberAutoJoin,
        ),
        localParticipantIdentity: readLocalParticipantIdentity(
          auxiliaryDataFromApi,
          createBookedEventLocalParticipantIdentity(bookedEvent, bookedEvent?.userRole),
        ),
        legacyPlatformId: routingContext.legacyPlatformId,
        sessionMode: routingContext.sessionMode,
        rtcProviderResolved: routingContext.rtcProviderResolved,
        signalingProviderResolved: routingContext.signalingProviderResolved,
        sessionRoutingDecision:
          backendSessionRoutingDecision || routingContext.sessionRoutingDecision,
      }
      
      // Immediately check if this is an offline meeting and set the ref
      if (routedBookedEvent?.meetingSrc === 'offline') {
        isOfflineMeetingRef.current = true
        // Clear devices immediately for offline meetings
        setAvailableCameras([])
        setAvailableMicrophones([])
        setAvailableSpeakers([])
      } else {
        isOfflineMeetingRef.current = false
      }
      
      let enrichedBookedEvent = enrichBookedEventWithPatientData(
        routedBookedEvent,
        routedAuxiliaryData,
      )
      if (!(
        enrichedBookedEvent?.patientInfoData?.dateOfBirth ||
        enrichedBookedEvent?.patientInfo?.dateOfBirth ||
        enrichedBookedEvent?.patientDateOfBirth
      )) {
        const fetchedPatientInfo = await fetchPatientInfoById(routedBookedEvent?.patientId)
        if (fetchedPatientInfo) {
          enrichedBookedEvent = enrichBookedEventWithPatientData(routedBookedEvent, {
            ...routedAuxiliaryData,
            patientInfo: fetchedPatientInfo,
          })
        }
      }

      if (updateBookedEventDatOnly) {
        setSelectedPatientBookedEventData(enrichedBookedEvent)
      } else {
        setAuxiliaryData(routedAuxiliaryData)
        setSelectedPatientBookedEventData(enrichedBookedEvent)
      }

      return enrichedBookedEvent
    }

    return null
  }

  // Function to get event by slug (for URL-based session opening)
  async function getEventBySlug(slug) {
    try {
      const response = await getDataWithoutParams(
        `/api/secure/user/booked-slot/details?slug=${slug}&send-auxiliary-data=true`,
      )
      if (
        isCommonResponseSuccessful(response?.data?.code) &&
        Object.keys(response?.data?.data?.bookedEvent)?.length !== 0
      ) {
        const { bookedEvent, ...auxiliaryDataFromApi } = response.data.data
        const backendSessionRoutingDecision =
          auxiliaryDataFromApi?.sessionRoutingDecision || bookedEvent?.sessionRoutingDecision || null
        const routingContext = resolveSessionRoutingContext({
          flowType: FLOW_TYPES.mentorChamberAutoJoin,
          sessionData: {
            ...bookedEvent,
            sessionRoutingDecision: backendSessionRoutingDecision,
          },
          sessionRoutingDecision: backendSessionRoutingDecision,
        })
        const routedBookedEvent = decorateSessionWithRouting(bookedEvent, {
          flowType: FLOW_TYPES.mentorChamberAutoJoin,
          sessionRoutingDecision:
            backendSessionRoutingDecision || routingContext.sessionRoutingDecision,
        })
        const routedAuxiliaryData = {
          ...auxiliaryDataFromApi,
          sessionInterfaceId: readSessionInterfaceId(
            auxiliaryDataFromApi,
            FLOW_TYPES.mentorChamberAutoJoin,
          ),
          localParticipantIdentity: readLocalParticipantIdentity(
            auxiliaryDataFromApi,
            createBookedEventLocalParticipantIdentity(bookedEvent, bookedEvent?.userRole),
          ),
          legacyPlatformId: routingContext.legacyPlatformId,
          sessionMode: routingContext.sessionMode,
          rtcProviderResolved: routingContext.rtcProviderResolved,
          signalingProviderResolved: routingContext.signalingProviderResolved,
          sessionRoutingDecision:
            backendSessionRoutingDecision || routingContext.sessionRoutingDecision,
        }
        let enrichedBookedEvent = enrichBookedEventWithPatientData(
          routedBookedEvent,
          routedAuxiliaryData,
        )
        if (!(
          enrichedBookedEvent?.patientInfoData?.dateOfBirth ||
          enrichedBookedEvent?.patientInfo?.dateOfBirth ||
          enrichedBookedEvent?.patientDateOfBirth
        )) {
          const fetchedPatientInfo = await fetchPatientInfoById(routedBookedEvent?.patientId)
          if (fetchedPatientInfo) {
            enrichedBookedEvent = enrichBookedEventWithPatientData(routedBookedEvent, {
              ...routedAuxiliaryData,
              patientInfo: fetchedPatientInfo,
            })
          }
        }
        setAuxiliaryData(routedAuxiliaryData)
        setSelectedPatientBookedEventData(enrichedBookedEvent)
        setSelectedPatientBookedEventId(bookedEvent?.id)
        setPatientSelected(true)
        return bookedEvent
      }
    } catch (error) {
      console.error('Error fetching event by slug:', error)
    }
    return null
  }

  async function setup() {
    setPatientBookedSlotDetailsLoading(true)
    if (selectedPatientBookedEventId) {
      await getAndSetPatientBookedEventDetails()
    } else if (sessionSlug) {
      await getEventBySlug(sessionSlug)
    }
    setPatientBookedSlotDetailsLoading(false)
  }

  const selectedPatientId = resolveBookedEventPatientId(selectedPatientBookedEventData)
  const selectedPatientEventType = resolveBookedEventReportType(
    selectedPatientBookedEventData,
    auxiliaryData,
  )
  const selectedPatientClinicId =
    selectedPatientBookedEventData?.clinicId || chosenClinicData?.id || null
  const selectedPatientClinicBrandId =
    selectedPatientBookedEventData?.clinicBrandId || chosenClinicData?.clinicBrandId || ''

  useEffect(() => {
    const launcherContextSourceKey = selectedPatientBookedEventData?.id
      ? `mentor-chamber-event:${selectedPatientBookedEventData.id}`
      : `mentor-chamber-clinic:${clinicBrandId || 'none'}:${clinicLocationId || 'none'}`
    const rtcConflictActive = chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING

    if (selectedPatientBookedEventData?.id) {
      publishPortalVoiceLauncherContext({
        actorRole: 'mentor',
        bookedEventId: selectedPatientBookedEventData.id,
        uiSurface: 'mentor-floating-launcher',
        rtcConflict: {
          active: rtcConflictActive,
          title: 'Leave the current video call before placing a phone call',
          description:
            'Your chamber video call is already using the microphone. Leave this video call first, then place a phone call to the patient or clinic team.',
          actionLabel: 'Leave Video Call',
          helperText:
            'After leaving the current chamber video call, you can immediately use the call menu here.',
          successMessage: 'The chamber video call has ended. You can place the phone call now.',
          onResolve: leaveThisSession,
        },
      }, launcherContextSourceKey)

      return () => {
        clearPortalVoiceLauncherContext(launcherContextSourceKey)
      }
    }

    if (clinicBrandId && clinicLocationId) {
      publishPortalVoiceLauncherContext({
        actorRole: 'mentor',
        clinicBrandId,
        clinicId: clinicLocationId,
        uiSurface: 'mentor-floating-launcher',
        allowedDestinationTypes: ['support-team', 'clinic-assistant'],
        rtcConflict: {
          active: rtcConflictActive,
          title: 'Leave the chamber video call before placing a phone call',
          description:
            'Your chamber video call is already using the microphone. Leave the current video call first, then call the support team or clinic assistant.',
          actionLabel: 'Leave Video Call',
          helperText:
            'Once the chamber video call is disconnected, this phone menu will be available again right here.',
          successMessage: 'The chamber video call has ended. You can place the phone call now.',
          onResolve: leaveThisSession,
        },
      }, launcherContextSourceKey)

      return () => {
        clearPortalVoiceLauncherContext(launcherContextSourceKey)
      }
    }

    clearPortalVoiceLauncherContext(launcherContextSourceKey)

    return () => {
      clearPortalVoiceLauncherContext(launcherContextSourceKey)
    }
  }, [
    chamberScreenStateNow,
    clinicBrandId,
    clinicLocationId,
    leaveThisSession,
    selectedPatientBookedEventData?.id,
  ])

  const allowPrescribing =
    selectedPatientId &&
    (getAllRolesInBoolean().isDoctor ||
      selectedPatientEventType === allAvailableEventTypes.consultation) &&
    mentorProfileData?.allowedToPrescribe

  const allowTherapyReport =
    selectedPatientId &&
    (selectedPatientEventType === allAvailableEventTypes.therapySession ||
      // Nutrition consultations are a therapy discipline — they author a therapy report (with the
      // nutrition section set) rather than a prescription. The therapy-report editor detects the
      // discipline from the booked event and switches to the nutrition layout automatically.
      selectedPatientEventType === allAvailableEventTypes.nutritionConsultation)
  const allowAssessmentReport =
    selectedPatientId && selectedPatientEventType === allAvailableEventTypes.assessment

  const allowScreeningReport =
    selectedPatientId && selectedPatientEventType === allAvailableEventTypes.screening

  function showPaymentQrToPatient(paymentLinkWithPatientDetails) {
    if (paymentLinkWithPatientDetails?.userPaymentLink?.paymentLink) {
      showSnackBar(
        'Showing payment QR with patient details on room screen',
        200,
        serverGivenNextAction?.channel?.chamberRoomId,
      )
    } else {
      showSnackBar(
        'Showing created patient details on room screen',
        200,
        serverGivenNextAction?.channel?.chamberRoomId,
      )
    }

    sendShowImageCommandToChamberScreen(
      serverGivenNextAction?.channel?.chamberRoomId,
      'event-booking-payment-qr-with-patient-details',
      paymentLinkWithPatientDetails,
    )
  }

  // Desktop horizontal resizer - waits for refs to be ready
  useEffect(() => {
    if (isMobile) {
      return undefined
    }

    let cleanup = null
    let interval = null
    const minLeftWidth = 200
    const minRightWidth = 400

    // Check if refs are ready
    const checkRefs = () => {
      const dragger = refLeft?.current
      const leftPanel = refLeftPanel?.current
      const rightPanel = refBox?.current

      if (!dragger || !leftPanel || !rightPanel) {
        return false
      }

      // Check if resizer is visible (not hidden on mobile)
      const resizerStyles = window.getComputedStyle(dragger)
      const isVisible = resizerStyles.display !== 'none'

      if (!isVisible) {
        return false
      }

      return true
    }

    function setupResizer() {
      const dragger = refLeft?.current
      const leftPanel = refLeftPanel?.current
      const rightPanel = refBox?.current

      if (!dragger || !leftPanel || !rightPanel) {
        return null
      }

      let startX = 0
      let startLeftWidth = 0
      let startRightWidth = 0
      let isDragging = false

      const applyPanelWidths = (leftWidth, rightWidth) => {
        leftPanel.style.width = `${leftWidth}px`
        leftPanel.style.flexShrink = '0'
        leftPanel.style.flexGrow = '0'
        leftPanel.style.flexBasis = `${leftWidth}px`

        rightPanel.style.width = `${rightWidth}px`
        rightPanel.style.flexShrink = '0'
        rightPanel.style.flexGrow = '0'
        rightPanel.style.flexBasis = `${rightWidth}px`
      }

      /**
       * Get clientX from either mouse or touch event
       */
      const getClientX = (e) => {
        return e.touches ? e.touches[0].clientX : e.clientX
      }

      const getAvailableWidth = () => {
        const separatorWidth = dragger.getBoundingClientRect().width || dragger.offsetWidth || 0
        const containerWidth =
          dragger.parentElement?.getBoundingClientRect().width ||
          leftPanel.offsetWidth + rightPanel.offsetWidth + separatorWidth

        return Math.max(minLeftWidth + minRightWidth, containerWidth - separatorWidth)
      }

      const getNextWidths = (deltaX) => {
        const availableWidth = getAvailableWidth()
        const minDelta = minLeftWidth - startLeftWidth
        const maxDelta = startRightWidth - minRightWidth
        const boundedDelta = Math.min(maxDelta, Math.max(minDelta, deltaX))
        const nextLeftWidth = Math.min(
          availableWidth - minRightWidth,
          Math.max(minLeftWidth, startLeftWidth + boundedDelta),
        )
        const nextRightWidth = Math.max(minRightWidth, availableWidth - nextLeftWidth)

        return { nextLeftWidth, nextRightWidth }
      }

      /**
       * Handle movement during drag (works for both mouse and touch)
       * Calculates new panel widths and applies them in real-time
       */
      const handleMove = (e) => {
        if (!isDragging) return

        if (e.touches) {
          e.preventDefault()
        }

        const currentX = getClientX(e)
        const deltaX = currentX - startX
        const { nextLeftWidth, nextRightWidth } = getNextWidths(deltaX)
        applyPanelWidths(nextLeftWidth, nextRightWidth)
      }

      /**
       * Handle end of drag - clean up event listeners and reset styles
       */
      const handleEnd = () => {
        isDragging = false
        document.removeEventListener('mousemove', handleMove)
        document.removeEventListener('mouseup', handleEnd)
        document.removeEventListener('touchmove', handleMove)
        document.removeEventListener('touchend', handleEnd)
        document.removeEventListener('touchcancel', handleEnd)
        window.removeEventListener('blur', handleEnd)
        document.body.style.cursor = ''
        document.body.style.userSelect = ''
        document.body.style.touchAction = ''
      }

      /**
       * Handle start of drag (works for both mouse and touch)
       */
      const handleStart = (e) => {
        if (!e.touches && e.button !== undefined && e.button !== 0) {
          return
        }

        e.preventDefault()
        e.stopPropagation()

        // Store initial state
        startX = getClientX(e)
        startLeftWidth = leftPanel.offsetWidth
        startRightWidth = rightPanel.offsetWidth
        isDragging = true

        // Set drag cursor and disable text selection
        document.body.style.cursor = 'col-resize'
        document.body.style.userSelect = 'none'
        document.body.style.touchAction = 'none' // Prevent scrolling while dragging

        // Add document-level event listeners for smooth dragging
        if (e.touches) {
          // Touch events
          document.addEventListener('touchmove', handleMove, { passive: false })
          document.addEventListener('touchend', handleEnd)
          document.addEventListener('touchcancel', handleEnd)
        } else {
          // Mouse events
          document.addEventListener('mousemove', handleMove)
          document.addEventListener('mouseup', handleEnd)
        }

        window.addEventListener('blur', handleEnd)
      }

      // Attach event listeners for both mouse and touch
      dragger.addEventListener('mousedown', handleStart, true) // Use capture phase
      dragger.addEventListener('touchstart', handleStart, { passive: false, capture: true })

      // Return cleanup function
      return () => {
        isDragging = false
        dragger.removeEventListener('mousedown', handleStart, true)
        dragger.removeEventListener('touchstart', handleStart, true)
        document.removeEventListener('mousemove', handleMove)
        document.removeEventListener('mouseup', handleEnd)
        document.removeEventListener('touchmove', handleMove)
        document.removeEventListener('touchend', handleEnd)
        document.removeEventListener('touchcancel', handleEnd)
        window.removeEventListener('blur', handleEnd)
        document.body.style.cursor = ''
        document.body.style.userSelect = ''
        document.body.style.touchAction = ''
      }
    }

    // Wait for refs to be ready
    if (!checkRefs()) {
      // Set up interval to check periodically until refs are ready
      interval = setInterval(() => {
        if (checkRefs()) {
          clearInterval(interval)
          cleanup = setupResizer()
        }
      }, 100)
    } else {
      // Refs are ready, set up immediately
      cleanup = setupResizer()
    }

    return () => {
      if (interval) {
        clearInterval(interval)
      }
      if (cleanup) {
        cleanup()
      }
    }
  }, [chamberScreenStateNow, isMobile])

  useEffect(() => {
    // CRITICAL GUARD: Don't set menu options or selectedOptionPatientMenu if we're leaving a session
    // This prevents the menu from being re-selected after we've cleared it in finallyCloseBookedEvent()
    // 
    // IMPORTANT: This guard MUST be checked FIRST, before any other logic
    // If this guard is removed or moved, the header will persist after leaving a session
    // 
    // The guard works by checking isLeavingSessionRef.current, which is set to true
    // in finallyCloseBookedEvent() BEFORE clearing selectedOptionPatientMenu
    if (isLeavingSessionRef.current) {
      return
    }
    
    // Additional defensive check: If selectedOptionPatientMenu was just cleared (undefined/null)
    // and we're not in a normal session setup flow, don't auto-select
    // This is a secondary guard in case isLeavingSessionRef gets reset too early
    if (!selectedOptionPatientMenu && !selectedPatientBookedEventData) {
      // Both are cleared - likely we're leaving, don't set menu
      return
    }
    
    if (selectedPatientBookedEventData) {
      const menu = []
      if (allowPrescribing) {
        menu.unshift({ label: 'Vitals', id: 'vitals' })
        menu.unshift({ label: 'Patient History', id: 'patient_history' })
        menu.unshift({ label: 'Prescription', id: 'prescription' })
      }
      if (allowTherapyReport) {
        menu.unshift({ label: 'Patient History', id: 'patient_history' })
        // Discipline-aware label: nutrition events surface as "Nutrition Consultation Report"
        // even though the underlying menu id stays `therapy_report` (same editor).
        menu.unshift({
          label: getTherapyReportShortLabelFromEntity(selectedPatientBookedEventData),
          id: 'therapy_report',
        })
      }
      if (allowAssessmentReport) {
        menu.unshift({ label: 'Patient History', id: 'patient_history' })
        menu.unshift({ label: 'Assessment Report', id: 'assessment_report' })
      }
      if (allowScreeningReport) {
        menu.unshift({ label: 'Screening Report', id: 'screening_report' })
      }
      // Assessments tab on prescription/therapy/screening sessions (not on Assessment Report page — that page has its own launcher)
      if (allowPrescribing || allowTherapyReport || allowScreeningReport) {
        menu.push({ label: 'Assessments', id: 'assessments' })
      }
      setPatientMenuOptions(menu)
      if (menu.length === 0) {
        if (selectedOptionPatientMenu) {
          setSelectedOptionPatientMenu(undefined)
        }
        return
      }

      const hasValidSelectedOption = menu.some((menuItem) => menuItem?.id === selectedOptionPatientMenu)
      if (!hasValidSelectedOption) {
        setSelectedOptionPatientMenu(menu[0]?.id)
      }
      return
    }

    setPatientMenuOptions([])
    if (selectedOptionPatientMenu) {
      setSelectedOptionPatientMenu(undefined)
    }
  }, [selectedPatientBookedEventData, selectedOptionPatientMenu, allowPrescribing, allowTherapyReport, allowAssessmentReport, allowScreeningReport])

  useEffect(() => {
    setup()
  }, [selectedPatientBookedEventId])

  useEffect(() => {
    if (!selectedPatientBookedEventData?.id || !selectedPatientId) return

    const hasUsablePatientDob = Boolean(
      selectedPatientBookedEventData?.patientInfoData?.dateOfBirth ||
      selectedPatientBookedEventData?.patientInfo?.dateOfBirth ||
      selectedPatientBookedEventData?.patientDateOfBirth,
    )

    if (hasUsablePatientDob) return

    const enriched = enrichBookedEventWithPatientData(selectedPatientBookedEventData)
    if (enriched !== selectedPatientBookedEventData) {
      setSelectedPatientBookedEventData(enriched)
    }
  }, [bookedSlotsInDay, enrichBookedEventWithPatientData, selectedPatientBookedEventData, selectedPatientId])

  // Handle URL-based session opening (when URL contains /l/<slug>)
  useEffect(() => {
    // Don't open session if we're leaving
    if (isLeavingSessionRef.current) {
      return
    }
    
    // Don't open session if we just removed this slug
    if (sessionSlug && lastRemovedSlugRef.current === sessionSlug) {
      return
    }
    
    // Check if the current URL actually contains the slug (React Router params might be stale)
    const currentUrlPath = window.location.pathname
    const expectedSlugPath = sessionSlug ? `/l/${sessionSlug}` : ''
    if (sessionSlug && !currentUrlPath.includes(expectedSlugPath)) {
      return
    }
    
    // Use requestAnimationFrame to ensure this runs after render, not during
    if (sessionSlug && clinicBrandId && clinicLocationId && !selectedPatientBookedEventData && !isFetchingEventBySlugRef.current) {
      isFetchingEventBySlugRef.current = true
      requestAnimationFrame(() => {
        // Double-check we're not leaving before fetching
        if (isLeavingSessionRef.current || lastRemovedSlugRef.current === sessionSlug) {
          isFetchingEventBySlugRef.current = false
          return
        }
        
        // Triple-check URL still contains the slug
        const currentUrlPathCheck = window.location.pathname
        if (!currentUrlPathCheck.includes(`/l/${sessionSlug}`)) {
          isFetchingEventBySlugRef.current = false
          return
        }
        
        // URL has a session slug, fetch and open that session
        getEventBySlug(sessionSlug).finally(() => {
          isFetchingEventBySlugRef.current = false
        })
      })
    }
  }, [sessionSlug, clinicBrandId, clinicLocationId, selectedPatientBookedEventData, location.pathname])

  // Update URL when session is opened
  useEffect(() => {
    // Don't update URL if we're in the process of leaving
    if (isLeavingSessionRef.current) {
      return
    }
    
    // Don't update URL if selectedPatientBookedEventData is null/undefined (we've left the session)
    if (!selectedPatientBookedEventData) {
      return
    }
    
    // Get clinicBrandId from props or from chosenClinicData
    const effectiveClinicBrandId = clinicBrandId || chosenClinicData?.clinicBrandId
    
    // Check if current URL is the base path (no /l/) - if so, don't add session slug
    // Use window.location to get the absolute latest pathname (React Router location might be stale)
    const currentPath = window.location.pathname
    const basePath = `/mentor-home/join-chamber-room/${effectiveClinicBrandId}/${clinicLocationId}`
    
    // If we're on the base path (no /l/), don't add session slug - we've left the session
    if (currentPath === basePath || (!currentPath.includes('/l/') && effectiveClinicBrandId && clinicLocationId)) {
      return
    }
    
    // Don't add a slug that was just removed
    if (selectedPatientBookedEventData?.slug && lastRemovedSlugRef.current === selectedPatientBookedEventData.slug) {
      return
    }
    
    if (selectedPatientBookedEventData?.slug && effectiveClinicBrandId && clinicLocationId) {
      // Use requestAnimationFrame to ensure this runs after render, not during
      requestAnimationFrame(() => {
        // Triple-check we're not leaving and data still exists before updating URL
        if (isLeavingSessionRef.current || !selectedPatientBookedEventData) {
          return
        }
        
        // Don't re-add a slug we just removed (check again in case it changed)
        if (lastRemovedSlugRef.current === selectedPatientBookedEventData.slug) {
          return
        }
        
        // Double-check current path hasn't changed to base path
        const currentPathCheck = window.location.pathname
        const basePathCheck = `/mentor-home/join-chamber-room/${effectiveClinicBrandId}/${clinicLocationId}`
        if (currentPathCheck === basePathCheck || !currentPathCheck.includes('/l/')) {
          return
        }
        
        const sessionPath = `${basePathCheck}/l/${selectedPatientBookedEventData.slug}`
        
        // Only update URL if it doesn't already have the session slug
        if (!currentPathCheck.includes(`/l/${selectedPatientBookedEventData.slug}`)) {
          navigate(sessionPath, { replace: true })
          // Clear the removed slug ref since we're adding it back
          lastRemovedSlugRef.current = null
        }
      })
    }
  }, [selectedPatientBookedEventData, selectedPatientBookedEventData?.slug, clinicBrandId, clinicLocationId, chosenClinicData?.clinicBrandId, navigate, location.pathname])
  
  // SIMPLIFIED DESIGN: Parent component is the SINGLE SOURCE OF TRUTH for header state
  // Child components should NOT set headers - they just render their content
  // Parent manages header based on selectedOptionPatientMenu state
  const reportModes = ['prescription', 'therapy_report', 'screening_report', 'assessment_report']
  useEffect(() => {
    const isInReportMode = selectedOptionPatientMenu && reportModes.includes(selectedOptionPatientMenu)
    const hasValidEventData = selectedPatientBookedEventData?.id && selectedPatientId
    
    // Map report modes to their flowId values
    const flowIdMap = {
      'prescription': 'prescription-making-page',
      'therapy_report': 'therapy-report-making-page',
      'screening_report': 'screening-report-making-page',
      'assessment_report': 'assessment-report-making-page',
    }
    
    if (isInReportMode && hasValidEventData) {
      // We're in a report mode with valid data - set the appropriate header
      const flowId = flowIdMap[selectedOptionPatientMenu]
      if (flowId) {
        setFlowId(flowId)
        setButtonTopOffset(50)
      }
    } else {
      // Not in report mode or no valid event data - show calendar header
      // This should run immediately when selectedOptionPatientMenu is cleared
      setFlowId('mentor-portal')
      setButtonTopOffset(0)
    }
  }, [selectedOptionPatientMenu, selectedPatientBookedEventData?.id, selectedPatientId, setFlowId, setButtonTopOffset])
  
  // Reconnect to chamber room when returning from live session page
  useEffect(() => {
    const returnFromLiveSession = sessionStorage.getItem('returnFromLiveSession')
    const storedChamberRoomRtcProps = sessionStorage.getItem('chamberRoomRtcProps')
    const storedChamberRoomRtmProps = sessionStorage.getItem('chamberRoomRtmProps')
    const storedChannelName = sessionStorage.getItem('chamberRoomChannelName')
    const storedChamberName = sessionStorage.getItem('chamberRoomChamberName')
    const storedLocalParticipantIdentity = sessionStorage.getItem(
      'chamberRoomLocalParticipantIdentity',
    )
    
    if (returnFromLiveSession === 'true' && storedChamberRoomRtcProps && storedChannelName) {
      try {
        const rtcProps = JSON.parse(storedChamberRoomRtcProps)
        const rtmProps = JSON.parse(storedChamberRoomRtmProps)
        const normalizedRtcProps = {
          ...rtcProps,
          layout: AGORA_RTC_LAYOUTS.pin,
        }
        delete normalizedRtcProps.CustomVideoPlaceholder

        // Restore chamber room session
        setChamberScreenStateNow(CHAMBER_SCREEN_STATES.SESSION_RUNNING)
        setJoinedChamberName(storedChamberName || 'Chamber Room')
        setJoinedChannelName(storedChannelName)
        setAgoraRtcProps(normalizedRtcProps)
        setAgoraRtmProps(rtmProps)
        setChamberLocalParticipantIdentity(
          storedLocalParticipantIdentity ? JSON.parse(storedLocalParticipantIdentity) : null,
        )
        
        // Clear stored data
        sessionStorage.removeItem('returnFromLiveSession')
        sessionStorage.removeItem('chamberRoomRtcProps')
        sessionStorage.removeItem('chamberRoomRtmProps')
        sessionStorage.removeItem('chamberRoomChannelName')
        sessionStorage.removeItem('chamberRoomChamberName')
        sessionStorage.removeItem('chamberRoomLocalParticipantIdentity')
        sessionStorage.removeItem('chamberRoomUrl')
      } catch (error) {
        console.error('Error reconnecting to chamber room:', error)
        // If reconnection fails, try to get next action from server
        getAndHandleNextAction()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const refBox = useRef(null) // Right panel (calendar/interaction part)
  const refLeft = useRef(null) // Resizer separator
  const refVideoContainer = useRef(null) // Left panel (video container)
  // The desktop resizer resizes whichever left panel is mounted: the lobby in IDLING, the video
  // in SESSION_RUNNING. refVideoContainer is only set in the SESSION_RUNNING branch, so the
  // resizer targets this ref instead (attached to both branches) — otherwise drag is dead in the
  // IDLING placeholder because its left panel is null.
  const refLeftPanel = useRef(null)
  const refMobileResizer = useRef(null) // Mobile vertical resizer
  
  // Mobile scroll state for floating video
  const [isScrolledDown, setIsScrolledDown] = useState(false)
  const calendarScrollContainerRef = useRef(null)
  const videoContainerRef = useRef(null)
  const lastScrollTop = useRef(0)
  
  // Mobile actions menu state
  const [mobileActionsMenuAnchor, setMobileActionsMenuAnchor] = useState(null)
  const mobileActionsMenuOpen = Boolean(mobileActionsMenuAnchor)
  
  // Video container ref (used for finding video elements)
  const videoFullscreenRef = useRef(null)
  const mentorChamberProviderInitialConfig = useMemo(
    () => ({
      rtcProps: agoraRtcProps || {},
      rtmProps: agoraRtmProps || null,
    }),
    [agoraRtcProps, agoraRtmProps],
  )
  const mentorChamberShell = useRtcSessionShell({
    providerId: RTC_PROVIDERS.agora,
    sessionKey: `${agoraRtcProps?.channel || ''}:${agoraRtcProps?.uid || ''}`,
    surfacePolicyId: 'mentor-chamber',
    localParticipantIdentity: chamberLocalParticipantIdentity,
    providerInitialConfig: mentorChamberProviderInitialConfig,
  })
  const mentorChamberSnapshot = useMemo(
    () =>
      buildChamberShellSnapshot({
        controllerState: mentorChamberShell,
      }),
    [
      mentorChamberShell.dominantParticipantId,
      mentorChamberShell.participants,
      mentorChamberShell.visibleParticipants,
    ],
  )
  const debugUidToUsernameMap = mentorChamberSnapshot.usernameMap
  const debugRemoteUsers = mentorChamberSnapshot.remoteUsers
  const remoteParticipantCount = mentorChamberSnapshot.remoteParticipantCount
  const getFocusMenuUsers = mentorChamberSnapshot.focusMenuParticipants
  const effectiveStageFocusUid = mentorChamberSnapshot.activeSpotlightUid
  const resolvedMentorAgoraRtcProps = useMemo(() => {
    if (!agoraRtcProps?.channel || !agoraRtcProps?.appId) {
      return agoraRtcProps
    }

    return {
      ...agoraRtcProps,
      layout: AGORA_RTC_LAYOUTS.pin,
    }
  }, [
    agoraRtcProps,
  ])

  const getProfilePictureUrl = (profilePicId) => {
    if (!profilePicId) return null

    if (profilePicId.startsWith('http://') || profilePicId.startsWith('https://')) {
      return profilePicId
    }

    return `https://media.aumhum.com/images/prod/${profilePicId}`
  }

  const getInitials = (name) => {
    if (!name || name === 'Loading...' || name === 'You' || name === 'Guest') {
      return 'U'
    }

    const trimmedName = name.trim()
    const words = trimmedName.split(/\s+/).filter((w) => w.length > 0)

    if (words.length > 1) {
      return (words[0][0] + words[words.length - 1][0]).toUpperCase()
    }
    if (trimmedName.length > 0) {
      return trimmedName.charAt(0).toUpperCase()
    }

    return 'U'
  }

  const [focusMenuAnchor, setFocusMenuAnchor] = useState(null)
  const focusMenuOpen = Boolean(focusMenuAnchor)
  const allowChamberManualFocus =
    mentorChamberShell?.surfacePolicy?.allowManualFocus !== false

  const desktopVideoUtilityButtonSx = {
    backgroundColor: 'rgba(255, 255, 255, 0.94)',
    backdropFilter: 'blur(14px) saturate(180%)',
    WebkitBackdropFilter: 'blur(14px) saturate(180%)',
    border: '1px solid rgba(196, 181, 253, 0.7)',
    color: '#5b21b6',
    width: '42px',
    height: '42px',
    boxShadow: '0 14px 28px rgba(91, 33, 182, 0.12)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 1)',
      borderColor: 'rgba(167, 139, 250, 0.92)',
      transform: 'translateY(-1px)',
      boxShadow: '0 18px 34px rgba(91, 33, 182, 0.18)',
    },
    transition: 'all 0.2s ease',
  }

  useEffect(() => {
    if (chamberScreenStateNow !== CHAMBER_SCREEN_STATES.SESSION_RUNNING) {
      setEmrVideoCallActivity(false, { source: 'mentor-chamber-room' })
      return undefined
    }

    const publishVideoCallActivity = () => {
      setEmrVideoCallActivity(true, {
        source: 'mentor-chamber-room',
        chamberRoomId,
        channelName: joinedChannelName,
        chamberName: joinedChamberName,
        remoteParticipantCount,
      })
    }

    publishVideoCallActivity()
    const intervalId = setInterval(publishVideoCallActivity, 15000)

    return () => {
      clearInterval(intervalId)
      setEmrVideoCallActivity(false, { source: 'mentor-chamber-room' })
    }
  }, [chamberRoomId, chamberScreenStateNow, joinedChamberName, joinedChannelName, remoteParticipantCount])


  // Compute video container styles for mobile floating
  const videoContainerSx = useMemo(() => {
    const baseStyles = {
      flex: { xs: '1 1 0', md: '1 1 0' }, // Take full space on mobile
      flexShrink: { xs: 0, md: 1 },
      flexBasis: { xs: '100%', md: 0 }, // Full width/height on mobile
      display: 'flex',
      flexDirection: 'column',
      background: 'linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(241, 245, 249, 0.98) 100%)',
      borderRadius: '0',
      overflow: { xs: 'hidden', md: 'hidden' }, // Hidden on both to prevent scroll
      overflowY: { xs: 'hidden', md: 'hidden' }, // Hidden vertical scroll on both
      position: {
        xs: 'relative', // Always relative on mobile for full height
        md: 'relative'
      },
      transition: 'all 0.3s ease',
      boxShadow: {
        xs: 'none', // No shadow on mobile
        md: 'none'
      },
    }

    // Mobile: Switch between portrait (full height) and landscape (full width) modes
    if (isMobile) {
      if (isVideoLandscape) {
        // Landscape mode: Full width (100vw), height calculated from 16:9 aspect ratio
        // Height = width * (9/16) = 100vw * 0.5625 = 56.25vw
      return {
        ...baseStyles,
          width: '100vw', // Full viewport width
          maxWidth: '100vw',
          height: '56.25vw', // 16:9 aspect ratio (9/16 = 0.5625)
          minHeight: 0,
          maxHeight: '100dvh', // Don't exceed the visible viewport height
          flex: '0 0 auto', // Don't grow/shrink
          margin: '0 auto',
          alignSelf: 'center',
        }
      } else {
        // Portrait mode: Full height. Use dvh so the video (and its
        // bottom-anchored controls) fits the visible viewport above the
        // mobile browser's bottom toolbar instead of overshooting with 100vh.
        return {
          ...baseStyles,
          minWidth: '100%',
          minHeight: '100dvh',
          height: '100dvh',
          maxHeight: '100dvh',
        width: '100%',
        }
      }
    }

    // Desktop: Return base styles
    return {
      ...baseStyles,
      minWidth: '400px',
      minHeight: 0,
      height: '100%',
      maxHeight: '100%',
      width: undefined,
    }
  }, [isMobile, isVideoLandscape])

  // Detect mobile screen size
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }
    
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  // Declutter the mobile chamber video screen: the global DocSide help tab and its
  // "Call support" widget eat the limited canvas during a call (same reasoning the
  // helper already applies to kiosk/display surfaces). Hide it while this page is
  // mounted on mobile and restore it on unmount / when switching back to desktop.
  useEffect(() => {
    if (!isMobile) {
      setShowDocSide(true)
      return undefined
    }
    setShowDocSide(false)
    return () => setShowDocSide(true)
  }, [isMobile, setShowDocSide])

  // Never leave the mobile notes/Rx sheet stranded once the patient context is gone
  // (session ended, patient deselected) or after switching back to desktop.
  useEffect(() => {
    if (!patientSelected || !isMobile) {
      setMobileReportSheetOpen(false)
      setIsVideoLandscape(false)
    }
  }, [patientSelected, isMobile])

  // Reset the picture-in-picture tile to its default spot each time the report sheet closes, so the
  // video always returns to full-screen cleanly and the PIP starts at the top next time it opens.
  useEffect(() => {
    if (!mobileReportSheetOpen) setPipPos(null)
  }, [mobileReportSheetOpen])

  // Detect the on-screen keyboard via visualViewport. The keyboard is "up" only when the viewport
  // has shrunk meaningfully AND an editable field is focused — then we hide the floating dock so it
  // doesn't sit over the input. The focus check is essential: the mobile browser address bar
  // collapsing/expanding (and desktop devtools/zoom) shrink the viewport the same way, and since we
  // track the largest height ever seen as the baseline, normal viewing would otherwise be read as
  // "keyboard open" and keep the dock hidden — so it only appeared intermittently.
  useEffect(() => {
    if (!isMobile) return undefined
    const vv = typeof window !== 'undefined' ? window.visualViewport : null
    if (!vv) return undefined
    let baseline = vv.height
    const isEditableFocused = () => {
      const el = typeof document !== 'undefined' ? document.activeElement : null
      if (!el) return false
      const tag = el.tagName
      return tag === 'INPUT' || tag === 'TEXTAREA' || el.isContentEditable === true
    }
    const update = () => {
      baseline = Math.max(baseline, vv.height)
      setKeyboardOpen(isEditableFocused() && baseline - vv.height > 150)
    }
    update()
    vv.addEventListener('resize', update)
    // focus/blur don't always fire a viewport resize, and a blur must clear the flag promptly
    window.addEventListener('focusin', update)
    window.addEventListener('focusout', update)
    return () => {
      vv.removeEventListener('resize', update)
      window.removeEventListener('focusin', update)
      window.removeEventListener('focusout', update)
    }
  }, [isMobile])

  // Pin the floating chamber controls to the VISIBLE (visual) viewport on mobile. `position: fixed`
  // anchors to the layout viewport, but the page is sized to 100dvh with no scroll, so the browser's
  // toolbar stays shown and the visual viewport is shorter — bottom-anchored controls then land
  // behind/below the toolbar (in the DOM but off-screen; only a zoom/resize revealed them). We expose
  // the gap above/below the visible area as CSS vars and add them to the controls' top/bottom offsets.
  // When there's no gap (no toolbar / fixed already tracks the visual viewport) the vars are 0 → no-op.
  useEffect(() => {
    if (!isMobile) return undefined
    const vv = typeof window !== 'undefined' ? window.visualViewport : null
    const root = typeof document !== 'undefined' ? document.documentElement : null
    if (!vv || !root) return undefined
    const apply = () => {
      const bottomInset = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop))
      const topInset = Math.max(0, Math.round(vv.offsetTop))
      root.style.setProperty('--chamber-vv-bottom-inset', `${bottomInset}px`)
      root.style.setProperty('--chamber-vv-top-inset', `${topInset}px`)
    }
    apply()
    vv.addEventListener('resize', apply)
    vv.addEventListener('scroll', apply)
    window.addEventListener('resize', apply)
    return () => {
      vv.removeEventListener('resize', apply)
      vv.removeEventListener('scroll', apply)
      window.removeEventListener('resize', apply)
      root.style.removeProperty('--chamber-vv-bottom-inset')
      root.style.removeProperty('--chamber-vv-top-inset')
    }
  }, [isMobile])

  // While the PIP is showing, follow the incoming (remote) video's orientation so a landscape feed
  // gets a landscape tile. Reads the largest non-self <video> in the stage; polls lightly since the
  // stream can connect/rotate after the sheet opens.
  useEffect(() => {
    if (!isMobile || !mobileReportSheetOpen) return undefined
    const frame = refVideoContainer.current
    if (!frame) return undefined
    const check = () => {
      const videos = Array.from(frame.querySelectorAll('video')).filter(
        (v) => !v.closest('.shared-video-layout__self-preview') && v.videoWidth > 0,
      )
      if (videos.length === 0) return
      const main = videos.reduce((a, b) =>
        b.videoWidth * b.videoHeight > a.videoWidth * a.videoHeight ? b : a,
      )
      setPipLandscape(main.videoWidth >= main.videoHeight)
    }
    check()
    const id = setInterval(check, 1500)
    return () => clearInterval(id)
  }, [isMobile, mobileReportSheetOpen])

  // Handle scroll detection for mobile floating video
  useEffect(() => {
    if (!isMobile || chamberScreenStateNow !== CHAMBER_SCREEN_STATES.SESSION_RUNNING) {
      setIsScrolledDown(false)
      return
    }

    const handleScroll = () => {
      if (!calendarScrollContainerRef.current) return
      
      const scrollTop = calendarScrollContainerRef.current.scrollTop
      const scrollThreshold = 100 // Start floating after 100px scroll
      
      if (scrollTop > scrollThreshold && scrollTop > lastScrollTop.current) {
        // Scrolling down
        setIsScrolledDown(true)
      } else if (scrollTop <= scrollThreshold || scrollTop < lastScrollTop.current) {
        // Scrolling up or near top
        setIsScrolledDown(false)
      }
      
      lastScrollTop.current = scrollTop
    }

    const container = calendarScrollContainerRef.current
    if (container) {
      container.addEventListener('scroll', handleScroll, { passive: true })
      return () => {
        container.removeEventListener('scroll', handleScroll)
      }
    }
  }, [isMobile, chamberScreenStateNow, selectedTab])
  
  // Mobile vertical resizer logic
  useEffect(() => {
    if (!isMobile || chamberScreenStateNow !== CHAMBER_SCREEN_STATES.SESSION_RUNNING) return
    
    const resizer = refMobileResizer.current
    const videoContainer = videoContainerRef.current
    const calendarContainer = calendarScrollContainerRef.current
    
    if (!resizer || !videoContainer || !calendarContainer) return
    
    let startY = 0
    let startVideoHeight = 0
    
    const handleTouchMove = (e) => {
      e.preventDefault()
      const deltaY = e.touches[0].clientY - startY
      
      // Calculate new heights with minimum constraints
      const newVideoHeight = Math.max(150, startVideoHeight + deltaY)
      
      // Apply new heights
      videoContainer.style.height = `${newVideoHeight}px`
      videoContainer.style.maxHeight = `${newVideoHeight}px`
      calendarContainer.style.height = `calc(100% - ${newVideoHeight}px - 8px)` // 8px for resizer
    }
    
    const handleMouseMove = (e) => {
      const deltaY = e.clientY - startY
      
      // Calculate new heights with minimum constraints
      const newVideoHeight = Math.max(150, startVideoHeight + deltaY)
      
      // Apply new heights
      videoContainer.style.height = `${newVideoHeight}px`
      videoContainer.style.maxHeight = `${newVideoHeight}px`
      calendarContainer.style.height = `calc(100% - ${newVideoHeight}px - 8px)` // 8px for resizer
    }
    
    const handleEnd = () => {
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleEnd)
      document.removeEventListener('touchmove', handleTouchMove, { passive: false })
      document.removeEventListener('touchend', handleEnd)
      document.body.style.cursor = ''
      document.body.style.userSelect = ''
    }
    
    const handleStart = (e) => {
      e.preventDefault()
      
      // Get initial state
      const clientY = e.type === 'touchstart' ? e.touches[0].clientY : e.clientY
      startY = clientY
      startVideoHeight = videoContainer.offsetHeight
      
      // Set drag cursor and disable text selection
      document.body.style.cursor = 'row-resize'
      document.body.style.userSelect = 'none'
      
      // Add document-level event listeners
      if (e.type === 'touchstart') {
        document.addEventListener('touchmove', handleTouchMove, { passive: false })
        document.addEventListener('touchend', handleEnd)
      } else {
        document.addEventListener('mousemove', handleMouseMove)
        document.addEventListener('mouseup', handleEnd)
      }
    }
    
    resizer.addEventListener('mousedown', handleStart)
    resizer.addEventListener('touchstart', handleStart, { passive: false })
    
    return () => {
      resizer.removeEventListener('mousedown', handleStart)
      resizer.removeEventListener('touchstart', handleStart)
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleEnd)
      document.removeEventListener('touchmove', handleTouchMove)
      document.removeEventListener('touchend', handleEnd)
    }
  }, [isMobile, chamberScreenStateNow])

  const handleAssessmentReportSaved = useCallback(() => {
    getAndSetPatientBookedEventDetails?.()
    const pid = selectedPatientId
    const refId = selectedPatientBookedEventData?.id
    if (pid != null && refId != null) {
      store.dispatch(getPastPatientReports({ patientId: pid, referenceBookedEventId: refId }))
    }
  }, [selectedPatientId, selectedPatientBookedEventData?.id, getAndSetPatientBookedEventDetails])

  const hasExistingPreScreeningStep = useCallback((bookedEvent) => {
    return Boolean(
      bookedEvent?.previousSteps?.some(
        (step) => step?.refType === allAvailableEventTypes.screening && step?.refId,
      ),
    )
  }, [])

  const canBookPreScreeningFromConsultation = useCallback((bookedEvent) => {
    if (
      !getAllRolesInBoolean().isScreener ||
      !screenerCalendarAccess?.canBookPreScreeningAppointment ||
      bookedEvent?.eventType !== allAvailableEventTypes.consultation ||
      bookedEvent?.mentorId === mentorProfileData?.id ||
      hasExistingPreScreeningStep(bookedEvent)
    ) {
      return false
    }
    const bookableDoctorIds = screenerCalendarAccess?.preScreeningBookableDoctorIds || []
    return bookableDoctorIds.includes(bookedEvent?.mentorId)
  }, [
    hasExistingPreScreeningStep,
    mentorProfileData?.id,
    screenerCalendarAccess?.canBookPreScreeningAppointment,
    screenerCalendarAccess?.preScreeningBookableDoctorIds,
  ])

  const handleDoctorConsultationCalendarEventClick = useCallback((bookedEvent) => {
    if (canBookPreScreeningFromConsultation(bookedEvent)) {
      setScreeningBookingCandidate(bookedEvent)
      return
    }
    if (hasExistingPreScreeningStep(bookedEvent)) {
      toast.info('This consultation already has a screening session linked.')
      return
    }
    toast.info('Doctor consultation calendar events are view-only from screening check-in.')
  }, [canBookPreScreeningFromConsultation, hasExistingPreScreeningStep])

  const handleBookPreScreeningFromConsultation = useCallback(async () => {
    if (!screeningBookingCandidate) return
    setIsBookingScreeningFromConsultation(true)
    try {
      const response = await putCPDataWithoutParams(
        '/api/secure/teacher/screener-access/screening/book',
        {
          ...screeningBookingCandidate,
          clinicBrandId: screeningBookingCandidate?.clinicBrandId || effectiveCalendarClinicBrandId,
          clinicId: screeningBookingCandidate?.clinicId || effectiveCalendarClinicLocationId,
          apiParam: 'booked-event-info',
        },
      )
      if (
        response?.status === 200 &&
        isCommonResponseSuccessful(response?.data?.code) &&
        response?.data?.data?.screening
      ) {
        toast.success(
          `Screening booked for ${response?.data?.data?.screening?.userName} with ${response?.data?.data?.screening?.mentorName}`,
        )
        setScreeningBookingCandidate(null)
        if (calendarRef.current?.refresh) {
          calendarRef.current.refresh()
        }
      } else {
        toast.error(response?.data?.message || 'Error booking screening')
      }
    } catch (error) {
      console.error('Error booking screening from consultation calendar:', error)
      toast.error('Error booking screening')
    } finally {
      setIsBookingScreeningFromConsultation(false)
    }
  }, [
    effectiveCalendarClinicBrandId,
    effectiveCalendarClinicLocationId,
    screeningBookingCandidate,
  ])

  const shouldShowAutoConnectPauseDialog =
    autoConnectPauseDialogOpen &&
    autoConnectRemainingMs > 0 &&
    chamberScreenStateNow === CHAMBER_SCREEN_STATES.IDLING

  // Next appointment summary for the mobile pull-up peek. Booked slots carry an "HH:MM"
  // start time (slotStartTime / startTime); on the current day we prefer the next slot
  // that hasn't started yet, otherwise the earliest one for the selected date.
  // Clinic timezone for the appointment list. Booked-event times arrive as UTC; we display them
  // in the clinic's offset (the browser's offset when the doctor is on-site), falling back to IST
  // (+05:30) — matching the rest of the booking surfaces. dayjs(rawUtc).format() alone would treat
  // the UTC wall-clock as local time and show the wrong hour. Declared before the appointments
  // state because appointmentsDateKey/toClinicDayjs depend on it.
  const clinicTzOffset = useMemo(() => {
    try {
      return getTimezoneOffset() || '+05:30'
    } catch {
      return '+05:30'
    }
  }, [])

  // Parse a booked-slot timestamp (plain UTC like 'YYYY-MM-DD HH:mm:ss', or a *ForDayCal value that
  // already carries an offset suffix) into a dayjs fixed to the clinic offset.
  const toClinicDayjs = useCallback(
    (raw) => {
      if (!raw) return null
      const normalized = typeof raw === 'string' ? raw.replace(' ', 'T') : raw
      const d = dayjs.utc(normalized)
      if (!d.isValid()) return null
      return d.utcOffset(clinicTzOffset)
    },
    [clinicTzOffset],
  )

  // ---- Mobile appointments bottom-sheet (Yesterday / Today / Tomorrow + a dynamic picked date) ----
  const [appointmentsMode, setAppointmentsMode] = useState('today') // 'yesterday' | 'today' | 'tomorrow' | 'picked'
  // Per-date cache (keyed 'YYYY-MM-DD' in the clinic offset). The drawer prefetches the whole
  // ±1-day window in one call so switching Yesterday/Today/Tomorrow is instant; refreshes run in
  // the background and replace the cache without blocking the visible content.
  const [appointmentsByDate, setAppointmentsByDate] = useState({})
  const [chamberAppointmentsLoading, setChamberAppointmentsLoading] = useState(false)
  const [chamberAppointmentsError, setChamberAppointmentsError] = useState(false)
  // When a specific date outside ±1 day is picked, it's cached under its own key and shown in the
  // dynamic 'picked' tab.
  const [upcomingDate, setUpcomingDate] = useState(null) // 'DD-MM-YYYY' | null
  const appointmentsDateInputRef = useRef(null)

  // The clinic-local 'YYYY-MM-DD' key for the active tab.
  const appointmentsDateKey = useMemo(() => {
    const nowC = dayjs().utcOffset(clinicTzOffset)
    if (appointmentsMode === 'yesterday') return nowC.subtract(1, 'day').format('YYYY-MM-DD')
    if (appointmentsMode === 'tomorrow') return nowC.add(1, 'day').format('YYYY-MM-DD')
    if (appointmentsMode === 'picked' && upcomingDate)
      return dayjs(upcomingDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
    return nowC.format('YYYY-MM-DD')
  }, [appointmentsMode, upcomingDate, clinicTzOffset])

  // The slots to render for the active tab (undefined = not yet fetched → show the first-load
  // spinner; [] = fetched and empty → show the empty state).
  const displayedAppointments = appointmentsByDate[appointmentsDateKey]

  const handlePickAppointmentDate = useCallback((ymd) => {
    if (!ymd) return
    const picked = dayjs(ymd, 'YYYY-MM-DD')
    if (!picked.isValid()) return
    const today = dayjs()
    // A picked date that is one of the fixed tabs just selects that tab; anything else opens the
    // dynamic "picked date" tab (shown alongside Yesterday/Today/Tomorrow).
    if (picked.isSame(today, 'day')) {
      setUpcomingDate(null)
      setAppointmentsMode('today')
    } else if (picked.isSame(today.subtract(1, 'day'), 'day')) {
      setUpcomingDate(null)
      setAppointmentsMode('yesterday')
    } else if (picked.isSame(today.add(1, 'day'), 'day')) {
      setUpcomingDate(null)
      setAppointmentsMode('tomorrow')
    } else {
      setUpcomingDate(picked.format('DD-MM-YYYY'))
      setAppointmentsMode('picked')
    }
  }, [])

  // Tapping an appointment card opens that patient's EMR (prescription / therapy report) for
  // documentation while staying in the chamber. On mobile the report panel is otherwise hidden,
  // so we explicitly open the full-screen report sheet; on desktop the split report panel shows
  // automatically once a patient is selected.
  const handleBookedSlotSelect = useCallback(
    (data) => {
      const isSessionBlocked =
        data?.status === BOOKING_STATUSES.BOOKING_INITIATED &&
        data?.paymentStatus === BOOKING_PAYMENT_STATUSES.PENDING
      if (isSessionBlocked) {
        toast.warning('This session is awaiting payment confirmation and cannot be opened yet.')
        return
      }
      if (
        effectiveCalendarEventScope !== CALENDAR_EVENT_SCOPES.own &&
        data?.eventType === allAvailableEventTypes.consultation &&
        data?.mentorId !== mentorProfileData?.id
      ) {
        handleDoctorConsultationCalendarEventClick(data)
        setCalendarDrawerOpen(false)
        return
      }
      if (data?.status === STATUS_SESSION_CANCELLED) return
      markBookedEventLog(data?.id, 'JOIN', 'mentor')
      setSelectedPatientBookedEventId(data?.id)
      setPatientSelected(true)
      if (isMobile) {
        setMobileReportSheetOpen(true)
      }
      setCalendarDrawerOpen(false)
    },
    [
      effectiveCalendarEventScope,
      mentorProfileData?.id,
      handleDoctorConsultationCalendarEventClick,
      isMobile,
    ],
  )


  // ----- Picture-in-picture video drag (mobile, report sheet open) -----
  const handlePipPointerDown = useCallback((e) => {
    const rect = e.currentTarget.getBoundingClientRect()
    pipDragRef.current = {
      pointerId: e.pointerId,
      offsetX: e.clientX - rect.left,
      offsetY: e.clientY - rect.top,
      width: rect.width,
      height: rect.height,
    }
    try {
      e.currentTarget.setPointerCapture(e.pointerId)
    } catch {
      /* setPointerCapture unsupported — drag still works via the captured listeners */
    }
  }, [])
  const handlePipPointerMove = useCallback((e) => {
    const drag = pipDragRef.current
    if (!drag) return
    const maxLeft = window.innerWidth - drag.width - PIP_EDGE_MARGIN
    const maxTop = window.innerHeight - drag.height - PIP_EDGE_MARGIN
    const left = Math.max(PIP_EDGE_MARGIN, Math.min(maxLeft, e.clientX - drag.offsetX))
    const top = Math.max(PIP_EDGE_MARGIN, Math.min(maxTop, e.clientY - drag.offsetY))
    setPipPos({ left, top })
  }, [])
  const handlePipPointerUp = useCallback((e) => {
    const drag = pipDragRef.current
    pipDragRef.current = null
    if (drag) {
      try {
        e.currentTarget.releasePointerCapture(drag.pointerId)
      } catch {
        /* no-op */
      }
    }
  }, [])

  // Range fetch → split slots into the per-date cache by their clinic-local day. Range as Z-UTC.
  const fetchAppointmentRange = useCallback(
    async (startDay, endDay, datesToSeed) => {
      const offset = clinicTzOffset
      const toUtc = (d, endOfDay) =>
        dayjs
          .utc(
            (endOfDay ? d.endOf('day') : d.startOf('day')).format(
              `YYYY-MM-DDTHH:mm:ss[${offset}]`,
            ),
          )
          .format('YYYY-MM-DDTHH:mm:ss[Z]')
      const result = await fetchAndProcessBookedSlots({
        apiSignature: calendarBookingListingApiSignature,
        startTime: toUtc(startDay, false),
        endTime: toUtc(endDay, true),
        timeZone: encodeURIComponent(offset),
        forMentor: true,
      })
      const all = (result?.bookedSlotWithPatientInfo || []).filter(
        (s) => s && s.status !== STATUS_SESSION_CANCELLED,
      )
      // Seed the requested day keys (so an empty day reads as "fetched, empty", not "loading").
      const byDate = {}
      ;(datesToSeed || []).forEach((k) => {
        byDate[k] = []
      })
      all.forEach((s) => {
        const d = toClinicDayjs(s?.startTime || s?.slotStart || s?.startTimeForDayCal)
        const k = d && d.isValid() ? d.format('YYYY-MM-DD') : null
        if (!k) return
        if (!byDate[k]) byDate[k] = []
        byDate[k].push(s)
      })
      return byDate
    },
    [calendarBookingListingApiSignature, clinicTzOffset, toClinicDayjs],
  )

  // Prefetch the whole Yesterday/Today/Tomorrow window in one call → instant tab switches. Runs in
  // the background; the visible content keeps showing its cached slots while this refreshes them.
  const loadAppointmentWindow = useCallback(async () => {
    const nowC = dayjs().utcOffset(clinicTzOffset)
    const start = nowC.subtract(1, 'day')
    const end = nowC.add(1, 'day')
    const keys = [
      start.format('YYYY-MM-DD'),
      nowC.format('YYYY-MM-DD'),
      end.format('YYYY-MM-DD'),
    ]
    setChamberAppointmentsLoading(true)
    setChamberAppointmentsError(false)
    try {
      const byDate = await fetchAppointmentRange(start, end, keys)
      setAppointmentsByDate((prev) => ({ ...prev, ...byDate }))
      // Feed the peek + patient enrichment with today's slots.
      setBookedSlotsInDay(byDate[keys[1]] || [])
    } catch (err) {
      setChamberAppointmentsError(true)
    } finally {
      setChamberAppointmentsLoading(false)
    }
  }, [clinicTzOffset, fetchAppointmentRange])

  // Single-day fetch for an arbitrary picked date (outside the ±1 window).
  const loadPickedDay = useCallback(
    async (dateKey) => {
      if (!dateKey) return
      const day = dayjs(dateKey, 'YYYY-MM-DD')
      setChamberAppointmentsLoading(true)
      setChamberAppointmentsError(false)
      try {
        const byDate = await fetchAppointmentRange(day, day, [dateKey])
        setAppointmentsByDate((prev) => ({ ...prev, ...byDate }))
      } catch (err) {
        setChamberAppointmentsError(true)
      } finally {
        setChamberAppointmentsLoading(false)
      }
    },
    [fetchAppointmentRange],
  )

  // Latest drawer state, read inside the (stable) onBookedSlotsUpdate handler without putting these
  // volatile values in its deps (which would churn the calendar's fetch/poll effects).
  const appointmentsLiveStateRef = useRef({})
  appointmentsLiveStateRef.current = {
    isMobile,
    open: calendarDrawerOpen,
    patientSelected,
    mode: appointmentsMode,
    dateKey: appointmentsDateKey,
  }

  // The mounted desktop calendar pushes this after a new booking and on its own 75s poll (the PC
  // refresh mechanism). Mirror PC: refresh the drawer's per-date cache so new/changed appointments
  // appear without a manual reload. Loop-free — the loaders use the raw setBookedSlotsInDay setter,
  // they don't re-invoke this callback.
  const handleCalendarBookedSlotsUpdate = useCallback(
    (slots) => {
      setBookedSlotsInDay(slots)
      const st = appointmentsLiveStateRef.current
      if (st.isMobile && st.open && !st.patientSelected) {
        loadAppointmentWindow()
        if (st.mode === 'picked') loadPickedDay(st.dateKey)
      }
    },
    [loadAppointmentWindow, loadPickedDay],
  )

  // On open, prefetch the ±1-day window (covers Yesterday/Today/Tomorrow).
  useEffect(() => {
    if (!isMobile || !calendarDrawerOpen || patientSelected) return
    loadAppointmentWindow()
  }, [isMobile, calendarDrawerOpen, patientSelected, loadAppointmentWindow])

  // A picked date outside the window isn't covered by the prefetch — fetch it once when selected.
  useEffect(() => {
    if (!isMobile || !calendarDrawerOpen || patientSelected) return
    if (appointmentsMode !== 'picked') return
    if (appointmentsByDate[appointmentsDateKey] !== undefined) return
    loadPickedDay(appointmentsDateKey)
  }, [
    isMobile,
    calendarDrawerOpen,
    patientSelected,
    appointmentsMode,
    appointmentsDateKey,
    appointmentsByDate,
    loadPickedDay,
  ])

  const renderAppointmentCard = (slot) => {
    const startRaw = slot?.startTimeForDayCal || slot?.slotStart || slot?.startTime
    const start = toClinicDayjs(startRaw)
    const timeLabel = start && start.isValid() ? start.format('h:mm A') : '--:--'
    const name = slot?.userName || slot?.patientName || slot?.patientInfo?.name || 'Patient'
    const typeLabel = APPOINTMENT_TYPE_LABELS[slot?.eventType] || 'Session'
    // Age/gender tag, e.g. "34/M". Age from the patient's DOB (fallback to a stored age); gender as
    // a single letter.
    const dob = slot?.patientInfo?.dateOfBirth
    const ageVal = dob ? getAgeFromDobWithTime(dob) : (slot?.patientInfo?.age ?? '')
    const genderRaw = slot?.patientInfo?.gender || slot?.userGender || slot?.gender
    const genderShort = genderRaw
      ? GENDER_SHORT_LABELS[genderRaw] || String(genderRaw).charAt(0).toUpperCase()
      : ''
    const ageGender = [ageVal, genderShort].filter((v) => v !== '' && v != null).join('/')
    const isInPerson = slot?.meetingSrc === 'offline'
    const isCompleted = Boolean(slot?.markedCompleted)
    const isInProgress = slot?.sessionStatus === BOOKING_SESSION_STATUS?.IN_PROGRESS
    const isPaymentPending =
      slot?.status === BOOKING_STATUSES.BOOKING_INITIATED &&
      slot?.paymentStatus === BOOKING_PAYMENT_STATUSES.PENDING
    // Status colour code: in-progress = green, completed = grey, payment due = amber,
    // yet-to-start = indigo. Drives both the chip and the card's left accent bar.
    let chip = { label: 'Yet to start', bg: 'rgba(103, 121, 227, 0.14)', color: '#5568d3' }
    let statusColor = '#6779e3'
    if (isInProgress) {
      chip = { label: 'In progress', bg: 'rgba(16, 185, 129, 0.15)', color: '#0f8a5f' }
      statusColor = '#10b981'
    } else if (isCompleted) {
      chip = { label: 'Completed', bg: 'rgba(0, 0, 0, 0.06)', color: 'rgba(0, 0, 0, 0.55)' }
      statusColor = 'rgba(0, 0, 0, 0.32)'
    } else if (isPaymentPending) {
      chip = { label: 'Payment due', bg: 'rgba(245, 158, 11, 0.16)', color: '#b45309' }
      statusColor = '#f59e0b'
    }
    return (
      <Box
        key={slot?.id || `${name}-${timeLabel}`}
        role="button"
        onClick={() => handleBookedSlotSelect(slot)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.25,
          p: '10px 12px',
          pl: '10px',
          borderRadius: '12px',
          border: '0.5px solid rgba(0, 0, 0, 0.10)',
          borderLeft: `4px solid ${statusColor}`,
          background: '#ffffff',
          cursor: 'pointer',
          transition: 'all 0.15s ease',
          '&:hover': { borderColor: 'rgba(103, 121, 227, 0.4)', background: 'rgba(103, 121, 227, 0.03)' },
          '&:active': { transform: 'scale(0.99)' },
        }}
      >
        <Box sx={{ minWidth: 56, textAlign: 'center' }}>
          <Typography sx={{ fontSize: '13px', fontWeight: 700, color: statusColor }}>{timeLabel}</Typography>
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.625, minWidth: 0 }}>
            <Typography
              sx={{
                fontSize: '13px',
                fontWeight: 600,
                color: '#1f2937',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                minWidth: 0,
              }}
            >
              {name}
            </Typography>
            {ageGender ? (
              <Typography
                component="span"
                sx={{ flexShrink: 0, fontSize: '11px', fontWeight: 600, color: 'rgba(0, 0, 0, 0.5)' }}
              >
                {ageGender}
              </Typography>
            ) : null}
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.125 }}>
            {isInPerson ? (
              <PlaceRoundedIcon sx={{ fontSize: 13, color: '#9333ea' }} />
            ) : (
              <VideocamRoundedIcon sx={{ fontSize: 14, color: '#6779e3' }} />
            )}
            <Typography sx={{ fontSize: '11px', color: 'rgba(0, 0, 0, 0.6)' }}>
              {isInPerson ? 'In person' : 'Video call'} · {typeLabel}
            </Typography>
          </Box>
        </Box>
        <Box
          component="span"
          sx={{
            flexShrink: 0,
            fontSize: '11px',
            fontWeight: 600,
            px: 1,
            py: 0.5,
            borderRadius: '8px',
            background: chip.bg,
            color: chip.color,
            whiteSpace: 'nowrap',
          }}
        >
          {chip.label}
        </Box>
      </Box>
    )
  }

  // Next appointment summary for the mobile pull-up peek. Booked-event times come through as full
  // timestamps (startTimeForDayCal / startTime), parsed with dayjs.
  const nextAppointment = useMemo(() => {
    if (!Array.isArray(bookedSlotsInDay) || bookedSlotsInDay.length === 0) return null
    const getStart = (slot) => {
      const raw = slot?.startTimeForDayCal || slot?.slotStart || slot?.startTime
      const d = toClinicDayjs(raw)
      return d && d.isValid() ? d : null
    }
    const candidates = bookedSlotsInDay
      .filter((slot) => slot && slot.status !== STATUS_SESSION_CANCELLED)
      .map((slot) => ({ slot, start: getStart(slot) }))
      .filter((entry) => entry.start)
    if (candidates.length === 0) return null
    const now = dayjs()
    const upcoming = isToday
      ? candidates.filter((entry) => entry.start.isAfter(now.subtract(5, 'minute')))
      : candidates
    const pool = (upcoming.length > 0 ? upcoming : candidates).sort(
      (a, b) => a.start.valueOf() - b.start.valueOf(),
    )
    const chosen = pool[0]
    if (!chosen) return null
    const { slot, start } = chosen
    const name =
      slot.patientName ||
      slot.userName ||
      slot.patientInfo?.name ||
      slot.patientInfoData?.name ||
      'Patient'
    return { time: start.format('h:mm A'), name, count: candidates.length }
  }, [bookedSlotsInDay, isToday, toClinicDayjs])

  return (
    <div 
      className="w-100 d-flex flex-column full-width-child-resizable-box-print-only"
      style={{
        // Mobile: dynamic viewport height (100dvh) so the bottom-anchored video
        // controls stay inside the visible area even while the browser's bottom
        // toolbar is shown (100vh overshoots the visible viewport on mobile).
        // Desktop: 100vh.
        height: isMobile ? '100dvh' : '100vh',
        overflow: isMobile ? 'visible' : 'hidden', // Allow overflow on mobile so fixed controls aren't clipped
      }}
    >
      <ScreeningSectionsProvider>
        {/* On the mobile live screen the transparent top strip is removed — calendar moves to the
            bottom pull-up peek and Checkout to the top-right cluster. Header stays mounted
            (display:none) so its session-timer/report logic is unaffected, and still shows on
            desktop and the mobile idle/calendar view. */}
        <Box
          sx={{
            display:
              isMobile && chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING
                ? 'none'
                : 'contents',
          }}
        >
        <SplitScreenHeader
          chosenClinicData={chosenClinicData}
          chamberScreenStateNow={chamberScreenStateNow}
          leaveThisSession={leaveThisSession}
          serverGivenNextAction={serverGivenNextAction}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          calendarEventScope={effectiveCalendarEventScope}
          setCalendarEventScope={setCalendarEventScope}
          canViewConsultationCalendar={canViewConsultationCalendar}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          onPrevClick={onPrevClick}
          onNextClick={onNextClick}
          handleGoToToday={handleGoToToday}
          isToday={isToday}
          clinicSchedules={clinicSchedules}
          onOpenPatientSearch={handleOpenPatientSearch}
          onOpenBookedSlotsDrawer={handleOpenBookedSlotsDrawer}
          onRefreshBookings={handleRefreshBookings}
          isRefreshing={isRefreshingBookings}
          eachSlotDurationInMins={eachSlotDurationInMins}
          setEachSlotDurationInMins={setEachSlotDurationInMins}
          onOpenCalendarDrawer={() => setCalendarDrawerOpen(true)} // Calendar drawer callback for mobile
          // Report mode props - when a report page is open
          selectedOptionPatientMenu={selectedOptionPatientMenu}
          selectedPatientBookedEventData={selectedPatientBookedEventData}
          auxiliaryData={auxiliaryData}
          // Chamber screen status props
          chamberScreenStatus={chamberScreenStatus}
          joinedChamberName={joinedChamberName}
          onSaveReport={async () => {
            if (selectedOptionPatientMenu === 'screening_report') {
              await screeningReportRef?.current?.saveScreeningReport()
            } else if (selectedOptionPatientMenu === 'prescription') {
              await prescriptionRef?.current?.savePrescriptionData()
            } else if (selectedOptionPatientMenu === 'therapy_report') {
              await therapyReportRef?.current?.saveTherapyReport()
            }
          }}
          onLeaveSession={async (markAsCompleted = false) => {
            setIsLeavingSession(true)
            showNotification.info('Saving and returning to calendar...')
            try {
              await closeBookedEvent(markAsCompleted)
            } finally {
              setIsLeavingSession(false)
            }
          }}
          onCompleteSession={async () => {
            // Use closeBookedEvent with markAsCompleted=true for all report types
            // This ensures proper cleanup and state reset
            await closeBookedEvent(true)
          }}
          isSavingReport={
            selectedOptionPatientMenu === 'screening_report' ? screeningReportRef?.current?.isSaving :
            selectedOptionPatientMenu === 'prescription' ? prescriptionRef?.current?.isSaving :
            selectedOptionPatientMenu === 'therapy_report' ? therapyReportRef?.current?.isSaving :
            false
          }
          isLeavingSession={isLeavingSession}
        />
        </Box>
        <Dialog
          open={Boolean(screeningBookingCandidate)}
          onClose={() => {
            if (!isBookingScreeningFromConsultation) {
              setScreeningBookingCandidate(null)
            }
          }}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>Book missing screening?</DialogTitle>
          <DialogContent>
            <Typography variant="body2" color="text.secondary">
              Create a pre-screening session for{' '}
              {screeningBookingCandidate?.userName || 'this patient'} before the consultation with{' '}
              {screeningBookingCandidate?.mentorName || 'the doctor'}.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setScreeningBookingCandidate(null)}
              disabled={isBookingScreeningFromConsultation}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleBookPreScreeningFromConsultation}
              disabled={isBookingScreeningFromConsultation}
              startIcon={isBookingScreeningFromConsultation ? <CircularProgress size={16} /> : null}
            >
              Book Screening
            </Button>
          </DialogActions>
        </Dialog>
        <PractitionerAssessmentDrawer
          key={selectedPatientBookedEventId ?? 'no-booking'}
          open={assessmentDrawerOpen}
          onClose={() => setAssessmentDrawerOpen(false)}
          bookedEventId={selectedPatientBookedEventId}
          bookedEventInfo={selectedPatientBookedEventData}
          onRunSubmitted={() => getAndSetPatientBookedEventDetails?.()}
          patientId={selectedPatientId}
          mentorId={mentorProfileData?.id}
          onAssessmentReportSaved={handleAssessmentReportSaved}
        />
        <NerdStatComponent serverGivenNextAction={serverGivenNextAction} />
        {/* Mobile: Full screen video (calendar in drawer) | Desktop: Horizontal layout (side by side) */}
        <Box
          className="d-flex flex-grow-1"
          sx={{
            // Mobile: Full viewport height (header overlays). Desktop: Subtract header height
            marginTop: { xs: 0, sm: 0, md: `${MENTOR_SPLIT_HEADER_OFFSET_PX}px` },
            height: {
              // dvh on mobile keeps the bottom-anchored video controls visible
              // above the browser's bottom toolbar (100vh would overshoot).
              xs: '100dvh',
              sm: '100dvh',
              md: `calc(100vh - ${MENTOR_SPLIT_HEADER_OFFSET_PX}px)`,
            },
            maxHeight: {
              xs: '100dvh',
              sm: '100dvh',
              md: `calc(100vh - ${MENTOR_SPLIT_HEADER_OFFSET_PX}px)`,
            }, // Constrain height
            overflow: 'hidden', // Prevent outer container from scrolling - children handle their own scroll
            flexDirection: { xs: 'column', md: 'row' },
            position: 'relative',
            display: 'flex', // Ensure flex is enabled
            // Mobile: stack from the top so the split view shows the video strip on top and the
            // report (EMR) filling the space below it.
            alignItems: { xs: 'stretch', md: 'stretch' },
            justifyContent: { xs: 'flex-start', md: 'flex-start' },
            minHeight: 0, // Critical for flex children to allow scrolling
          }}
        >
        {chamberScreenStateNow === CHAMBER_SCREEN_STATES.IDLING && (
          <Box ref={(node) => { refLeftPanel.current = node }} sx={{
            width: '100%',
            // Mobile: Show with proper sizing. Desktop: Show normally
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            p: { xs: 2, sm: 2, md: 2 }, 
            position: 'relative',
            flex: { xs: '1 1 0', md: '1 1 0' },
            overflowY: 'auto',
            overflowX: 'hidden',
            minHeight: 0,
          }}>
            <Box sx={{ 
              maxWidth: { xs: '100%', sm: '400px', md: '420px', lg: '480px' }, 
              width: '100%',
              px: { xs: 1, sm: 2 },
            }} className="hide-on-print-only">
              {/* Connection status header */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: { xs: 1.75, sm: 2 } }}>
                <Box
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    flexShrink: 0,
                    backgroundColor: chamberRoomId ? '#10b981' : '#f59e0b',
                    boxShadow: chamberRoomId
                      ? '0 0 0 4px rgba(16, 185, 129, 0.18)'
                      : '0 0 0 4px rgba(245, 158, 11, 0.18)',
                    animation: 'chamberReadyPulse 1.8s ease-in-out infinite',
                    '@keyframes chamberReadyPulse': {
                      '0%, 100%': { opacity: 1 },
                      '50%': { opacity: 0.4 },
                    },
                  }}
                />
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography sx={{ fontSize: '15px', fontWeight: 600, color: 'rgba(17, 24, 39, 0.9)', lineHeight: 1.25 }}>
                    {joinedChamberName
                      ? `Joining ${joinedChamberName}…`
                      : chamberRoomId
                        ? "You're ready"
                        : 'Connecting…'}
                  </Typography>
                  <Typography sx={{ fontSize: '12px', color: 'rgba(107, 114, 128, 0.85)', lineHeight: 1.4 }}>
                    {joinedChamberName
                      ? 'Setting up the room…'
                      : autoConnectRemainingMs > 0
                        ? `Auto-connect paused · resumes in ${formatAutoConnectRemaining(autoConnectRemainingMs)}`
                        : chamberRoomId
                          ? "Auto-connect on · you'll join the next patient automatically"
                          : 'Reconnecting to the chamber…'}
                  </Typography>
                </Box>
                <Tooltip title="Refresh connection & reception screen" arrow>
                  <IconButton
                    onClick={() => {
                      if (chamberRoomId) {
                        getAndHandleNextAction({ force: true })
                        runChamberScreenStatusCheck()
                      }
                    }}
                    size="small"
                    sx={{
                      flexShrink: 0,
                      padding: '7px',
                      backgroundColor: 'rgba(103, 121, 227, 0.08)',
                      color: '#6779e3',
                      border: '1px solid rgba(103, 121, 227, 0.2)',
                      '&:hover': {
                        backgroundColor: 'rgba(103, 121, 227, 0.15)',
                        borderColor: 'rgba(103, 121, 227, 0.4)',
                      },
                    }}
                  >
                    <RefreshIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                </Tooltip>
              </Box>

              {/* Reception (patient-side) screen status — surfaced prominently when it's
                  switched off / disconnected so the doctor knows the other side is down. */}
              {chamberRoomId && chamberScreenStatus === 'offline' && (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 1.25,
                    p: { xs: 1.25, sm: 1.5 },
                    mb: { xs: 1.5, sm: 2 },
                    borderRadius: '12px',
                    background: 'rgba(239, 68, 68, 0.08)',
                    border: '1px solid rgba(239, 68, 68, 0.3)',
                  }}
                >
                  <SignalWifiOffIcon sx={{ fontSize: 20, color: '#ef4444', mt: '1px', flexShrink: 0 }} />
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: 'rgba(185, 28, 28, 0.95)', lineHeight: 1.3 }}>
                      Reception screen is switched off
                    </Typography>
                    <Typography sx={{ fontSize: '12px', color: 'rgba(153, 27, 27, 0.85)', lineHeight: 1.4, mt: 0.25 }}>
                      The clinic check-in screen is offline or not responding, so the next patient can&apos;t be connected yet. Auto-connect will hold until it&apos;s back — use the refresh up top to re-check now.
                    </Typography>
                  </Box>
                </Box>
              )}
              {chamberRoomId && chamberScreenStatus !== 'offline' && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: { xs: 1.5, sm: 2 }, px: 0.25 }}>
                  <Box
                    sx={{
                      width: 7,
                      height: 7,
                      borderRadius: '50%',
                      flexShrink: 0,
                      backgroundColor: chamberScreenStatus === 'online' ? '#10b981' : '#9ca3af',
                    }}
                  />
                  <Typography sx={{ fontSize: '12px', color: 'rgba(107, 114, 128, 0.85)' }}>
                    {chamberScreenStatus === 'online'
                      ? 'Reception screen connected'
                      : 'Checking reception screen…'}
                  </Typography>
                </Box>
              )}

              {/* Ready room: self-view preview with overlaid camera/mic controls */}
              <Paper
                elevation={0}
                sx={{
                  p: { xs: 1.5, sm: 2 },
                  borderRadius: '16px',
                  background: 'rgba(255, 255, 255, 0.9)',
                  border: '1px solid rgba(0, 0, 0, 0.07)',
                  mb: { xs: 1.5, sm: 2 },
                  width: '100%',
                  boxSizing: 'border-box',
                }}
              >
                <Box
                  sx={{
                    position: 'relative',
                    width: '100%',
                    aspectRatio: '16 / 10',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    background: '#0e1116',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                  }}
                >
                  <video
                    ref={previewVideoRef}
                    autoPlay
                    playsInline
                    muted
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      display: previewStream ? 'block' : 'none',
                    }}
                  />
                  {!previewStream && (
                    <Box
                      sx={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1,
                        color: 'rgba(255, 255, 255, 0.55)',
                      }}
                    >
                      <Box
                        sx={{
                          width: 48,
                          height: 48,
                          borderRadius: '50%',
                          background: 'rgba(255, 255, 255, 0.1)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        {isCameraOpen ? (
                          <VideocamIcon sx={{ fontSize: 24 }} />
                        ) : (
                          <VideocamOffIcon sx={{ fontSize: 24 }} />
                        )}
                      </Box>
                      <Typography sx={{ fontSize: '12px' }}>
                        {isCameraOpen ? 'Starting camera…' : 'Camera is off'}
                      </Typography>
                    </Box>
                  )}
                  <Box
                    sx={{
                      position: 'absolute',
                      left: 10,
                      right: 10,
                      bottom: 10,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                    }}
                  >
                    <Button
                      onClick={async () => {
                        const next = !isCameraOpen
                        setIsCameraOpen(next)
                        localStorage.setItem('chamberJoinWithCamera', String(next))
                        if (next && availableCameras.length === 0) {
                          try {
                            await navigator.mediaDevices.getUserMedia({ video: true, audio: false })
                            await getAndSetCameras({ setAvailableCameras, setSelectedCamera })
                          } catch (error) {
                            console.error('Error loading cameras:', error)
                            setIsCameraOpen(false)
                            localStorage.setItem('chamberJoinWithCamera', 'false')
                          }
                        }
                      }}
                      startIcon={
                        isCameraOpen ? (
                          <VideocamIcon sx={{ fontSize: 16 }} />
                        ) : (
                          <VideocamOffIcon sx={{ fontSize: 16 }} />
                        )
                      }
                      sx={{
                        textTransform: 'none',
                        borderRadius: '999px',
                        px: 1.5,
                        py: 0.6,
                        minWidth: 0,
                        fontSize: '12px',
                        fontWeight: 600,
                        backdropFilter: 'blur(8px)',
                        color: isCameraOpen ? '#34d399' : 'rgba(255, 255, 255, 0.92)',
                        background: isCameraOpen ? 'rgba(16, 185, 129, 0.22)' : 'rgba(15, 15, 18, 0.55)',
                        border: `1px solid ${isCameraOpen ? 'rgba(16, 185, 129, 0.55)' : 'rgba(255, 255, 255, 0.25)'}`,
                        '&:hover': {
                          background: isCameraOpen ? 'rgba(16, 185, 129, 0.32)' : 'rgba(15, 15, 18, 0.72)',
                        },
                      }}
                    >
                      {isCameraOpen ? 'Camera on' : 'Camera off'}
                    </Button>
                    <Button
                      onClick={async () => {
                        const next = !isAudioOpen
                        setIsAudioOpen(next)
                        localStorage.setItem('chamberJoinWithMic', String(next))
                        if (next && availableMicrophones.length === 0) {
                          try {
                            await navigator.mediaDevices.getUserMedia({ video: false, audio: true })
                            await getAndSetMicrophones({ setAvailableMicrophones, setSelectedMicrophone })
                            await getAndSetSpeakers({ setAvailableSpeakers, setSelectedSpeaker })
                          } catch (error) {
                            console.error('Error loading microphones:', error)
                            setIsAudioOpen(false)
                            localStorage.setItem('chamberJoinWithMic', 'false')
                          }
                        }
                      }}
                      startIcon={
                        isAudioOpen ? (
                          <MicIcon sx={{ fontSize: 16 }} />
                        ) : (
                          <MicOffIcon sx={{ fontSize: 16 }} />
                        )
                      }
                      sx={{
                        textTransform: 'none',
                        borderRadius: '999px',
                        px: 1.5,
                        py: 0.6,
                        minWidth: 0,
                        fontSize: '12px',
                        fontWeight: 600,
                        backdropFilter: 'blur(8px)',
                        color: isAudioOpen ? '#34d399' : 'rgba(255, 255, 255, 0.92)',
                        background: isAudioOpen ? 'rgba(16, 185, 129, 0.22)' : 'rgba(15, 15, 18, 0.55)',
                        border: `1px solid ${isAudioOpen ? 'rgba(16, 185, 129, 0.55)' : 'rgba(255, 255, 255, 0.25)'}`,
                        '&:hover': {
                          background: isAudioOpen ? 'rgba(16, 185, 129, 0.32)' : 'rgba(15, 15, 18, 0.72)',
                        },
                      }}
                    >
                      {isAudioOpen ? 'Mic on' : 'Mic off'}
                    </Button>
                    <Box sx={{ flex: 1 }} />
                    {isAudioOpen && (
                      <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: '3px', height: 20 }}>
                        {audioPreviewBars.slice(0, 5).map((level, index) => (
                          <Box
                            key={`overlay-mic-bar-${index}`}
                            sx={{
                              width: '3px',
                              borderRadius: '999px',
                              height: `${Math.max(15, level)}%`,
                              minHeight: '4px',
                              background: 'rgba(52, 211, 153, 0.95)',
                              transition: 'height 120ms ease-out',
                            }}
                          />
                        ))}
                      </Box>
                    )}
                  </Box>
                  {/* Device settings gear — tucked top-right of the preview, like a standard video call */}
                  <Tooltip title="Device settings" arrow>
                    <IconButton
                      onClick={(e) => setDeviceMenuAnchor(e.currentTarget)}
                      size="small"
                      aria-label="Device settings"
                      sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        padding: '6px',
                        color: 'rgba(255, 255, 255, 0.9)',
                        background: 'rgba(15, 15, 18, 0.5)',
                        backdropFilter: 'blur(8px)',
                        border: '1px solid rgba(255, 255, 255, 0.25)',
                        '&:hover': { background: 'rgba(15, 15, 18, 0.7)' },
                      }}
                    >
                      <SettingsIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Tooltip>
                </Box>

                {/* Device settings popover — opened from the gear on the preview, so the
                    camera/mic/speaker pickers don't take up the lobby's real estate. */}
                <Popover
                  open={Boolean(deviceMenuAnchor)}
                  anchorEl={deviceMenuAnchor}
                  onClose={() => setDeviceMenuAnchor(null)}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  PaperProps={{
                    sx: {
                      mt: 0.5,
                      p: 1.5,
                      width: 280,
                      maxWidth: 'calc(100vw - 32px)',
                      borderRadius: '14px',
                      boxShadow: '0 12px 40px rgba(0, 0, 0, 0.18)',
                    },
                  }}
                >
                  <Typography sx={{ fontSize: '12px', fontWeight: 700, color: 'rgba(55, 65, 81, 0.9)', mb: 1.25, letterSpacing: '0.02em' }}>
                    Device settings
                  </Typography>

                  <Box sx={{ mb: 1.25 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.5 }}>
                      <VideocamIcon sx={{ fontSize: 15, color: 'rgba(107, 114, 128, 0.7)' }} />
                      <Typography sx={{ fontSize: '11px', fontWeight: 600, color: 'rgba(107, 114, 128, 0.85)' }}>Camera</Typography>
                    </Box>
                    <FormControl size="small" fullWidth>
                      <Select
                        value={selectedCamera}
                        onChange={(e) => {
                          setSelectedCamera(e.target.value)
                          localStorage.setItem('selectedCamera', e.target.value)
                        }}
                        disabled={!isCameraOpen || availableCameras.length === 0}
                        displayEmpty
                        sx={{ fontSize: '13px', borderRadius: '10px', '& .MuiSelect-select': { padding: '8px 12px' } }}
                      >
                        {availableCameras.length === 0 && (
                          <MenuItem value="" sx={{ fontSize: '13px' }}>
                            No camera detected
                          </MenuItem>
                        )}
                        {availableCameras.map((camera) => (
                          <MenuItem key={camera.deviceId} value={camera.deviceId} sx={{ fontSize: '13px' }}>
                            {camera.label || `Camera ${camera.deviceId.slice(0, 8)}`}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>

                  <Box sx={{ mb: 1.25 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.5 }}>
                      <MicIcon sx={{ fontSize: 15, color: 'rgba(107, 114, 128, 0.7)' }} />
                      <Typography sx={{ fontSize: '11px', fontWeight: 600, color: 'rgba(107, 114, 128, 0.85)' }}>Microphone</Typography>
                    </Box>
                    <FormControl size="small" fullWidth>
                      <Select
                        value={selectedMicrophone}
                        onChange={(e) => {
                          setSelectedMicrophone(e.target.value)
                          localStorage.setItem('selectedMicrophone', e.target.value)
                        }}
                        disabled={!isAudioOpen || availableMicrophones.length === 0}
                        displayEmpty
                        sx={{ fontSize: '13px', borderRadius: '10px', '& .MuiSelect-select': { padding: '8px 12px' } }}
                      >
                        {availableMicrophones.length === 0 && (
                          <MenuItem value="" sx={{ fontSize: '13px' }}>
                            No microphone detected
                          </MenuItem>
                        )}
                        {availableMicrophones.map((mic) => (
                          <MenuItem key={mic.deviceId} value={mic.deviceId} sx={{ fontSize: '13px' }}>
                            {mic.label || `Mic ${mic.deviceId.slice(0, 8)}`}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>

                  <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.5 }}>
                      <VolumeUpIcon sx={{ fontSize: 15, color: 'rgba(107, 114, 128, 0.7)' }} />
                      <Typography sx={{ fontSize: '11px', fontWeight: 600, color: 'rgba(107, 114, 128, 0.85)' }}>Speaker</Typography>
                    </Box>
                    <FormControl size="small" fullWidth>
                      <Select
                        value={selectedSpeaker}
                        onChange={(e) => {
                          setSelectedSpeaker(e.target.value)
                          localStorage.setItem('selectedSpeaker', e.target.value)
                        }}
                        disabled={availableSpeakers.length === 0}
                        displayEmpty
                        sx={{ fontSize: '13px', borderRadius: '10px', '& .MuiSelect-select': { padding: '8px 12px' } }}
                      >
                        {availableSpeakers.length === 0 && (
                          <MenuItem value="" sx={{ fontSize: '13px' }}>
                            System default speaker
                          </MenuItem>
                        )}
                        {availableSpeakers.map((speaker) => (
                          <MenuItem key={speaker.deviceId} value={speaker.deviceId} sx={{ fontSize: '13px' }}>
                            {speaker.label || `Speaker ${speaker.deviceId.slice(0, 8)}`}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Popover>
              </Paper>

              {/* Auto-connect strip */}
              <Paper
                elevation={0}
                sx={{
                  p: { xs: 1.5, sm: 1.75 },
                  borderRadius: '14px',
                  background: autoConnectRemainingMs > 0 ? 'rgba(254, 243, 199, 0.7)' : 'rgba(103, 121, 227, 0.06)',
                  border: `1px solid ${autoConnectRemainingMs > 0 ? 'rgba(245, 158, 11, 0.3)' : 'rgba(103, 121, 227, 0.18)'}`,
                  mb: { xs: 1.5, sm: 2 },
                  width: '100%',
                  boxSizing: 'border-box',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.25, mb: 1.5 }}>
                  <PauseCircleOutlineIcon
                    sx={{ fontSize: 20, color: autoConnectRemainingMs > 0 ? 'rgba(146, 64, 14, 0.9)' : '#6779e3', flexShrink: 0, mt: '1px' }}
                  />
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                      sx={{
                        fontSize: '13px',
                        fontWeight: 600,
                        color: autoConnectRemainingMs > 0 ? 'rgba(146, 64, 14, 0.95)' : 'rgba(55, 65, 81, 0.9)',
                        lineHeight: 1.25,
                      }}
                    >
                      Chamber auto-connect
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: '12px',
                        color: autoConnectRemainingMs > 0 ? 'rgba(146, 64, 14, 0.85)' : 'rgba(107, 114, 128, 0.8)',
                        lineHeight: 1.4,
                        mt: 0.25,
                      }}
                    >
                      {autoConnectRemainingMs > 0
                        ? `Paused — you won't be auto-connected to the chamber room. Resuming in ${formatAutoConnectRemaining(autoConnectRemainingMs)}.`
                        : "On — you'll be connected to the chamber room automatically when the next patient is ready."}
                    </Typography>
                  </Box>
                </Box>
                {autoConnectRemainingMs > 0 ? (
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleResumeAutoConnect({ source: 'manual' })}
                    sx={{ textTransform: 'none', fontSize: '12px', borderRadius: '10px' }}
                  >
                    Resume auto-connect now
                  </Button>
                ) : (
                  <Box sx={{ display: 'flex', gap: 1, flexWrap: { xs: 'wrap', sm: 'nowrap' }, alignItems: 'center' }}>
                    <Typography sx={{ fontSize: '12px', color: 'rgba(107, 114, 128, 0.85)', flexShrink: 0 }}>
                      Pause for
                    </Typography>
                    <FormControl
                      size="small"
                      sx={{ minWidth: { xs: '100%', sm: 96 }, flex: { xs: '1 1 100%', sm: '0 0 auto' } }}
                    >
                      <Select
                        value={autoConnectPauseDurationMs}
                        onChange={(event) => setAutoConnectPauseDurationMs(Number(event.target.value))}
                        sx={{ fontSize: '12px', borderRadius: '10px', '& .MuiSelect-select': { padding: '7px 10px' } }}
                      >
                        {AUTO_CONNECT_PAUSE_OPTIONS.map((option) => (
                          <MenuItem key={`auto-connect-pause-${option.value}`} value={option.value} sx={{ fontSize: '12px' }}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => handlePauseAutoConnect({ source: 'manual' })}
                      sx={{ flex: { xs: '1 1 100%', sm: '0 0 auto' }, textTransform: 'none', fontSize: '12px', borderRadius: '10px', whiteSpace: 'nowrap' }}
                    >
                      Pause auto-connect
                    </Button>
                  </Box>
                )}
              </Paper>

              {/* Exit Button */}
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <CheckoutButtonComponent
                  text="Exit"
                  exitButtonText="Exit"
                  showExitButtonIfNotCheckedIn={true}
                  styleProp={{
                    fontSize: '11px',
                    fontWeight: 500,
                    padding: '6px 12px',
                    backgroundColor: 'rgba(239, 68, 68, 0.08)',
                    color: 'rgba(220, 38, 38, 0.8)',
                    border: '1px solid rgba(239, 68, 68, 0.15)',
                    borderRadius: '8px',
                    boxShadow: 'none',
                    '&:hover': {
                      background: 'rgba(239, 68, 68, 0.12)',
                      borderColor: 'rgba(239, 68, 68, 0.25)',
                    },
                    transition: 'all 0.2s ease',
                  }}
                  buttonColor="error"
                  buttonVariant="outlined"
                />
              </Box>
            </Box>
          </Box>
        )}
        {chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING && (
          <Box
            ref={videoContainerRef}
            sx={videoContainerSx}
            className="hide-on-print-only mobile-video-container"
          >
            {/* Desktop: Signal actions as fixed sidebar - Hidden on mobile */}
            {!isMobile && (
            <ChamberScreenSignallingActions
              chamberRoomId={serverGivenNextAction?.channel?.chamberRoomId}
            />
            )}
            
            {/* Mobile top-right cluster (the live screen has no header strip). During a patient
                session this is the Leave button (Save & Complete / Save as Draft) — always on top
                of everything (z above the report sheet) so it's reachable on the prescription page
                too. When idle (no patient) it falls back to the chamber Checkout. */}
            {isMobile && (
              <Box
                sx={{
                  position: 'fixed',
                  top: 'calc(env(safe-area-inset-top, 0px) + 12px + var(--chamber-vv-top-inset, 0px))',
                  right: '12px',
                  zIndex: 1850,
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                {patientSelected &&
                chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING ? (
                  <LeaveButton
                    popoverZIndex={2200}
                    isLeavingSession={isLeavingSession}
                    isAlreadyMarkedAsCompleted={
                      selectedPatientBookedEventData?.markedCompleted === true
                    }
                    leaveSession={async (markAsCompleted = false) => {
                      setIsLeavingSession(true)
                      showNotification.info('Saving and returning to calendar...')
                      try {
                        await closeBookedEvent(markAsCompleted)
                      } finally {
                        setIsLeavingSession(false)
                      }
                    }}
                    customButton={
                      <Box
                        role="button"
                        aria-label="Leave session"
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px',
                          cursor: 'pointer',
                          fontSize: '13px',
                          fontWeight: 700,
                          color: '#fff',
                          px: 1.75,
                          py: 0.85,
                          borderRadius: '999px',
                          background: 'linear-gradient(135deg, #ef4444, #dc2626)',
                          boxShadow: '0 4px 16px rgba(239,68,68,0.4)',
                          '&:hover': { background: 'linear-gradient(135deg, #dc2626, #b91c1c)' },
                        }}
                      >
                        {isLeavingSession ? (
                          <CircularProgress size={16} sx={{ color: '#fff' }} />
                        ) : (
                          <ExitToAppIcon sx={{ fontSize: 18 }} />
                        )}
                        Leave
                      </Box>
                    }
                  />
                ) : (
                  <CheckoutButtonComponent
                    text="Checkout"
                    additionalFunctionBeforeAction={() => {
                      if (chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING) {
                        leaveThisSession()
                      }
                    }}
                    showExitButtonIfNotCheckedIn={true}
                    styleProp={{
                      fontSize: '12px',
                      fontWeight: 600,
                      padding: '6px 12px',
                      backgroundColor: 'rgba(15, 15, 18, 0.55)',
                      color: '#ffffff',
                      border: '1px solid rgba(255, 255, 255, 0.25)',
                      borderRadius: '999px',
                      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.35)',
                      backdropFilter: 'blur(12px) saturate(180%)',
                      WebkitBackdropFilter: 'blur(12px) saturate(180%)',
                      '&:hover': { backgroundColor: 'rgba(15, 15, 18, 0.72)' },
                    }}
                  />
                )}
                <Tooltip title="Session options" arrow>
                  <IconButton
                    aria-label="Session options"
                    onClick={(e) => setMobileActionsMenuAnchor(e.currentTarget)}
                    size="small"
                    sx={{
                      backgroundColor: 'rgba(15, 15, 18, 0.55)',
                      backdropFilter: 'blur(12px) saturate(180%)',
                      WebkitBackdropFilter: 'blur(12px) saturate(180%)',
                      border: '1px solid rgba(255, 255, 255, 0.25)',
                      color: '#ffffff',
                      width: { xs: '40px', sm: '44px' },
                      height: { xs: '40px', sm: '44px' },
                      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.35)',
                      '&:hover': {
                        backgroundColor: 'rgba(15, 15, 18, 0.72)',
                      },
                      transition: 'all 0.2s ease',
                    }}
                  >
                    <MoreVertIcon sx={{ fontSize: { xs: 22, sm: 24 } }} />
                  </IconButton>
                </Tooltip>
              </Box>
            )}

            {/* Mobile: pull-up peek that raises the appointments bottom-sheet. Centred above the
                control dock so it clears the bottom-left self-view + the bottom-right dock; shows
                the next appointment at a glance. Hidden once a booked patient is selected. */}
            {isMobile && !mobileReportSheetOpen && !calendarDrawerOpen && !patientSelected && (
              <Box
                sx={{
                  position: 'fixed',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  bottom: 'calc(env(safe-area-inset-bottom, 0px) + 74px + var(--chamber-vv-bottom-inset, 0px))',
                  zIndex: 1200,
                  display: 'flex',
                  justifyContent: 'center',
                  pointerEvents: 'none',
                }}
              >
                <Box
                  role="button"
                  aria-label="Open appointments"
                  onClick={() => setCalendarDrawerOpen(true)}
                  sx={{
                    pointerEvents: 'auto',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    maxWidth: '60vw',
                    px: 1.5,
                    py: 0.75,
                    borderRadius: '999px',
                    background: 'rgba(18, 18, 22, 0.66)',
                    backdropFilter: 'blur(12px) saturate(180%)',
                    WebkitBackdropFilter: 'blur(12px) saturate(180%)',
                    border: '1px solid rgba(255, 255, 255, 0.18)',
                    boxShadow: '0 6px 18px rgba(0, 0, 0, 0.35)',
                    color: 'rgba(255, 255, 255, 0.95)',
                    transition: 'all 0.2s ease',
                    '&:hover': { background: 'rgba(18, 18, 22, 0.78)' },
                  }}
                >
                  <KeyboardArrowUpIcon sx={{ fontSize: 18, opacity: 0.9 }} />
                  <CalendarMonthIcon sx={{ fontSize: 15, opacity: 0.9 }} />
                  <Typography
                    component="span"
                    sx={{
                      fontSize: '12px',
                      fontWeight: 500,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {nextAppointment ? `Next · ${nextAppointment.time} · ${nextAppointment.name}` : 'Appointments'}
                  </Typography>
                </Box>
              </Box>
            )}

            {/* Unified mobile control dock — fixed at the bottom-right corner (it must NOT shift
                between the video and report pages). A Video⇄Rx/Report toggle, History, and a Print
                button (saves + opens the quick-print / download view). Collapses to a hamburger and
                hides while the keyboard is up so it never covers the field being typed. Leave lives
                in the always-on top-right button. */}
            {isMobile &&
              patientSelected &&
              !keyboardOpen &&
              chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING && (
                <Box
                  sx={{
                    position: 'fixed',
                    right: '12px',
                    bottom: 'calc(env(safe-area-inset-bottom, 0px) + 18px + var(--chamber-vv-bottom-inset, 0px))',
                    zIndex: 1800,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    gap: 1.25,
                  }}
                >
                  {!chamberDockMinimized && (
                    <>
                      {/* Print — saves then opens the quick-print / download view */}
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Typography component="span" sx={CHAMBER_DOCK_LABEL_SX}>
                          Print
                        </Typography>
                        <IconButton
                          aria-label="Print or download"
                          onClick={(e) => {
                            if (selectedOptionPatientMenu === 'therapy_report') {
                              setReportPreviewDrawerOpen(true)
                            } else if (selectedOptionPatientMenu === 'screening_report') {
                              screeningReportRef?.current?.openPreviewDrawer?.()
                            } else {
                              // Prescription: open a small menu with Print + Download options
                              // instead of going straight to quick-print.
                              setPrintMenuAnchor(e.currentTarget)
                            }
                          }}
                          sx={CHAMBER_DOCK_FAB_SX}
                        >
                          <PrintIcon sx={{ fontSize: 20 }} />
                        </IconButton>
                      </Box>
                      {/* History — uniform chamber-level patient history drawer */}
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Typography component="span" sx={CHAMBER_DOCK_LABEL_SX}>
                          History
                        </Typography>
                        <IconButton
                          aria-label="Patient history"
                          onClick={() => setChamberHistoryDrawerOpen(true)}
                          sx={CHAMBER_DOCK_FAB_SX}
                        >
                          <HistoryIcon sx={{ fontSize: 20 }} />
                        </IconButton>
                      </Box>
                      {/* Video ⇄ Rx/Report toggle */}
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Typography
                          component="span"
                          sx={{
                            ...CHAMBER_DOCK_LABEL_SX,
                            background: 'rgba(16,185,129,0.92)',
                            fontWeight: 700,
                          }}
                        >
                          {mobileReportSheetOpen
                            ? 'Video'
                            : selectedOptionPatientMenu === 'prescription'
                              ? 'Rx'
                              : 'Report'}
                        </Typography>
                        <IconButton
                          aria-label={mobileReportSheetOpen ? 'Show video' : 'Open report'}
                          onClick={() => setMobileReportSheetOpen((open) => !open)}
                          sx={{
                            width: 56,
                            height: 56,
                            color: '#fff',
                            background: 'linear-gradient(135deg, #10b981, #059669)',
                            boxShadow: '0 8px 22px rgba(16,185,129,0.45)',
                            border: '1.5px solid rgba(255,255,255,0.3)',
                            '&:hover': {
                              background: 'linear-gradient(135deg, #0ea271, #048257)',
                            },
                          }}
                        >
                          {mobileReportSheetOpen ? (
                            <VideocamIcon sx={{ fontSize: 24 }} />
                          ) : selectedOptionPatientMenu === 'prescription' ? (
                            <MedicationIcon sx={{ fontSize: 24 }} />
                          ) : (
                            <ArticleIcon sx={{ fontSize: 24 }} />
                          )}
                        </IconButton>
                      </Box>
                    </>
                  )}
                  {/* Hamburger — minimize / restore the dock */}
                  <IconButton
                    aria-label={chamberDockMinimized ? 'Show controls' : 'Minimize controls'}
                    onClick={() => setChamberDockMinimized((m) => !m)}
                    sx={{
                      width: 44,
                      height: 44,
                      color: '#fff',
                      background: 'rgba(15, 15, 18, 0.62)',
                      backdropFilter: 'blur(12px) saturate(180%)',
                      WebkitBackdropFilter: 'blur(12px) saturate(180%)',
                      border: '1px solid rgba(255,255,255,0.22)',
                      boxShadow: '0 6px 18px rgba(0,0,0,0.35)',
                      '&:hover': { background: 'rgba(15,15,18,0.78)' },
                    }}
                  >
                    {chamberDockMinimized ? <MenuRoundedIcon /> : <CloseIcon />}
                  </IconButton>
                </Box>
              )}

            {/* Print button menu (prescription) — opens Print + Download options off the dock's
                Print button. Download/Send both save the prescription first (prescriptionRef →
                saveAndDownloadPDF awaits savePrescriptionData), exactly like Save. */}
            <Menu
              anchorEl={printMenuAnchor}
              open={Boolean(printMenuAnchor)}
              onClose={() => setPrintMenuAnchor(null)}
              anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
              transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              sx={{ zIndex: 1900 }}
              PaperProps={{ sx: { minWidth: 224, borderRadius: '12px' } }}
            >
              <MenuItem
                onClick={() => {
                  setPrintMenuAnchor(null)
                  prescriptionRef?.current?.quickPrint?.()
                }}
              >
                <ListItemIcon>
                  <PrintIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Print</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setPrintMenuAnchor(null)
                  prescriptionRef?.current?.downloadPDF?.()
                }}
              >
                <ListItemIcon>
                  <DownloadIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Download PDF</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setPrintMenuAnchor(null)
                  prescriptionRef?.current?.sendPDFToPatient?.()
                }}
              >
                <ListItemIcon>
                  <SendIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Send PDF to patient</ListItemText>
              </MenuItem>
            </Menu>

            {/* Mobile: Focus/Swap Menu */}
            {isMobile && allowChamberManualFocus && (
              <Menu
                anchorEl={focusMenuAnchor}
                open={focusMenuOpen}
                onClose={() => setFocusMenuAnchor(null)}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                PaperProps={{
                  sx: {
                    mt: 1,
                    minWidth: 240,
                    maxHeight: 400,
                    borderRadius: '12px',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                    border: '1px solid rgba(103, 121, 227, 0.1)',
                    overflow: 'auto',
                  },
                }}
              >
                {mentorChamberShell.isManualFocusActive ? (
                  <MenuItem
                    onClick={() => {
                      mentorChamberShell.clearManualFocus()
                      setFocusMenuAnchor(null)
                    }}
                    sx={{ fontSize: '13px', fontWeight: 600, color: '#6779e3' }}
                  >
                    Use automatic focus
                  </MenuItem>
                ) : null}
                {getFocusMenuUsers.length > 0 ? (
                  getFocusMenuUsers.map((userInfo) => {
                    const stageUid = effectiveStageFocusUid
                    const isFocused =
                      stageUid !== null &&
                      stageUid !== undefined &&
                      (stageUid === userInfo.uid ||
                        String(stageUid) === String(userInfo.uid) ||
                        Number(stageUid) === Number(userInfo.uid))
                    const profilePicUrl = getProfilePictureUrl(userInfo.profilePicId)
                    const initials = getInitials(userInfo.name)

                    return (
                      <MenuItem
                        key={userInfo.uid}
                        onClick={() => {
                          mentorChamberShell.setPreferredDominantParticipantId(
                            userInfo.participantId,
                          )
                          setFocusMenuAnchor(null)
                        }}
                        sx={{
                          '&:hover': {
                            backgroundColor: 'rgba(103, 121, 227, 0.1)',
                          },
                          backgroundColor: isFocused ? 'rgba(103, 121, 227, 0.15)' : 'transparent',
                          borderLeft: isFocused ? '3px solid #6779e3' : '3px solid transparent',
                        }}
                      >
                        <Avatar
                          src={profilePicUrl || undefined}
                          sx={{
                            width: 32,
                            height: 32,
                            mr: 1.5,
                            fontSize: '14px',
                            bgcolor: profilePicUrl ? 'transparent' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          }}
                        >
                          {!profilePicUrl && initials}
                        </Avatar>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              fontSize: '14px',
                              fontWeight: isFocused ? 600 : 400,
                              color: isFocused ? '#6779e3' : 'inherit',
                            }}
                          >
                            {userInfo.name}
                            {userInfo.isLocal && (
                              <Typography component="span" variant="caption" sx={{ ml: 0.5, color: 'text.secondary', fontSize: '11px' }}>
                                (You)
                              </Typography>
                            )}
                          </Typography>
                          {userInfo.role && (
                            <Typography variant="caption" sx={{ fontSize: '11px', color: 'text.secondary', display: 'block' }}>
                              {userInfo.role === 'mentor' ? 'Mentor' : 
                               userInfo.role === 'patient' ? 'Patient' : 
                               userInfo.role === 'chamber-room' ? 'Chamber Room' : 
                               userInfo.role}
                            </Typography>
                          )}
                        </Box>
                        {isFocused && (
                          <CenterFocusStrongIcon sx={{ fontSize: 18, color: '#6779e3', ml: 1 }} />
                        )}
                      </MenuItem>
                    )
                  })
                ) : (
                  <MenuItem disabled>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.5)' }}>
                      No participants available
                    </Typography>
                  </MenuItem>
                )}
              </Menu>
            )}

            {/* Mobile: Menu for room screen actions */}
            {isMobile && (
                <Menu
                  anchorEl={mobileActionsMenuAnchor}
                  open={mobileActionsMenuOpen}
                  onClose={() => setMobileActionsMenuAnchor(null)}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  PaperProps={{
                    sx: {
                      mt: 1,
                      minWidth: 200,
                      borderRadius: '12px',
                      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                      border: '1px solid rgba(103, 121, 227, 0.1)',
                    },
                  }}
                >
                  {patientSelected && (
                    <MenuItem
                      onClick={() => {
                        setMobileReportSheetOpen(true)
                        setMobileActionsMenuAnchor(null)
                      }}
                    >
                      <MedicationIcon sx={{ fontSize: 18, mr: 1.5, color: '#10b981' }} />
                      Notes &amp; Rx
                    </MenuItem>
                  )}
                  {patientSelected && (
                    <MenuItem
                      onClick={() => {
                        setAssessmentDrawerOpen(true)
                        setMobileActionsMenuAnchor(null)
                      }}
                    >
                      <AssignmentIcon sx={{ fontSize: 18, mr: 1.5, color: 'rgba(103, 121, 227, 0.7)' }} />
                      Conduct assessment
                    </MenuItem>
                  )}
                  {allowChamberManualFocus && (
                    <MenuItem
                      onClick={() => {
                        setFocusMenuAnchor(mobileActionsMenuAnchor)
                        setMobileActionsMenuAnchor(null)
                      }}
                    >
                      <CenterFocusStrongIcon sx={{ fontSize: 18, mr: 1.5, color: 'rgba(103, 121, 227, 0.7)' }} />
                      Focus on participant
                    </MenuItem>
                  )}
                  <Divider sx={{ my: 0.5 }} />
                  <MenuItem
                    onClick={async () => {
                      await sendShowImageCommandToChamberScreen(serverGivenNextAction?.channel?.chamberRoomId, 'payment-qr')
                      setMobileActionsMenuAnchor(null)
                    }}
                  >
                    <QrCodeScannerIcon sx={{ fontSize: 18, mr: 1.5, color: 'rgba(103, 121, 227, 0.7)' }} />
                    Show Payment QR
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      askCheckedInChamberScreenToPollNextAction(serverGivenNextAction?.channel?.chamberRoomId)
                      setMobileActionsMenuAnchor(null)
                    }}
                  >
                    <LoginIcon sx={{ fontSize: 18, mr: 1.5, color: 'rgba(103, 121, 227, 0.7)' }} />
                    Fast-track Connect
                  </MenuItem>
                  <MenuItem
                    onClick={async () => {
                      sendShowImageCommandToChamberScreen(serverGivenNextAction?.channel?.chamberRoomId, 'clear-screen')
                      setMobileActionsMenuAnchor(null)
                    }}
                  >
                    <LayersClearIcon sx={{ fontSize: 18, mr: 1.5, color: 'rgba(103, 121, 227, 0.7)' }} />
                    Clear Screen
                  </MenuItem>
                  <MenuItem
                    onClick={async () => {
                      await sendReloadChamberRoomScreenSignal(serverGivenNextAction?.channel?.chamberRoomId)
                      setMobileActionsMenuAnchor(null)
                    }}
                  >
                    <ReplayIcon sx={{ fontSize: 18, mr: 1.5, color: 'rgba(103, 121, 227, 0.7)' }} />
                    Refresh Screen
                  </MenuItem>
                </Menu>
            )}
            
            <Box
              ref={(node) => {
                videoFullscreenRef.current = node
                refVideoContainer.current = node
                refLeftPanel.current = node
              }}
              data-video-container="left-frame"
              data-video-pip={isMobile && mobileReportSheetOpen ? 'true' : 'false'}
              sx={{
                // Mobile has two video layouts:
                //  • No report open → full-screen video pinned to the visible viewport via
                //    position:fixed + inset:0 (avoids the bottom-control cutoff; immune to 100vh
                //    quirks and the fixed header's in-flow spacer).
                //  • Report open → the video collapses to a small draggable picture-in-picture tile
                //    floating above the EMR sheet, so the doctor watches the patient while writing.
                ...(isMobile
                  ? mobileReportSheetOpen
                    ? {
                        position: 'fixed',
                        ...(pipPos
                          ? { top: `${pipPos.top}px`, left: `${pipPos.left}px`, transform: 'none' }
                          : {
                              top: 'calc(env(safe-area-inset-top, 0px) + 12px)',
                              left: '50%',
                              transform: 'translateX(-50%)',
                            }),
                        width: `${pipLandscape ? PIP_WIDTH_LANDSCAPE : PIP_WIDTH}px`,
                        height: `${pipLandscape ? PIP_HEIGHT_LANDSCAPE : PIP_HEIGHT}px`,
                        maxHeight: 'none',
                        minHeight: 0,
                        borderRadius: '16px',
                        border: '1.5px solid rgba(255, 255, 255, 0.85)',
                        boxShadow: '0 16px 40px rgba(0, 0, 0, 0.45)',
                        touchAction: 'none',
                        cursor: 'grab',
                      }
                    : {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        width: '100vw',
                        maxHeight: 'none',
                        minHeight: 0,
                      }
                  : {
                      position: 'relative',
                      flexGrow: 1,
                      flexShrink: 1,
                      flexBasis: 0,
                      width: undefined,
                      height: '100%',
                      minHeight: 0,
                      maxHeight: '100%',
                    }),
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                alignSelf: 'stretch',
                overflow: 'hidden',
                zIndex: isMobile && mobileReportSheetOpen ? 1700 : 100,
              }}
            >
            <MentorChamberAgoraVideoSurface
              key={`agora-video-${agoraRtcProps?.channel || 'none'}-${isInBookedEventSession ? 'booked' : 'chamber'}`}
              shell={mentorChamberShell}
              agoraRtcProps={resolvedMentorAgoraRtcProps}
              agoraRtmProps={agoraRtmProps}
              handleLeaveRoom={() => {
                leaveThisSession()
              }}
              onParticipantsUpdated={mentorChamberShell.handleParticipantSnapshot}
              playAudioOnUserJoin={false}
              playAudioOnUserLeave={false}
              onCameraClose={() => {
                setIsCameraOpen(false)
                if (selectedPatientBookedEventId) {
                  markBookedEventLog(selectedPatientBookedEventId, 'CAMERA_OFF', 'mentor', {
                    camera: false,
                    mic: isAudioOpen,
                  })
                }
              }}
              onCameraOpen={() => {
                setIsCameraOpen(true)
                if (selectedPatientBookedEventId) {
                  markBookedEventLog(selectedPatientBookedEventId, 'CAMERA_ON', 'mentor', {
                    camera: true,
                    mic: isAudioOpen,
                  })
                }
              }}
              onAudioClose={() => {
                setIsAudioOpen(false)
                if (selectedPatientBookedEventId) {
                  markBookedEventLog(selectedPatientBookedEventId, 'MIC_OFF', 'mentor', {
                    camera: isCameraOpen,
                    mic: false,
                  })
                }
              }}
              onAudioOpen={() => {
                setIsAudioOpen(true)
                if (selectedPatientBookedEventId) {
                  markBookedEventLog(selectedPatientBookedEventId, 'MIC_ON', 'mentor', {
                    camera: isCameraOpen,
                    mic: true,
                  })
                }
              }}
              />
              {!isMobile &&
              allowChamberManualFocus &&
              chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING ? (
                <>
                  <Box
                    sx={{
                      position: 'absolute',
                      left: 24,
                      bottom: 24,
                      zIndex: 12010,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      px: 1.25,
                      py: 1,
                      borderRadius: '20px',
                      background: 'rgba(255, 255, 255, 0.72)',
                      border: '1px solid rgba(216, 180, 254, 0.72)',
                      boxShadow:
                        '0 24px 54px rgba(91, 33, 182, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.86)',
                      backdropFilter: 'blur(18px) saturate(140%)',
                      WebkitBackdropFilter: 'blur(18px) saturate(140%)',
                    }}
                  >
                    <Tooltip title="Select video to focus" arrow>
                      <IconButton
                        onClick={(e) => setFocusMenuAnchor(e.currentTarget)}
                        sx={desktopVideoUtilityButtonSx}
                      >
                        <CenterFocusStrongIcon sx={{ fontSize: 20 }} />
                      </IconButton>
                    </Tooltip>
                  </Box>

                  <Menu
                    anchorEl={focusMenuAnchor}
                    open={focusMenuOpen}
                    onClose={() => setFocusMenuAnchor(null)}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    PaperProps={{
                      sx: {
                        mt: 1,
                        minWidth: 240,
                        maxHeight: 400,
                        borderRadius: '16px',
                        boxShadow: '0 18px 46px rgba(91, 33, 182, 0.2)',
                        border: '1px solid rgba(216, 180, 254, 0.42)',
                        overflow: 'auto',
                      },
                    }}
                  >
                    {mentorChamberShell.isManualFocusActive ? (
                      <MenuItem
                        onClick={() => {
                          mentorChamberShell.clearManualFocus()
                          setFocusMenuAnchor(null)
                        }}
                        sx={{ fontSize: '13px', fontWeight: 600, color: '#6779e3' }}
                      >
                        Use automatic focus
                      </MenuItem>
                    ) : null}
                    {getFocusMenuUsers.length > 0 ? (
                      getFocusMenuUsers.map((userInfo) => {
                        const stageUid = effectiveStageFocusUid
                        const isFocused =
                          stageUid !== null &&
                          stageUid !== undefined &&
                          (stageUid === userInfo.uid ||
                            String(stageUid) === String(userInfo.uid) ||
                            Number(stageUid) === Number(userInfo.uid))
                        const profilePicUrl = getProfilePictureUrl(userInfo.profilePicId)
                        const initials = getInitials(userInfo.name)

                        return (
                          <MenuItem
                          key={userInfo.uid}
                          onClick={() => {
                              mentorChamberShell.setPreferredDominantParticipantId(
                                userInfo.participantId,
                              )
                              setFocusMenuAnchor(null)
                            }}
                            sx={{
                              '&:hover': {
                                backgroundColor: 'rgba(103, 121, 227, 0.1)',
                              },
                              backgroundColor: isFocused
                                ? 'rgba(103, 121, 227, 0.15)'
                                : 'transparent',
                              borderLeft: isFocused
                                ? '3px solid #6779e3'
                                : '3px solid transparent',
                            }}
                          >
                            <Avatar
                              src={profilePicUrl || undefined}
                              sx={{
                                width: 32,
                                height: 32,
                                mr: 1.5,
                                fontSize: '14px',
                                bgcolor: profilePicUrl
                                  ? 'transparent'
                                  : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                              }}
                            >
                              {!profilePicUrl && initials}
                            </Avatar>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: '14px',
                                  fontWeight: isFocused ? 600 : 400,
                                  color: isFocused ? '#6779e3' : 'inherit',
                                }}
                              >
                                {userInfo.name}
                                {userInfo.isLocal ? (
                                  <Typography
                                    component="span"
                                    variant="caption"
                                    sx={{ ml: 0.5, color: 'text.secondary', fontSize: '11px' }}
                                  >
                                    (You)
                                  </Typography>
                                ) : null}
                              </Typography>
                              {userInfo.role ? (
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontSize: '11px',
                                    color: 'text.secondary',
                                    display: 'block',
                                  }}
                                >
                                  {userInfo.role === 'mentor'
                                    ? 'Mentor'
                                    : userInfo.role === 'patient'
                                      ? 'Patient'
                                      : userInfo.role === 'chamber-room'
                                        ? 'Chamber Room'
                                        : userInfo.role}
                                </Typography>
                              ) : null}
                            </Box>
                            {isFocused ? (
                              <CenterFocusStrongIcon
                                sx={{ fontSize: 18, color: '#6779e3', ml: 1 }}
                              />
                            ) : null}
                          </MenuItem>
                        )
                      })
                    ) : (
                      <MenuItem disabled>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.5)' }}
                        >
                          No participants available
                        </Typography>
                      </MenuItem>
                    )}
                  </Menu>

                </>
              ) : null}
              {/* PIP drag layer: when the EMR sheet is open the video is a small tile. This overlay
                  makes the whole tile draggable (finger/mouse) and carries an expand button that
                  restores full-screen video (closes the sheet). Sits above the video surface; the
                  expand button stops drag-start so a tap doesn't move the tile. */}
              {isMobile && mobileReportSheetOpen && (
                <Box
                  onPointerDown={handlePipPointerDown}
                  onPointerMove={handlePipPointerMove}
                  onPointerUp={handlePipPointerUp}
                  onPointerCancel={handlePipPointerUp}
                  sx={{
                    position: 'absolute',
                    inset: 0,
                    zIndex: 5,
                    cursor: 'grab',
                    touchAction: 'none',
                    '&:active': { cursor: 'grabbing' },
                    background:
                      'linear-gradient(180deg, rgba(0,0,0,0.34) 0%, rgba(0,0,0,0) 36%, rgba(0,0,0,0) 64%, rgba(0,0,0,0.34) 100%)',
                  }}
                >
                  <DragIndicatorIcon
                    sx={{
                      position: 'absolute',
                      top: 3,
                      left: 3,
                      fontSize: 15,
                      color: 'rgba(255,255,255,0.85)',
                      filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.6))',
                      pointerEvents: 'none',
                    }}
                  />
                  <Tooltip title="Expand video" arrow>
                    <IconButton
                      aria-label="Expand video to full screen"
                      size="small"
                      onPointerDown={(e) => e.stopPropagation()}
                      onClick={() => setMobileReportSheetOpen(false)}
                      sx={{
                        position: 'absolute',
                        top: 1,
                        right: 1,
                        color: '#fff',
                        width: 26,
                        height: 26,
                        '& svg': { fontSize: 15 },
                      }}
                    >
                      <OpenInFullIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
              )}
            </Box>
          </Box>
        )}

        {/* Debug Panel - Desktop only */}
        {!isMobile && chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING && (
          <DebugPanel
            uidToUsernameMap={debugUidToUsernameMap}
            remoteUsers={debugRemoteUsers}
            agoraRtcProps={resolvedMentorAgoraRtcProps}
            agoraRtmProps={agoraRtmProps}
            onRequestFocusUid={(participantId) =>
              mentorChamberShell.setPreferredDominantParticipantId(participantId)
            }
          />
        )}
        
        {/* Mobile Vertical Separator - Hidden on mobile (calendar is in drawer) */}
        {false && isMobile && chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING && (
          <Box
            ref={refMobileResizer}
            sx={{
              width: '100%',
              height: '8px',
              background: 'linear-gradient(to bottom, rgba(103, 121, 227, 0.1), rgba(116, 80, 170, 0.1))',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'row-resize',
              position: 'relative',
              transition: 'all 0.2s ease',
              borderTop: '1px solid rgba(103, 121, 227, 0.15)',
              borderBottom: '1px solid rgba(116, 80, 170, 0.15)',
              flexShrink: 0,
              '&:hover': {
                height: '12px',
                background: 'linear-gradient(to bottom, rgba(103, 121, 227, 0.2), rgba(116, 80, 170, 0.2))',
                borderTop: '2px solid rgba(103, 121, 227, 0.4)',
                borderBottom: '2px solid rgba(116, 80, 170, 0.4)',
              },
              '&:active': {
                height: '16px',
                background: 'linear-gradient(to bottom, rgba(103, 121, 227, 0.3), rgba(116, 80, 170, 0.3))',
              },
            }}
          >
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                backgroundColor: '#6779E3',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 8px rgba(103, 121, 227, 0.4)',
                transition: 'all 0.2s ease',
                '&:hover': {
                  width: 28,
                  height: 28,
                  backgroundColor: '#5568D3',
                  boxShadow: '0 3px 12px rgba(103, 121, 227, 0.6)',
                },
              }}
            >
              <DragIndicatorIcon
                sx={{
                  fontSize: '16px',
                  color: 'white',
                  transform: 'rotate(90deg)', // Rotate 90 degrees for vertical dragging
                }}
              />
            </Box>
          </Box>
        )}
        
        {/* Desktop Horizontal Separator - Hidden on mobile */}
        <HotlineSectionSeparator 
          ref={refLeft} 
          className="left-resizer hide-on-print-only"
          style={{
            display: isMobile ? 'none' : 'flex',
            pointerEvents: 'auto',
            zIndex: 10002,
            position: 'relative',
          }}
        >
          <Box
            sx={{
              width: 24,
              height: 24,
              borderRadius: '50%',
              backgroundColor: '#6779E3',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 8px rgba(103, 121, 227, 0.4)',
              transition: 'all 0.2s ease',
              pointerEvents: 'none', // Allow clicks to pass through to separator
              '&:hover': {
                width: 28,
                height: 28,
                backgroundColor: '#5568D3',
                boxShadow: '0 3px 12px rgba(103, 121, 227, 0.6)',
              },
            }}
          >
            <DragIndicatorIcon
              style={{
                fontSize: '16px',
                color: 'white',
                pointerEvents: 'none', // Ensure icon doesn't block events
              }}
            />
          </Box>
        </HotlineSectionSeparator>
        <HotlineChamberInteractionPart
          style={{
            paddingTop: 0,
            padding: 0,
            ...(isMobile
              ? (isVideoLandscape
                  ? {
                      // Split "video + notes" view: the report fills the space below the video
                      // strip so the doctor can document while still seeing the patient.
                      display: 'flex',
                      flexDirection: 'column',
                      flex: 1,
                      minHeight: 0,
                      width: '100%',
                      background: '#ffffff',
                      overflowY: 'auto',
                      WebkitOverflowScrolling: 'touch',
                    }
                  : {
                      // Full-video view: the report is a full-screen sheet opened on demand from
                      // the in-call "Notes & Rx" / "Conduct assessment" actions. It stays mounted
                      // (display:none) until opened so the PrescriptionMakingPage instance and its
                      // refs/save flow are preserved.
                      display: mobileReportSheetOpen ? 'flex' : 'none',
                      flexDirection: 'column',
                      position: 'fixed',
                      inset: 0,
                      width: '100%',
                      height: '100dvh',
                      maxHeight: '100dvh',
                      zIndex: 1500,
                      background: '#ffffff',
                      // The sheet itself does NOT scroll — the inner scroll Box below does. This keeps
                      // the header pinned and guarantees the form scrolls even when the embedded
                      // PrescriptionMakingPage uses height:100% internally (which would otherwise fill
                      // the sheet exactly and leave nothing for the sheet to scroll).
                      overflow: 'hidden',
                    })
              : {
                  // Desktop: lives inline in the split panel.
                  width: undefined,
                  height: '100%',
                  flexShrink: 0,
                  marginTop: 0,
                  transition: 'margin-top 0.3s ease',
                }),
          }}
          ref={(node) => {
            refBox.current = node
            calendarScrollContainerRef.current = node
          }}
          /* On mobile the report uses its own fixed-sheet / flex-split layout; the
             `.resizable-box.mobile-calendar-container { position: relative !important; height: 100%
             !important }` rule (for the desktop resizer) would otherwise override position:fixed and
             bury the sheet behind the full-screen video. So drop `resizable-box` on mobile. */
          className={isMobile ? 'mobile-calendar-container' : 'resizable-box mobile-calendar-container'}
        >
          {isMobile && mobileReportSheetOpen && (
            <Box
              sx={{
                flexShrink: 0,
                zIndex: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                px: 1.5,
                py: 1,
                borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
                background: '#ffffff',
              }}
            >
              <Typography sx={{ fontWeight: 600, fontSize: '15px' }}>
                {selectedOptionPatientMenu === 'therapy_report'
                  ? 'Therapy report'
                  : selectedOptionPatientMenu === 'screening_report'
                    ? 'Screening report'
                    : selectedOptionPatientMenu === 'assessment_report'
                      ? 'Assessment report'
                      : 'Prescription'}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
                <IconButton
                  aria-label="More report options"
                  size="small"
                  onClick={(e) => setSheetMoreMenuAnchor(e.currentTarget)}
                >
                  <MoreVertRoundedIcon />
                </IconButton>
                <IconButton
                  aria-label="Close report"
                  size="small"
                  onClick={() => setMobileReportSheetOpen(false)}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
          )}
          {/* Sheet-header overflow menu: only the rarely-used secondary actions. Print/preview is
              the floating dock's Print button; Leave is the top-right button; Vitals is dropped on
              the mobile prescription view. */}
          {isMobile && (
            <Menu
              anchorEl={sheetMoreMenuAnchor}
              open={Boolean(sheetMoreMenuAnchor)}
              onClose={() => setSheetMoreMenuAnchor(null)}
              sx={{ zIndex: 2000 }}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              PaperProps={{ sx: { minWidth: 210, borderRadius: '12px' } }}
            >
              {selectedOptionPatientMenu === 'prescription' && [
                <MenuItem
                  key="rx"
                  onClick={() => {
                    setRxDrawerOpen(true)
                    setSheetMoreMenuAnchor(null)
                  }}
                >
                  <MedicationIcon sx={{ fontSize: 18, mr: 1.5, color: '#10b981' }} />
                  Add medications
                </MenuItem>,
                <MenuItem
                  key="settings"
                  onClick={() => {
                    prescriptionRef?.current?.openSettings?.()
                    setSheetMoreMenuAnchor(null)
                  }}
                >
                  <SettingsIcon sx={{ fontSize: 18, mr: 1.5, color: 'rgba(0,0,0,0.55)' }} />
                  Page settings
                </MenuItem>,
              ]}
              {selectedOptionPatientMenu === 'therapy_report' && (
                <MenuItem
                  onClick={() => {
                    therapyReportRef?.current?.openSettings?.()
                    setSheetMoreMenuAnchor(null)
                  }}
                >
                  <SettingsIcon sx={{ fontSize: 18, mr: 1.5, color: 'rgba(0,0,0,0.55)' }} />
                  Report settings
                </MenuItem>
              )}
              {selectedOptionPatientMenu === 'screening_report' && (
                <MenuItem
                  onClick={() => {
                    screeningReportRef?.current?.openSettings?.()
                    setSheetMoreMenuAnchor(null)
                  }}
                >
                  <SettingsIcon sx={{ fontSize: 18, mr: 1.5, color: 'rgba(0,0,0,0.55)' }} />
                  Report settings
                </MenuItem>
              )}
              {selectedOptionPatientMenu === 'assessment_report' && (
                <MenuItem
                  onClick={() => {
                    assessmentReportRef?.current?.openSettings?.()
                    setSheetMoreMenuAnchor(null)
                  }}
                >
                  <SettingsIcon sx={{ fontSize: 18, mr: 1.5, color: 'rgba(0,0,0,0.55)' }} />
                  Report settings
                </MenuItem>
              )}
            </Menu>
          )}
          {/* Inner scroll container — the fixed sheet itself doesn't scroll (overflow:hidden); this
              Box is the single scroller so the form is always reachable below the pinned header. On
              desktop it's a plain block (flex:unset) and the sheet scrolls as before. */}
          <Box
            sx={{
              flex: { xs: 1, md: 'unset' },
              minHeight: 0,
              width: '100%',
              overflowY: 'auto',
              overflowX: 'hidden',
              WebkitOverflowScrolling: 'touch',
            }}
          >
            {patientSelected ? (
              <div>
                {patientBookedSlotDetailsLoading ? (
                  <Spinner animation="border" variant="dark" size="sm" />
                ) : (
                  <div>
                    {/* Section tab strip — sleek icon + initial chips (icon + full label on desktop),
                        mirroring the /l/* tabs. NOT sticky: it scrolls away with the content. Per-report
                        action chips live in the sheet-header ⋮ menu. */}
                    <Box
                      className="hide-on-print-only"
                      data-testid="patient-menu-row"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.75,
                        flexShrink: 0,
                        px: 1,
                        py: 0.75,
                        overflowX: 'auto',
                        background: '#fff',
                        borderBottom: '1px solid rgba(103, 121, 227, 0.12)',
                        scrollbarWidth: 'none',
                        '&::-webkit-scrollbar': { display: 'none' },
                      }}
                    >
                      {patientMenuOptions?.map((menuItem, menuItemIndex) => {
                        const selected = menuItem.id === selectedOptionPatientMenu
                        const meta = CHAMBER_TAB_META[menuItem.id]
                        const TabIcon = meta?.icon || ArticleIcon
                        const tabLabel = isMobile ? meta?.initial || menuItem.label : menuItem.label
                        return (
                          <Box
                            component="button"
                            key={menuItem.id ?? menuItemIndex}
                            onClick={() => {
                              setSelectedOptionPatientMenu(menuItem.id)
                              if (menuItem.id === 'assessments') {
                                setAssessmentDrawerOpen(true)
                              }
                            }}
                            title={menuItem.label}
                            aria-label={menuItem.label}
                            sx={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: 0.5,
                              flexShrink: 0,
                              minHeight: 30,
                              px: 1.25,
                              py: 0.5,
                              borderRadius: '9px',
                              fontFamily: 'inherit',
                              fontWeight: 600,
                              fontSize: '13px',
                              whiteSpace: 'nowrap',
                              cursor: 'pointer',
                              transition: 'all 0.2s ease',
                              border: selected ? '1.5px solid #6779e3' : '1px solid rgba(0, 0, 0, 0.12)',
                              background: selected
                                ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                                : '#fff',
                              color: selected ? '#fff' : '#475569',
                              '&:active': { transform: 'scale(0.96)' },
                            }}
                          >
                            <TabIcon sx={{ fontSize: 16 }} />
                            <span>{tabLabel}</span>
                          </Box>
                        )
                      })}
                    </Box>
                    {patientMenuOptions?.length === 0 && (
                      <Box sx={{ p: 3, maxWidth: 560 }}>
                        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                          This booking could not be opened yet
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          We could not determine the right report view for this session. The booking data may be incomplete or still using an older event type.
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                          Event type: {selectedPatientBookedEventData?.eventType || selectedPatientEventType || 'Unknown'}
                        </Typography>
                      </Box>
                    )}
                    <PrescriptionDataProvider key={selectedPatientBookedEventId ?? 'no-booking'}>
                      <div>
                        {selectedOptionPatientMenu === 'prescription' && (
                          <PrescriptionMakingPage
                            ref={prescriptionRef}
                            propEventId={selectedPatientBookedEventData?.id}
                            propPatientId={selectedPatientId}
                            propClinicId={selectedPatientClinicId}
                            propClinicBrandId={selectedPatientClinicBrandId}
                            propMentorProfileData={mentorProfileData}
                            propBookedEventInfo={selectedPatientBookedEventData}
                            setHideLayoutComponents={setHideLayoutComponents}
                            // triggerSave={triggerSave}
                            // setTriggerSave={setTriggerSave}
                            auxiliaryDataFromProps={auxiliaryData}
                            getProcessAndSetEventData={getAndSetPatientBookedEventDetails}
                            inChamber
                            afterSaveFunction={(markAsCompleted = false) => {
                              if (newWantedMenuItemId === 'end') {
                                finallyCloseBookedEvent(markAsCompleted)
                              } else {
                                setSelectedOptionPatientMenu(newWantedMenuItemId)
                              }
                            }}
                            showPatientDetailsInHeader
                          />
                        )}
                        {selectedOptionPatientMenu === 'therapy_report' && (
                          <TherapyReportMakingPage
                            ref={therapyReportRef}
                            propEventId={selectedPatientBookedEventData?.id}
                            propPatientId={selectedPatientId}
                            propClinicId={selectedPatientClinicId}
                            propClinicBrandId={selectedPatientClinicBrandId}
                            propMentorProfileData={mentorProfileData}
                            propBookedEventInfo={selectedPatientBookedEventData}
                            triggerSave={triggerSave}
                            setTriggerSave={setTriggerSave}
                            auxiliaryDataFromProps={auxiliaryData}
                            hideDocSide
                            leaveRoom={finallyCloseBookedEvent}
                            getProcessAndSetEventData={getAndSetPatientBookedEventDetails}
                            afterSaveFunction={() => {
                              if (newWantedMenuItemId === 'end') {
                                setSelectedPatientBookedEventId()
                                setPatientSelected(false)
                                setNewWantedMenuItemId()
                                setSelectedOptionPatientMenu()
                              } else {
                                setSelectedOptionPatientMenu(newWantedMenuItemId)
                              }
                            }}
                            showPatientDetailsInHeader
                          />
                        )}
                        {selectedOptionPatientMenu === 'assessment_report' && (
                          <AssessmentReportMakingPage
                            ref={assessmentReportRef}
                            propEventId={selectedPatientBookedEventData?.id}
                            propPatientId={selectedPatientId}
                            propClinicId={selectedPatientClinicId}
                            propClinicBrandId={selectedPatientClinicBrandId}
                            propMentorProfileData={mentorProfileData}
                            propBookedEventInfo={selectedPatientBookedEventData}
                            triggerSave={triggerSave}
                            setTriggerSave={setTriggerSave}
                            auxiliaryDataFromProps={auxiliaryData}
                            getProcessAndSetEventData={getAndSetPatientBookedEventDetails}
                            afterSaveFunction={() => {
                              if (newWantedMenuItemId === 'end') {
                                setSelectedPatientBookedEventId()
                                setPatientSelected(false)
                                setNewWantedMenuItemId()
                                setSelectedOptionPatientMenu()
                              } else {
                                setSelectedOptionPatientMenu(newWantedMenuItemId)
                              }
                            }}
                            chamberRoomId={serverGivenNextAction?.channel?.chamberRoomId}
                            showPatientDetailsInHeader
                          />
                        )}
                        {selectedOptionPatientMenu === 'screening_report' && (
                          <ScreeningReportMakingPage
                            ref={screeningReportRef}
                            propEventId={selectedPatientBookedEventData?.id}
                            propPatientId={selectedPatientId}
                            propClinicId={selectedPatientClinicId}
                            propBookedEventInfo={selectedPatientBookedEventData}
                            propMentorProfileData={mentorProfileData}
                            auxiliaryDataFromProps={auxiliaryData}
                            getProcessAndSetEventData={getAndSetPatientBookedEventDetails}
                            leaveRoom={finallyCloseBookedEvent}
                          />
                        )}
                        {selectedOptionPatientMenu === 'past_prescriptions' && (
                          <LSPastPrescriptionsComponent
                            patientId={selectedPatientId}
                          />
                        )}
                        {selectedOptionPatientMenu === 'patient_history' && (
                          <LSPastVisitReportsComponent
                            patientId={selectedPatientId}
                            referenceBookedEventId={selectedPatientBookedEventData?.id}
                            addTopMargins
                          />
                        )}
                        {selectedOptionPatientMenu === 'vitals' && (
                          <VitalsListingPage
                            patientId={selectedPatientId}
                            clinicId={selectedPatientClinicId}
                          />
                        )}
                        {selectedOptionPatientMenu === 'assessments' && (
                          <Box sx={{ p: 3, maxWidth: 480 }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                              Assessment tests
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                              Start or view assessment runs for this session. Use the drawer to select an assessment.
                            </Typography>
                            <Button
                              variant="contained"
                              onClick={() => setAssessmentDrawerOpen(true)}
                              startIcon={<AssignmentIcon />}
                            >
                              Open assessment drawer
                            </Button>
                          </Box>
                        )}
                      </div>
                    </PrescriptionDataProvider>
                  </div>
                )}
              </div>
            ) : (
              <>
                {/* <HotlineCalendarComponentForMentor
                forMentor={true}
                mentorId={mentorProfileData?.id}
                mentorProfileData={mentorProfileData}
                containerRefForAutoScrolling={refBox}
                thisClinicData={chosenClinicData}
                mentorClinicAssociationData={mentorClinicAssociationData}
                bookedSlotClickFunctionOverride={(data) => {
                  if (data?.status !== STATUS_SESSION_CANCELLED) {
                    markJoinOrLeaveSession(data?.id, 'JOIN', 'mentor')
                    setSelectedPatientBookedEventId(data?.id)
                    setPatientSelected(true)
                  }
                }}
              /> */}

                <DayViewCalendarComponent
                  ref={calendarRef}
                  forMentor={true}
                  bookingLisitingApiSignature={calendarBookingListingApiSignature}
                  mentorAuthorisedToSaveAndGetPatientsUsingIdb={getAllRolesInBoolean().isDoctor}
                  mentorId={mentorProfileData?.id}
                  mentorProfileData={mentorProfileData}
                  mentorClinicAssociationData={mentorClinicAssociationData}
                  meetingBookApiSignature="/api/secure/meeting/book"
                  listOfPaymentLinksApiSignature="/api/secure/teacher/booked-slots/user-payment-link/get"
                  publicBookingJoiningLinksApiSignature="/api/secure/teacher/booked-slots/video-session-tokens/get"
                  patientSearchApiSignature="/api/secure/mentor/patient/list"
                  cancelAppointmentApiSignature="/api/secure/teacher/booked-slots/cancel"
                  pastPatientBookingsApiSignature="/api/secure/teacher/booked-event-history-of-a-patient"
                  createPatientApiSignature="/api/secure/patient/new"
                  sendSecureSessionLinkToPatientSignature="/api/secure/teacher/booked-slots/secure-join-link/send"
                  sendPublicSessionLinkToPatientSignature="/api/secure/teacher/booked-slots/public-join-link/send"
                  getPrescriptionImagesApiSignature="/api/secure/mentor/emr-reports/prescription/images/get-by-eventId"
                  savePrescriptionImagesApiSignature="/api/secure/mentor/emr-reports/prescription/images/save"
                  fileUploadApiSignature="/api/secure/mentor/emr-reports/file/upload"
                  sendPrescriptionPdfApiSignature="/api/secure/teacher/doctor/prescription/generate/pdf"
                  headerContainerStyles={{ display: 'none', height: 0, padding: 0, margin: 0 }}
                  hidePatientContactDetails={hidePatientContactDetails}
                  // allProfessionalsDataForAssistant
                  thisClinicData={chosenClinicData}
                  currentView={selectedTab}
                  // setFetchDataTriggerForBookingRequests
                  // canPersonPrintPrescription
                  // chambersData
                  // assistantProfileInThisClinic
                  // LeftSideExtraComponent
                  // RightSideExtraComponent
                  containerRefForAutoScrolling={refBox}
                  bookedSlotClickFunctionOverride={async (data) => {
                    // Check if session is blocked (payment pending - slot held but not confirmed)
                    const isSessionBlocked =
                      data?.status === BOOKING_STATUSES.BOOKING_INITIATED &&
                      data?.paymentStatus === BOOKING_PAYMENT_STATUSES.PENDING
                    
                    // Prevent joining blocked sessions
                    if (isSessionBlocked) {
                      toast.warning('This session is awaiting payment confirmation and cannot be joined yet.')
                      return
                    }

                    if (
                      effectiveCalendarEventScope !== CALENDAR_EVENT_SCOPES.own &&
                      data?.eventType === allAvailableEventTypes.consultation &&
                      data?.mentorId !== mentorProfileData?.id
                    ) {
                      handleDoctorConsultationCalendarEventClick(data)
                      return
                    }
                    
                    if (data?.status !== STATUS_SESSION_CANCELLED) {
                      // Check if this is an offline event - offline events should open therapy report editing page, not join video call
                      const isOfflineEvent = data?.meetingSrc === 'offline'
                      
                      // Check if this is a video call event and join the video call channel
                      const isVideoCallEvent = 
                        data?.eventType === allAvailableEventTypes.consultation ||
                        data?.eventType === allAvailableEventTypes.therapySession ||
                        data?.eventType === allAvailableEventTypes.screening ||
                        data?.eventType === allAvailableEventTypes.assessment
                      
                      if (isVideoCallEvent && !isOfflineEvent) {
                        // Join the booked event's video call channel (only for online events)
                        await joinBookedEventVideoCall(data)
                      } else {
                        // Not a video call or is offline, use original behavior (opens therapy report editing page on split page)
                        markBookedEventLog(data?.id, 'JOIN', 'mentor')
                        setSelectedPatientBookedEventId(data?.id)
                        setPatientSelected(true)
                      }
                    }
                  }}
                  // emptySlotClickFunctionOverride={() => null}
                  // LeftSideExtraComponent={<CheckInInformationComponent />}
                  RightSideExtraComponent={
                    <CheckoutButtonComponent
                      text=" "
                      additionalFunctionBeforeAction={() => {
                        chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING &&
                          leaveThisSession()
                      }}
                      styleProp={{
                        width: '16px',
                        flexDirection: 'column',
                        borderRadius: '0px',
                        height: '100%',
                      }}
                      showExitButtonIfNotCheckedIn={true}
                    />
                  }
                  // minimalUI
                  // showBookingPopup={true}
                  useClinicAppointmentTypes={false}
                  clinicAppointmentTypesList={[]}
                  paymentLinkToSendViaQRCode={showPaymentQrToPatient}
                  eachSlotDurationInMins={eachSlotDurationInMins}
                  setEachSlotDurationInMins={setEachSlotDurationInMins}
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                  onBookedSlotsUpdate={handleCalendarBookedSlotsUpdate}
                />
              </>
            )}
          </Box>
        </HotlineChamberInteractionPart>
        </Box>

        {/* Booked Slots Drawer */}
        <BookedSlotsDrawer
          open={bookedSlotsDrawerOpen}
          onClose={() => setBookedSlotsDrawerOpen(false)}
          bookedSlotsInDay={bookedSlotsInDay}
          selectedDate={selectedDate}
          selectedClinic={chosenClinicData}
          mentorProfileData={mentorProfileData}
          forMentor={true}
          hidePatientContactDetails={hidePatientContactDetails}
        />

        {/* Patient Search Drawer */}
        <PatientSearchDrawer
          open={patientSearchOpen}
          onClose={() => setPatientSearchOpen(false)}
          onSelectPatient={(patient) => {
            setPatientSearchOpen(false)
            // You can add additional logic here if needed
          }}
          onBookAppointment={(patient) => {
            // Open the PC-style booking dialog pre-filled with this patient.
            setPatientSearchOpen(false)
            calendarRef.current?.openBookingWithPatient?.(patient)
          }}
          clinicId={chosenClinicData?.id}
          clinicBrandId={chosenClinicData?.clinicBrandId}
          mentorProfileData={mentorProfileData}
          searchPatientApiSignature="/api/secure/mentor/patient/list"
          createPatientApiSignature="/api/secure/patient/new"
        />

        {/* Calendar / Appointments bottom sheet (mobile). SwipeableDrawer + grab handle gives a
            native swipe-down-to-dismiss feel; opened from the pull-up peek or the header icon. */}
        {isMobile && (
          <SwipeableDrawer
            anchor="bottom"
            open={calendarDrawerOpen}
            onClose={() => setCalendarDrawerOpen(false)}
            onOpen={() => setCalendarDrawerOpen(true)}
            disableSwipeToOpen
            disableDiscovery
            PaperProps={{
              sx: {
                // Height follows content (short list = short sheet); caps at 88dvh and the body
                // scrolls beyond that.
                height: 'auto',
                maxHeight: '88dvh',
                borderTopLeftRadius: '24px',
                borderTopRightRadius: '24px',
                background: 'rgba(255, 255, 255, 0.98)',
                backdropFilter: 'blur(20px) saturate(180%)',
                WebkitBackdropFilter: 'blur(20px) saturate(180%)',
                display: 'flex',
                flexDirection: 'column',
              },
            }}
          >
            {/* Grab handle */}
            <Box sx={{ display: 'flex', justifyContent: 'center', pt: 1, pb: 0.5, flexShrink: 0 }}>
              <Box sx={{ width: 40, height: 4, borderRadius: 2, background: 'rgba(0, 0, 0, 0.18)' }} />
            </Box>

            {/* Header: title + refresh + close */}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, pt: 0.5, pb: 1.5, flexShrink: 0 }}>
              <Typography variant="h6" sx={{ fontWeight: 600, color: '#1f2937' }}>
                Appointments
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {/* Hidden native date input — opened by the calendar button below. Lets the user
                    jump the Upcoming tab to any date (past or future). */}
                <input
                  ref={appointmentsDateInputRef}
                  type="date"
                  aria-hidden="true"
                  tabIndex={-1}
                  style={{ position: 'absolute', width: 1, height: 1, opacity: 0, pointerEvents: 'none' }}
                  onChange={(e) => handlePickAppointmentDate(e.target.value)}
                />
                <IconButton
                  aria-label="Book appointment"
                  size="small"
                  onClick={() => {
                    // Open the same booking dialog the PC calendar uses (it has patient
                    // search/create inside). Falls back to patient search if the calendar
                    // (which hosts the dialog) isn't mounted.
                    const result = calendarRef.current?.openNewBookingDialog?.()
                    if (!result || result.opened === false) {
                      handleOpenPatientSearch()
                    }
                  }}
                  sx={{
                    color: '#6779e3',
                    backgroundColor: 'rgba(103, 121, 227, 0.1)',
                    border: '1px solid rgba(103, 121, 227, 0.2)',
                    '&:hover': { backgroundColor: 'rgba(103, 121, 227, 0.2)' },
                  }}
                >
                  <AddRoundedIcon sx={{ fontSize: 20 }} />
                </IconButton>
                <IconButton
                  aria-label="Pick a date"
                  size="small"
                  onClick={() => {
                    const el = appointmentsDateInputRef.current
                    if (!el) return
                    if (upcomingDate) {
                      el.value = dayjs(upcomingDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
                    }
                    if (typeof el.showPicker === 'function') {
                      el.showPicker()
                    } else {
                      el.click()
                    }
                  }}
                  sx={{
                    color: '#6779e3',
                    backgroundColor: 'rgba(103, 121, 227, 0.1)',
                    border: '1px solid rgba(103, 121, 227, 0.2)',
                    '&:hover': { backgroundColor: 'rgba(103, 121, 227, 0.2)' },
                  }}
                >
                  <CalendarMonthIcon sx={{ fontSize: 20 }} />
                </IconButton>
                <IconButton
                  aria-label="Search patients"
                  size="small"
                  onClick={handleOpenPatientSearch}
                  sx={{
                    color: '#6779e3',
                    backgroundColor: 'rgba(103, 121, 227, 0.1)',
                    border: '1px solid rgba(103, 121, 227, 0.2)',
                    '&:hover': { backgroundColor: 'rgba(103, 121, 227, 0.2)' },
                  }}
                >
                  <SearchIcon sx={{ fontSize: 20 }} />
                </IconButton>
                <IconButton
                  aria-label="Refresh appointments"
                  size="small"
                  onClick={() => {
                    loadAppointmentWindow()
                    if (appointmentsMode === 'picked') loadPickedDay(appointmentsDateKey)
                  }}
                  disabled={chamberAppointmentsLoading}
                  sx={{
                    color: '#6779e3',
                    backgroundColor: 'rgba(103, 121, 227, 0.1)',
                    border: '1px solid rgba(103, 121, 227, 0.2)',
                    '&:hover': { backgroundColor: 'rgba(103, 121, 227, 0.2)' },
                  }}
                >
                  {chamberAppointmentsLoading ? (
                    <CircularProgress size={16} sx={{ color: '#6779e3' }} />
                  ) : (
                    <RefreshIcon sx={{ fontSize: 20 }} />
                  )}
                </IconButton>
                <IconButton
                  aria-label="Close appointments"
                  size="small"
                  onClick={() => setCalendarDrawerOpen(false)}
                  sx={{ color: '#6779e3', '&:hover': { backgroundColor: 'rgba(103, 121, 227, 0.1)' } }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>

            {/* Yesterday / Today / Tomorrow segmented control (+ a dynamic picked-date tab when a
                date outside this range is chosen from the calendar). */}
            <Box
              sx={{
                display: 'flex',
                gap: '4px',
                mx: 2,
                mb: 1.5,
                p: '4px',
                borderRadius: '10px',
                background: 'rgba(103, 121, 227, 0.08)',
                flexShrink: 0,
              }}
            >
              {(appointmentsMode === 'picked'
                ? ['yesterday', 'today', 'tomorrow', 'picked']
                : ['yesterday', 'today', 'tomorrow']
              ).map((segId) => {
                const active = appointmentsMode === segId
                const isPicked = segId === 'picked'
                const mainLabel = isPicked
                  ? upcomingDate
                    ? dayjs(upcomingDate, 'DD-MM-YYYY').format('D MMM')
                    : 'Date'
                  : segId === 'yesterday'
                    ? 'Yesterday'
                    : segId === 'tomorrow'
                      ? 'Tomorrow'
                      : 'Today'
                const sub = isPicked && upcomingDate ? relativeDayLabel(upcomingDate) : null
                return (
                  <Box
                    key={segId}
                    role="button"
                    aria-label={mainLabel}
                    onClick={() => {
                      if (isPicked) {
                        // Re-tapping the picked date clears it back to Today.
                        setUpcomingDate(null)
                        setAppointmentsMode('today')
                        return
                      }
                      setUpcomingDate(null)
                      setAppointmentsMode(segId)
                    }}
                    sx={{
                      flex: 1,
                      minWidth: 0,
                      textAlign: 'center',
                      py: sub ? 0.5 : 0.75,
                      borderRadius: '8px',
                      cursor: 'pointer',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      lineHeight: 1.15,
                      fontSize: '13px',
                      fontWeight: active ? 600 : 500,
                      color: active ? '#6779e3' : 'rgba(31, 41, 55, 0.7)',
                      background: active ? '#ffffff' : 'transparent',
                      boxShadow: active ? '0 1px 3px rgba(0, 0, 0, 0.08)' : 'none',
                      transition: 'all 0.2s ease',
                    }}
                  >
                    <Box
                      component="span"
                      sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}
                    >
                      {mainLabel}
                    </Box>
                    {sub ? (
                      <Box component="span" sx={{ fontSize: '10px', fontWeight: 500, opacity: 0.7 }}>
                        {sub}
                      </Box>
                    ) : null}
                  </Box>
                )
              })}
            </Box>

            {/* Body — grows with content (the Paper is height:auto up to a max), scrolls when long.
                Cached days render instantly; a background refresh never blanks them to a spinner. */}
            <Box
              sx={{
                flex: '1 1 auto',
                minHeight: 0,
                overflowY: 'auto',
                overflowX: 'hidden',
                px: 2,
                pb: 'calc(env(safe-area-inset-bottom, 0px) + 16px)',
              }}
            >
              {patientSelected ? (
                <Box sx={{ p: 3, textAlign: 'center' }}>
                  <Typography variant="body2" color="text.secondary">
                    You&apos;re in a session. Finish or leave it to browse appointments.
                  </Typography>
                </Box>
              ) : displayedAppointments === undefined ? (
                chamberAppointmentsError ? (
                  <Box sx={{ p: 3, textAlign: 'center' }}>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                      Couldn&apos;t load appointments.
                    </Typography>
                    <Button
                      onClick={loadAppointmentWindow}
                      variant="outlined"
                      size="small"
                      sx={{ textTransform: 'none' }}
                    >
                      Retry
                    </Button>
                  </Box>
                ) : (
                  <Box sx={{ display: 'flex', justifyContent: 'center', py: 5 }}>
                    <CircularProgress size={28} sx={{ color: '#6779e3' }} />
                  </Box>
                )
              ) : displayedAppointments.length === 0 ? (
                <Box sx={{ p: 4, textAlign: 'center' }}>
                  <CalendarMonthIcon sx={{ fontSize: 36, color: 'rgba(103, 121, 227, 0.4)', mb: 1 }} />
                  <Typography variant="body2" color="text.secondary">
                    {appointmentsMode === 'today'
                      ? 'No appointments today.'
                      : appointmentsMode === 'yesterday'
                        ? 'No appointments yesterday.'
                        : appointmentsMode === 'tomorrow'
                          ? 'No appointments tomorrow.'
                          : upcomingDate
                            ? `No appointments on ${dayjs(upcomingDate, 'DD-MM-YYYY').format('D MMM YYYY')}.`
                            : 'No appointments.'}
                  </Typography>
                </Box>
              ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  {displayedAppointments.map((slot) => renderAppointmentCard(slot))}
                </Box>
              )}
            </Box>
          </SwipeableDrawer>
        )}


        {/* Notification Panel for clean message display */}
        <NotificationPanel />

        <Dialog
          open={shouldShowAutoConnectPauseDialog}
          onClose={() => setAutoConnectPauseDialogOpen(false)}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: '12px',
              overflow: 'hidden',
            },
          }}
        >
          <DialogTitle
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              pb: 1,
            }}
          >
            <PauseCircleOutlineIcon sx={{ color: '#b45309' }} />
            <Typography component="span" sx={{ fontSize: '18px', fontWeight: 700 }}>
              Auto-connect paused
            </Typography>
          </DialogTitle>
          <DialogContent sx={{ pt: 0 }}>
            <Typography variant="body2" sx={{ color: 'rgba(31, 41, 55, 0.84)', mb: 1.5 }}>
              You seemed away, so chamber auto-connect is paused. Incoming chamber calls will not
              auto-connect until this resumes.
            </Typography>
            <Typography variant="body2" sx={{ color: '#92400e', fontWeight: 700 }}>
              Auto-resume in {formatAutoConnectRemaining(autoConnectRemainingMs)}.
            </Typography>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button
              onClick={() => setAutoConnectPauseDialogOpen(false)}
              size="small"
              sx={{ textTransform: 'none' }}
            >
              Keep paused
            </Button>
            <Button
              onClick={() => handleResumeAutoConnect({ source: 'manual' })}
              size="small"
              variant="contained"
              sx={{ textTransform: 'none' }}
            >
              Resume now
            </Button>
          </DialogActions>
        </Dialog>
        
        {/* Report Preview / Print Drawer */}
        {selectedPatientBookedEventData && allowTherapyReport && (
          <Drawer
            anchor="right"
            open={reportPreviewDrawerOpen}
            onClose={() => setReportPreviewDrawerOpen(false)}
            PaperProps={{
              sx: {
                width: { xs: '100%', sm: '92%', md: '82%', lg: '74%', xl: '66%' },
                maxWidth: { xs: '100%', sm: '1200px', md: '1400px', lg: '1600px' },
                display: 'flex',
                flexDirection: 'column',
                background: '#f8fafc',
              },
            }}
          >
            <Box
              sx={{
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2,
                px: 2,
                py: 1.5,
                borderBottom: '1px solid rgba(148, 163, 184, 0.35)',
                background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.98) 0%, rgba(99, 102, 241, 0.98) 100%)',
                color: '#fff',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PreviewIcon sx={{ fontSize: 20 }} />
                <Typography sx={{ fontWeight: 700, fontSize: '16px' }}>
                  Report Preview / Print
                </Typography>
              </Box>
              <IconButton
                onClick={() => setReportPreviewDrawerOpen(false)}
                sx={{
                  color: '#fff',
                  backgroundColor: 'rgba(255, 255, 255, 0.14)',
                  border: '1px solid rgba(255, 255, 255, 0.22)',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.22)',
                  },
                }}
                size="small"
              >
                <CloseIcon sx={{ fontSize: 18 }} />
              </IconButton>
            </Box>
            <Box
              sx={{
                flex: 1,
                minHeight: 0,
                overflowY: 'auto',
                overflowX: 'hidden',
                p: { xs: 1.5, md: 3 },
              }}
            >
              <ReportPreviewComponent
                eventType={selectedPatientEventType}
                auxiliaryData={auxiliaryData}
                therapyReportRef={therapyReportRef}
                screeningReportRef={screeningReportRef}
                assessmentReportRef={assessmentReportRef}
                getProcessAndSetEventData={getAndSetPatientBookedEventDetails}
              />
            </Box>
          </Drawer>
        )}

        {/* Rx Drawer - Prescription Preview */}
        {selectedPatientBookedEventData && (
          <Drawer
            anchor="right"
            open={rxDrawerOpen}
            onClose={() => setRxDrawerOpen(false)}
            PaperProps={{
              sx: {
                width: { xs: '100%', sm: '90%', md: '80%', lg: '70%', xl: '60%' },
                maxWidth: { xs: '100%', sm: '1200px', md: '1400px', lg: '1600px' },
                display: 'flex',
                flexDirection: 'column',
              },
            }}
          >
            <Box sx={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%', width: '100%', minWidth: 0 }}>
              <PrescriptionDataProvider>
                <RXDrawerComponent
                  mentorProfileData={mentorProfileData}
                  auxiliaryData={auxiliaryData}
                  bookedEventData={selectedPatientBookedEventData}
                  prescriptionRef={prescriptionRef}
                  onClose={() => setRxDrawerOpen(false)}
                />
              </PrescriptionDataProvider>
            </Box>
          </Drawer>
        )}

        {/* Chamber-level patient-history drawer — opened from the dock's History button, uniform
            across report types. Reuses the visit-history component + swipe gallery (the gallery is
            triggered from this header via chamberHistoryGalleryRef). */}
        {selectedPatientId && (
          <Drawer
            anchor="right"
            open={chamberHistoryDrawerOpen}
            onClose={() => setChamberHistoryDrawerOpen(false)}
            sx={{ zIndex: 1900 }}
            PaperProps={{
              sx: {
                width: { xs: '100%', sm: '90%', md: '70%' },
                maxWidth: { sm: '920px' },
                display: 'flex',
                flexDirection: 'column',
              },
            }}
          >
            <Box
              sx={{
                position: 'sticky',
                top: 0,
                zIndex: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                px: 2,
                py: 1.25,
                background: 'linear-gradient(135deg, #f59e0b, #fbbf24)',
                color: '#fff',
              }}
            >
              <Typography sx={{ fontWeight: 700, fontSize: '16px' }}>Patient History</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
                <IconButton
                  aria-label="Open history gallery"
                  size="small"
                  sx={{ color: '#fff' }}
                  onClick={() => chamberHistoryGalleryRef.current?.open?.()}
                >
                  <CollectionsIcon />
                </IconButton>
                <IconButton
                  aria-label="Close history"
                  size="small"
                  sx={{ color: '#fff' }}
                  onClick={() => setChamberHistoryDrawerOpen(false)}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
            <Box sx={{ flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch', minHeight: 0 }}>
              {chamberHistoryDrawerOpen && (
                <LSPastVisitReportsComponent
                  patientId={selectedPatientId}
                  referenceBookedEventId={selectedPatientBookedEventData?.id}
                  addTopMargins
                  galleryControlRef={chamberHistoryGalleryRef}
                  hideInlineGalleryButton
                  galleryZIndex={2100}
                />
              )}
            </Box>
          </Drawer>
        )}

      </ScreeningSectionsProvider>
    </div>
  )
}

const UndecidedClinicIdUIComponent = () => {
  const { mentorProfileData, mentorClinicAssociationData } = useContext(MentorProfileContext)

  const navigate = useNavigate()
  return (
    <div style={{ maxWidth: '400px' }}>
      <div>Please select a clinic to remotely connect:</div>
      <div>
        {mentorClinicAssociationData?.map((clinicLoc, clinicLocIndex) => {
          return (
            <button
              className={`${'bg-light'} rounded m-1`}
              key={clinicLocIndex}
              onClick={() => navigate(`/mentor-home/join-chamber-room/${clinicLoc?.id}`)}
            >
              {clinicLoc?.title || clinicLoc?.name || clinicLoc?.firstName}
            </button>
          )
        })}
      </div>
      <div style={{ marginTop: '32px' }} onClick={() => navigate('/mentor-home')}>
        Exit
      </div>
    </div>
  )
}

export const NerdStatComponent = ({
  externalTrigger,
  resetOutsideTrigger,
  showTriggerButton = true,
  serverGivenNextAction,
}) => {
  const [open, setOpen] = useState(false)
  const [minimized, setMinimized] = useState(false)

  useEffect(() => {
    if (externalTrigger) {
      setOpen(true)
      setMinimized(false)
    }
  }, [externalTrigger])

  return (
    <div
      style={{
        position: 'relative',
        marginTop: 'auto',
        paddingTop: '16px',
        paddingLeft: '16px',
        zIndex: 1,
      }}
      className="hide-on-print-only"
    >
      {open ? (
        <div
          style={{
            width: minimized ? '188px' : 'min(420px, calc(100vw - 32px))',
            maxHeight: minimized ? 'auto' : 'min(420px, calc(100vh - 96px))',
            borderRadius: '16px',
            background: 'rgba(15, 23, 42, 0.86)',
            color: '#e2e8f0',
            padding: '10px',
            fontSize: '12px',
            border: '1px solid rgba(148, 163, 184, 0.2)',
            backdropFilter: 'blur(18px)',
            boxShadow: '0 20px 44px rgba(2, 6, 23, 0.38)',
            overflow: 'hidden',
          }}
        >
          <div
            onClick={() => setMinimized((prev) => !prev)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '12px',
              cursor: 'pointer',
              userSelect: 'none',
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
              <div style={{ fontWeight: 700, letterSpacing: '0.04em' }}>#Stats</div>
              <div style={{ fontSize: '11px', color: 'rgba(226, 232, 240, 0.72)' }}>
                {minimized ? 'Tap to restore' : 'Tap header to minimize'}
              </div>
            </div>
            <div
              style={{
                fontSize: '11px',
                fontWeight: 700,
                color: '#bfdbfe',
                padding: '4px 8px',
                borderRadius: '999px',
                background: 'rgba(59, 130, 246, 0.16)',
              }}
            >
              {minimized ? 'SHOW' : 'HIDE'}
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: minimized ? '8px' : '12px',
              marginBottom: minimized ? '0' : '16px',
            }}
          >
            <div
              style={{
                cursor: 'pointer',
                fontSize: '11px',
                color: 'rgba(226, 232, 240, 0.74)',
              }}
              onClick={() =>
                setOpen(() => {
                  if (resetOutsideTrigger) {
                    resetOutsideTrigger()
                  }
                  return false
                })
              }
            >
              close
            </div>
          </div>
          {!minimized ? (
            <div
              style={{
                display: 'grid',
                gap: '8px',
                maxHeight: '320px',
                overflowY: 'auto',
                paddingRight: '4px',
              }}
            >
              <div>Last action UTC: {serverGivenNextAction?.chamberScreenAction?.createdTime}</div>
              <div>Action: {serverGivenNextAction?.chamberScreenAction?.action}</div>
              <div>ChamberLastPresent UTC: {serverGivenNextAction?.channel?.chamberLastPresent}</div>
              <div>ChamberRoomId: {serverGivenNextAction?.channel?.chamberRoomId}</div>
              <div>ChamberRoomName: {serverGivenNextAction?.channel?.chamberRoomName}</div>
              <div>ChannelId: {serverGivenNextAction?.channel?.id}</div>
              <div>MentorId: {serverGivenNextAction?.channel?.mentorId}</div>
              <div>MentorLastPresent UTC: {serverGivenNextAction?.channel?.mentorLastPresent}</div>
              <div>MentorName: {serverGivenNextAction?.channel?.mentorName}</div>
            </div>
          ) : null}
        </div>
      ) : (
        showTriggerButton && (
          <div
            style={{
              height: '24px',
              width: '24px',
              borderRadius: '50%',
              background: 'rgba(0,0,0,0.2)',
              color: '#fff',
              position: 'absolute',
              // top: '16px',
              left: '16px',
              bottom: '16px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
              zIndex: '9999',
            }}
            onClick={() => setOpen((prev) => !prev)}
          >
            i
          </div>
        )
      )}
    </div>
  )
}
